'use strict';

runBlock.$inject = ["$rootScope", "AppSettings", "$mdSidenav", "ConfigurationsTable"];
routesConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
editQuotaPriceModal.$inject = ["$mdDialog"];
editQuotaPriceModalDialog.$inject = ["$scope", "$mdDialog", "$mdToast", "type"];
Service.$inject = ["$mdDialog"];
DialogController.$inject = ["$scope", "$mdDialog", "payment", "$mdToast"];
var cov_zy8jmpdqc = function () {
    var path = '/home/lobo/repos/coliseu-app/src/index.js',
        hash = '9d65d52df15340007d424b990b0e31f4842ead95',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/index.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 33,
                    column: 19
                }
            },
            '1': {
                start: {
                    line: 38,
                    column: 4
                },
                end: {
                    line: 38,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 41,
                    column: 4
                },
                end: {
                    line: 43,
                    column: 6
                }
            },
            '3': {
                start: {
                    line: 42,
                    column: 8
                },
                end: {
                    line: 42,
                    column: 41
                }
            },
            '4': {
                start: {
                    line: 45,
                    column: 4
                },
                end: {
                    line: 47,
                    column: 6
                }
            },
            '5': {
                start: {
                    line: 46,
                    column: 8
                },
                end: {
                    line: 46,
                    column: 42
                }
            },
            '6': {
                start: {
                    line: 49,
                    column: 4
                },
                end: {
                    line: 51,
                    column: 5
                }
            },
            '7': {
                start: {
                    line: 50,
                    column: 1
                },
                end: {
                    line: 50,
                    column: 83
                }
            },
            '8': {
                start: {
                    line: 53,
                    column: 4
                },
                end: {
                    line: 53,
                    column: 32
                }
            }
        },
        fnMap: {
            '0': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 37,
                        column: 9
                    },
                    end: {
                        line: 37,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 76
                    },
                    end: {
                        line: 54,
                        column: 1
                    }
                },
                line: 37
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 41,
                        column: 29
                    },
                    end: {
                        line: 41,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 41,
                        column: 41
                    },
                    end: {
                        line: 43,
                        column: 5
                    }
                },
                line: 41
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 45,
                        column: 30
                    },
                    end: {
                        line: 45,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 42
                    },
                    end: {
                        line: 47,
                        column: 5
                    }
                },
                line: 45
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 49,
                        column: 32
                    },
                    end: {
                        line: 49,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 49,
                        column: 44
                    },
                    end: {
                        line: 51,
                        column: 5
                    }
                },
                line: 49
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_zy8jmpdqc.s[0]++;
angular.module('app', ['ui.router', 'restmod', 'restmod.styles.drfPaged', 'ngMaterial', 'satellizer', 'ngFileUpload', 'cgBusy', 'angularMoment', 'angular-loading-bar', 'timer', 'ui.mask', 'angular.filter', 'mdPickers', 'ui.tinymce', 'angular-click-outside', 'duScroll', 'app.notfound']).constant('moment', moment).constant('AppSettings', {
    appInProduction: false,
    appUrl: 'https://coliseu.soloweb.pt',
    apiUrl: 'https://api.coliseu.soloweb.pt',
    siteUrl: 'https://site.coliseu.soloweb.pt',
    mediaUrl: 'https://api.coliseu.soloweb.pt/static/media'
}).value('cgBusyDefaults', {
    message: '',
    templateUrl: 'app/shared/html/cgbusy/cgbusy.template.html'
}).run(runBlock);

/** @ngInject */
function runBlock($rootScope, AppSettings, $mdSidenav, ConfigurationsTable) {
    cov_zy8jmpdqc.f[0]++;
    cov_zy8jmpdqc.s[1]++;

    $rootScope.AppSettings = AppSettings;

    cov_zy8jmpdqc.s[2]++;
    $rootScope.openSidebar = function () {
        cov_zy8jmpdqc.f[1]++;
        cov_zy8jmpdqc.s[3]++;

        return $mdSidenav('menu').open();
    };

    cov_zy8jmpdqc.s[4]++;
    $rootScope.closeSidebar = function () {
        cov_zy8jmpdqc.f[2]++;
        cov_zy8jmpdqc.s[5]++;

        return $mdSidenav('menu').close();
    };

    cov_zy8jmpdqc.s[6]++;
    $rootScope.initStaticData = function () {
        cov_zy8jmpdqc.f[3]++;
        cov_zy8jmpdqc.s[7]++;

        $rootScope.ENABLE_REPORTS_VIEW = ConfigurationsTable.$find('ENABLE_REPORTS_VIEW');
    };

    cov_zy8jmpdqc.s[8]++;
    $rootScope.initStaticData();
}
'use strict';

var cov_1b056emtsi = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/modalServices/generateQuotas.service.js',
        hash = '9d87256155dda33754ef8d24f0f94ac4b8006b2d',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/modalServices/generateQuotas.service.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 34,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 49
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 24
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 27
                },
                end: {
                    line: 13,
                    column: 57
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 12
                },
                end: {
                    line: 24,
                    column: 15
                }
            },
            '5': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 31
                }
            },
            '6': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 9
                }
            },
            '7': {
                start: {
                    line: 31,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 29
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 34,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Service',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 45
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'show',
                decl: {
                    start: {
                        line: 12,
                        column: 17
                    },
                    end: {
                        line: 12,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 30
                    },
                    end: {
                        line: 25,
                        column: 9
                    }
                },
                line: 12
            },
            '3': {
                name: 'DialogController',
                decl: {
                    start: {
                        line: 28,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 57
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                line: 28
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 30,
                        column: 29
                    },
                    end: {
                        line: 30,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 41
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 30
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1b056emtsi.s[0]++;
(function () {
    'use strict';

    Service.$inject = ["$mdDialog", "QuotasTable"];
    DialogController.$inject = ["$scope", "$mdDialog", "member"];
    cov_1b056emtsi.f[0]++;
    cov_1b056emtsi.s[1]++;
    angular.module('app').service('GenerateQuotasModal', Service);

    /* @ngInject */
    function Service($mdDialog, QuotasTable) {
        cov_1b056emtsi.f[1]++;
        cov_1b056emtsi.s[2]++;

        this.show = show;

        function show(member) {
            cov_1b056emtsi.f[2]++;

            var parentEl = (cov_1b056emtsi.s[3]++, angular.element(document.body));
            cov_1b056emtsi.s[4]++;
            return $mdDialog.show({
                parent: parentEl,
                template: '<md-dialog aria-label="List dialog" style="min-width: 400px">' + '  <md-dialog-content>' + '    <generate-quotas-input member="member"/>' + '  </md-dialog-content>' + '</md-dialog>',
                locals: { member: member },
                controller: DialogController
            });
        }
    }

    function DialogController($scope, $mdDialog, member) {
        cov_1b056emtsi.f[3]++;
        cov_1b056emtsi.s[5]++;

        $scope.member = member;
        cov_1b056emtsi.s[6]++;
        $scope.closeDialog = function () {
            cov_1b056emtsi.f[4]++;
            cov_1b056emtsi.s[7]++;

            $mdDialog.hide();
        };
    }
})();
'use strict';

var cov_21c48ofydr = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/media/media.table.factory.js',
        hash = '5f605dcfc25cdf9bf38188ab46724b24082fa05c',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/media/media.table.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 13,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 67
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 13,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_21c48ofydr.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_21c48ofydr.f[0]++;
    cov_21c48ofydr.s[1]++;
    angular.module('app').factory('MediaTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_21c48ofydr.f[1]++;
        cov_21c48ofydr.s[2]++;


        return restmod.model('/media').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_2bwr2yui7c = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/media/media.service.js',
        hash = '67e1e1d1234631e8a0549c9324ecd79b725507c9',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/media/media.service.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 42
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 13,
                    column: 74
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 13
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 22,
                    column: 20
                },
                end: {
                    line: 22,
                    column: 42
                }
            },
            '7': {
                start: {
                    line: 24,
                    column: 20
                },
                end: {
                    line: 24,
                    column: 71
                }
            },
            '8': {
                start: {
                    line: 25,
                    column: 20
                },
                end: {
                    line: 25,
                    column: 37
                }
            },
            '9': {
                start: {
                    line: 27,
                    column: 45
                },
                end: {
                    line: 27,
                    column: 85
                }
            },
            '10': {
                start: {
                    line: 28,
                    column: 20
                },
                end: {
                    line: 28,
                    column: 90
                }
            },
            '11': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 60
                }
            },
            '12': {
                start: {
                    line: 32,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 33
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 36,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Service',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 52
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'upload',
                decl: {
                    start: {
                        line: 12,
                        column: 17
                    },
                    end: {
                        line: 12,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 30
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 21,
                        column: 24
                    },
                    end: {
                        line: 21,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 40
                    },
                    end: {
                        line: 23,
                        column: 17
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 23,
                        column: 19
                    },
                    end: {
                        line: 23,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 31
                    },
                    end: {
                        line: 26,
                        column: 17
                    }
                },
                line: 23
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 26,
                        column: 19
                    },
                    end: {
                        line: 26,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 34
                    },
                    end: {
                        line: 29,
                        column: 17
                    }
                },
                line: 26
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                }, {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                }],
                line: 15
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2bwr2yui7c.s[0]++;
(function () {
    'use strict';

    Service.$inject = ["Upload", "AppSettings", "$mdToast"];
    cov_2bwr2yui7c.f[0]++;
    cov_2bwr2yui7c.s[1]++;
    angular.module('app').service('MediaService', Service);

    /* @ngInject */
    function Service(Upload, AppSettings, $mdToast) {
        cov_2bwr2yui7c.f[1]++;
        cov_2bwr2yui7c.s[2]++;

        this.upload = upload;

        function upload(file) {
            cov_2bwr2yui7c.f[2]++;
            cov_2bwr2yui7c.s[3]++;

            $mdToast.show($mdToast.simple().textContent('Uploading ...'));

            cov_2bwr2yui7c.s[4]++;
            if (file) {
                cov_2bwr2yui7c.b[0][0]++;
                cov_2bwr2yui7c.s[5]++;

                return Upload.upload({
                    url: AppSettings.apiUrl + '/media/',
                    data: {
                        'file': file
                    }
                }).then(function (data) {
                    cov_2bwr2yui7c.f[3]++;
                    cov_2bwr2yui7c.s[6]++;

                    return data.data.file;
                }, function () {
                    cov_2bwr2yui7c.f[4]++;
                    cov_2bwr2yui7c.s[7]++;

                    $mdToast.updateTextContent('An error has ocurred');
                    cov_2bwr2yui7c.s[8]++;
                    return undefined;
                }, function (evt) {
                    cov_2bwr2yui7c.f[5]++;

                    var progressPercentage = (cov_2bwr2yui7c.s[9]++, parseInt(100.0 * evt.loaded / evt.total));
                    cov_2bwr2yui7c.s[10]++;
                    $mdToast.updateTextContent('Uploading (' + progressPercentage + '%)');
                });
            } else {
                cov_2bwr2yui7c.b[0][1]++;
                cov_2bwr2yui7c.s[11]++;

                $mdToast.updateTextContent('Invalid file!');
                cov_2bwr2yui7c.s[12]++;
                return undefined;
            }
        }
    }
})();
'use strict';

var cov_678y5pbgd = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/media/media.run.js',
        hash = 'a05cc37ea0ff1957e2c2a819e80c88cfd4d0926e',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/media/media.run.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 3,
                    column: 4
                },
                end: {
                    line: 5,
                    column: 23
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 41
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 8,
                        column: 13
                    },
                    end: {
                        line: 8,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 48
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 8
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_678y5pbgd.s[0]++;
(function () {
    'use strict';

    runBlock.$inject = ["$rootScope", "MediaService"];
    cov_678y5pbgd.f[0]++;
    cov_678y5pbgd.s[1]++;
    angular.module('app').run(runBlock);

    /* @ngInject */
    function runBlock($rootScope, MediaService) {
        cov_678y5pbgd.f[1]++;
        cov_678y5pbgd.s[2]++;

        $rootScope.$Media = MediaService;
    }
})();
'use strict';

var cov_1tylfkqa5t = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/media/media.filter.js',
        hash = 'bba04fd877a9025e68bc1e46de729e6ecb7ea7d0',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/media/media.filter.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 18,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 38
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 15,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 12,
                    column: 58
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 14,
                    column: 28
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 18,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'MediaUrl',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1tylfkqa5t.s[0]++;
(function () {
    'use strict';

    MediaUrl.$inject = ["AppSettings"];
    cov_1tylfkqa5t.f[0]++;
    cov_1tylfkqa5t.s[1]++;
    angular.module('app').filter('mediaUrl', MediaUrl);

    /* @ngInject */
    function MediaUrl(AppSettings) {
        cov_1tylfkqa5t.f[1]++;
        cov_1tylfkqa5t.s[2]++;

        return function (input) {
            cov_1tylfkqa5t.f[2]++;
            cov_1tylfkqa5t.s[3]++;

            if (input) {
                cov_1tylfkqa5t.b[0][0]++;
                cov_1tylfkqa5t.s[4]++;

                return AppSettings.mediaUrl + '/' + input;
            } else {
                cov_1tylfkqa5t.b[0][1]++;
                cov_1tylfkqa5t.s[5]++;

                return null;
            }
        };
    }
})();
'use strict';

var cov_1hz5221yg0 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/media/media.directive.js',
        hash = '6b52a0b50ab3bc771a021f05b0cd2f526dff725a',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/media/media.directive.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 29
                },
                end: {
                    line: 13,
                    column: 55
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 29
                },
                end: {
                    line: 14,
                    column: 42
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 29
                },
                end: {
                    line: 15,
                    column: 34
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 18,
                    column: 31
                },
                end: {
                    line: 18,
                    column: 45
                }
            },
            '8': {
                start: {
                    line: 19,
                    column: 20
                },
                end: {
                    line: 31,
                    column: 21
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 38
                },
                end: {
                    line: 24,
                    column: 70
                }
            },
            '10': {
                start: {
                    line: 25,
                    column: 24
                },
                end: {
                    line: 25,
                    column: 48
                }
            },
            '11': {
                start: {
                    line: 26,
                    column: 24
                },
                end: {
                    line: 30,
                    column: 27
                }
            },
            '12': {
                start: {
                    line: 27,
                    column: 28
                },
                end: {
                    line: 27,
                    column: 49
                }
            },
            '13': {
                start: {
                    line: 29,
                    column: 28
                },
                end: {
                    line: 29,
                    column: 49
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 36,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'MediaDirective',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 36
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 18
                    },
                    end: {
                        line: 12,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 56
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 17,
                        column: 50
                    },
                    end: {
                        line: 17,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 62
                    },
                    end: {
                        line: 32,
                        column: 17
                    }
                },
                line: 17
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 26,
                        column: 37
                    },
                    end: {
                        line: 26,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 53
                    },
                    end: {
                        line: 28,
                        column: 25
                    }
                },
                line: 26
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 28,
                        column: 27
                    },
                    end: {
                        line: 28,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 43
                    },
                    end: {
                        line: 30,
                        column: 25
                    }
                },
                line: 28
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                }, {
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                }],
                line: 19
            },
            '1': {
                loc: {
                    start: {
                        line: 20,
                        column: 24
                    },
                    end: {
                        line: 22,
                        column: 70
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 20,
                        column: 24
                    },
                    end: {
                        line: 20,
                        column: 28
                    }
                }, {
                    start: {
                        line: 21,
                        column: 24
                    },
                    end: {
                        line: 21,
                        column: 47
                    }
                }, {
                    start: {
                        line: 22,
                        column: 25
                    },
                    end: {
                        line: 22,
                        column: 45
                    }
                }, {
                    start: {
                        line: 22,
                        column: 49
                    },
                    end: {
                        line: 22,
                        column: 69
                    }
                }],
                line: 20
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0, 0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

cov_1hz5221yg0.s[0]++;
(function () {
    'use strict';

    MediaDirective.$inject = ["$parse"];
    cov_1hz5221yg0.f[0]++;
    cov_1hz5221yg0.s[1]++;
    angular.module('app').directive('mediaAutoUpload', MediaDirective);

    /* @ngInject */
    function MediaDirective($parse) {
        cov_1hz5221yg0.f[1]++;
        cov_1hz5221yg0.s[2]++;

        return {
            require: '?ngModel',
            link: function link(scope, element, attributes) {
                cov_1hz5221yg0.f[2]++;

                var getter = (cov_1hz5221yg0.s[3]++, $parse(attributes.ngModel));
                var setter = (cov_1hz5221yg0.s[4]++, getter.assign);
                var $scope = (cov_1hz5221yg0.s[5]++, scope);

                cov_1hz5221yg0.s[6]++;
                $scope.$watch(attributes.ngModel, function () {
                    cov_1hz5221yg0.f[3]++;

                    var file = (cov_1hz5221yg0.s[7]++, getter($scope));
                    cov_1hz5221yg0.s[8]++;
                    if ((cov_1hz5221yg0.b[1][0]++, file) && (cov_1hz5221yg0.b[1][1]++, (typeof file === 'undefined' ? 'undefined' : _typeof(file)) == 'object') && ((cov_1hz5221yg0.b[1][2]++, file instanceof File) || (cov_1hz5221yg0.b[1][3]++, file instanceof Blob))) {
                        cov_1hz5221yg0.b[0][0]++;

                        var promise = (cov_1hz5221yg0.s[9]++, $scope.$root.$Media.upload(file));
                        cov_1hz5221yg0.s[10]++;
                        setter($scope, promise);
                        cov_1hz5221yg0.s[11]++;
                        promise.then(function (data) {
                            cov_1hz5221yg0.f[4]++;
                            cov_1hz5221yg0.s[12]++;

                            setter($scope, data);
                        }, function (data) {
                            cov_1hz5221yg0.f[5]++;
                            cov_1hz5221yg0.s[13]++;

                            setter($scope, data);
                        });
                    } else {
                        cov_1hz5221yg0.b[0][1]++;
                    }
                });
            }
        };
    }
})();
'use strict';

var cov_4h8ruyyb7 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.users.factory.js',
        hash = 'ab98678fea8d19ef43bc1b2c7dd0b3b46968dbee',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.users.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 84,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 82,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 14,
                    column: 20
                },
                end: {
                    line: 16,
                    column: 21
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 24
                },
                end: {
                    line: 15,
                    column: 46
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 20
                },
                end: {
                    line: 17,
                    column: 32
                }
            },
            '6': {
                start: {
                    line: 20,
                    column: 20
                },
                end: {
                    line: 20,
                    column: 61
                }
            },
            '7': {
                start: {
                    line: 25,
                    column: 20
                },
                end: {
                    line: 25,
                    column: 39
                }
            },
            '8': {
                start: {
                    line: 26,
                    column: 20
                },
                end: {
                    line: 26,
                    column: 41
                }
            },
            '9': {
                start: {
                    line: 27,
                    column: 20
                },
                end: {
                    line: 31,
                    column: 21
                }
            },
            '10': {
                start: {
                    line: 28,
                    column: 24
                },
                end: {
                    line: 28,
                    column: 37
                }
            },
            '11': {
                start: {
                    line: 30,
                    column: 24
                },
                end: {
                    line: 30,
                    column: 36
                }
            },
            '12': {
                start: {
                    line: 36,
                    column: 20
                },
                end: {
                    line: 36,
                    column: 59
                }
            },
            '13': {
                start: {
                    line: 39,
                    column: 20
                },
                end: {
                    line: 39,
                    column: 61
                }
            },
            '14': {
                start: {
                    line: 44,
                    column: 20
                },
                end: {
                    line: 44,
                    column: 59
                }
            },
            '15': {
                start: {
                    line: 47,
                    column: 20
                },
                end: {
                    line: 47,
                    column: 61
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 84,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 83,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 13,
                        column: 24
                    },
                    end: {
                        line: 13,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 41
                    },
                    end: {
                        line: 18,
                        column: 17
                    }
                },
                line: 13
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 19,
                        column: 24
                    },
                    end: {
                        line: 19,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 19,
                        column: 41
                    },
                    end: {
                        line: 21,
                        column: 17
                    }
                },
                line: 19
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 24,
                        column: 24
                    },
                    end: {
                        line: 24,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 41
                    },
                    end: {
                        line: 32,
                        column: 17
                    }
                },
                line: 24
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 35,
                        column: 24
                    },
                    end: {
                        line: 35,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 41
                    },
                    end: {
                        line: 37,
                        column: 17
                    }
                },
                line: 35
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 38,
                        column: 24
                    },
                    end: {
                        line: 38,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 38,
                        column: 41
                    },
                    end: {
                        line: 40,
                        column: 17
                    }
                },
                line: 38
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 43,
                        column: 24
                    },
                    end: {
                        line: 43,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 43,
                        column: 41
                    },
                    end: {
                        line: 45,
                        column: 17
                    }
                },
                line: 43
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 46,
                        column: 24
                    },
                    end: {
                        line: 46,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 41
                    },
                    end: {
                        line: 48,
                        column: 17
                    }
                },
                line: 46
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 14,
                        column: 20
                    },
                    end: {
                        line: 16,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 14,
                        column: 20
                    },
                    end: {
                        line: 16,
                        column: 21
                    }
                }, {
                    start: {
                        line: 14,
                        column: 20
                    },
                    end: {
                        line: 16,
                        column: 21
                    }
                }],
                line: 14
            },
            '1': {
                loc: {
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                }, {
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                }],
                line: 27
            },
            '2': {
                loc: {
                    start: {
                        line: 36,
                        column: 27
                    },
                    end: {
                        line: 36,
                        column: 59
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 36,
                        column: 37
                    },
                    end: {
                        line: 36,
                        column: 52
                    }
                }, {
                    start: {
                        line: 36,
                        column: 55
                    },
                    end: {
                        line: 36,
                        column: 59
                    }
                }],
                line: 36
            },
            '3': {
                loc: {
                    start: {
                        line: 44,
                        column: 27
                    },
                    end: {
                        line: 44,
                        column: 59
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 44,
                        column: 37
                    },
                    end: {
                        line: 44,
                        column: 52
                    }
                }, {
                    start: {
                        line: 44,
                        column: 55
                    },
                    end: {
                        line: 44,
                        column: 59
                    }
                }],
                line: 44
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_4h8ruyyb7.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_4h8ruyyb7.f[0]++;
    cov_4h8ruyyb7.s[1]++;
    angular.module('app').factory('UsersTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_4h8ruyyb7.f[1]++;
        cov_4h8ruyyb7.s[2]++;


        return restmod.model('/users').mix('MixinContainable', {
            birthday: {
                decode: function decode(value) {
                    cov_4h8ruyyb7.f[2]++;
                    cov_4h8ruyyb7.s[3]++;

                    if (value) {
                        cov_4h8ruyyb7.b[0][0]++;
                        cov_4h8ruyyb7.s[4]++;

                        return new Date(value);
                    } else {
                        cov_4h8ruyyb7.b[0][1]++;
                    }
                    cov_4h8ruyyb7.s[5]++;
                    return null;
                },
                encode: function encode(value) {
                    cov_4h8ruyyb7.f[3]++;
                    cov_4h8ruyyb7.s[6]++;

                    return moment(value).format('YYYY-MM-DD');
                }
            },
            memberId: {
                encode: function encode(value) {
                    cov_4h8ruyyb7.f[4]++;
                    cov_4h8ruyyb7.s[7]++;

                    value = value + '';
                    cov_4h8ruyyb7.s[8]++;
                    value = value.trim();
                    cov_4h8ruyyb7.s[9]++;
                    if (value) {
                        cov_4h8ruyyb7.b[1][0]++;
                        cov_4h8ruyyb7.s[10]++;

                        return value;
                    } else {
                        cov_4h8ruyyb7.b[1][1]++;
                        cov_4h8ruyyb7.s[11]++;

                        return null;
                    }
                }
            },
            admissionDate: {
                decode: function decode(value) {
                    cov_4h8ruyyb7.f[5]++;
                    cov_4h8ruyyb7.s[12]++;

                    return value ? (cov_4h8ruyyb7.b[2][0]++, new Date(value)) : (cov_4h8ruyyb7.b[2][1]++, null);
                },
                encode: function encode(value) {
                    cov_4h8ruyyb7.f[6]++;
                    cov_4h8ruyyb7.s[13]++;

                    return moment(value).format('YYYY-MM-DD');
                }
            },
            demissionDate: {
                decode: function decode(value) {
                    cov_4h8ruyyb7.f[7]++;
                    cov_4h8ruyyb7.s[14]++;

                    return value ? (cov_4h8ruyyb7.b[3][0]++, new Date(value)) : (cov_4h8ruyyb7.b[3][1]++, null);
                },
                encode: function encode(value) {
                    cov_4h8ruyyb7.f[8]++;
                    cov_4h8ruyyb7.s[15]++;

                    return moment(value).format('YYYY-MM-DD');
                }
            },
            $config: {
                contains: {
                    quotas: {
                        type: 'hasMany',
                        table: 'QuotasTable',
                        foreignKey: 'user',
                        filters: {
                            ordering: '-year,-month',
                            page_size: 25
                        }
                    },
                    gems: {
                        type: 'hasMany',
                        table: 'GemsTable',
                        foreignKey: 'user'
                    },
                    orders: {
                        type: 'hasMany',
                        table: 'OrdersTable',
                        foreignKey: 'user',
                        filters: {
                            ordering: '-created',
                            page_size: 25
                        }
                    },
                    userType: {
                        type: 'belongsTo',
                        table: 'UserTypesTable',
                        foreignKey: 'type'
                    }
                }
            }
        }).mix('DirtyModel');
    }
})();
'use strict';

var cov_9y21pff9w = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.userTypes.factory.js',
        hash = '353b65f884d94496bf9ae603e808741821471104',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.userTypes.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 23,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_9y21pff9w.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_9y21pff9w.f[0]++;
    cov_9y21pff9w.s[1]++;
    angular.module('app').factory('UserTypesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_9y21pff9w.f[1]++;
        cov_9y21pff9w.s[2]++;


        return restmod.model('/user-types').mix('MixinContainable', {
            $config: {
                contains: {
                    currentPrice: {
                        type: 'belongsTo',
                        table: 'UserTypePricesTable',
                        foreignKey: 'currentUserTypePrice'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_ctbapc0zs = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.userTypePrices.factory.js',
        hash = 'fd53543d8e05f606816a4ec28d82d93dca5814ca',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.userTypePrices.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 23,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_ctbapc0zs.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_ctbapc0zs.f[0]++;
    cov_ctbapc0zs.s[1]++;
    angular.module('app').factory('UserTypePricesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_ctbapc0zs.f[1]++;
        cov_ctbapc0zs.s[2]++;


        return restmod.model('/user-type-prices').mix('MixinContainable', {
            $config: {
                contains: {
                    userType: {
                        type: 'belongsTo',
                        table: 'UserTypesTable',
                        foreignKey: 'userType'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_2ji14k4cue = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.userInterests.factory.js',
        hash = 'ddfcb45d0b0b53c02190c2fca2c6841fccc92871',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.userInterests.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 13,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 55
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 76
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 13,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2ji14k4cue.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2ji14k4cue.f[0]++;
    cov_2ji14k4cue.s[1]++;
    angular.module('app').factory('UserInterestsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2ji14k4cue.f[1]++;
        cov_2ji14k4cue.s[2]++;


        return restmod.model('/user-interests').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_1znmqmevw4 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.sendemail.factory.js',
        hash = 'c6e19a49aaedeac3f64abc6adbbc453dde4df68a',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.sendemail.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 14,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 14,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1znmqmevw4.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1znmqmevw4.f[0]++;
    cov_1znmqmevw4.s[1]++;
    angular.module('app').factory('SendemailTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1znmqmevw4.f[1]++;
        cov_1znmqmevw4.s[2]++;


        return restmod.model('/send-mail').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_1glj2h5u51 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.reports.js',
        hash = 'd84361e42bdcfc66d2872d0397ac090f152aab96',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.reports.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 29,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 49
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 1
                },
                end: {
                    line: 27,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 20
                },
                end: {
                    line: 13,
                    column: 60
                }
            },
            '4': {
                start: {
                    line: 16,
                    column: 20
                },
                end: {
                    line: 16,
                    column: 62
                }
            },
            '5': {
                start: {
                    line: 21,
                    column: 20
                },
                end: {
                    line: 21,
                    column: 60
                }
            },
            '6': {
                start: {
                    line: 24,
                    column: 20
                },
                end: {
                    line: 24,
                    column: 62
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 29,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 24
                    },
                    end: {
                        line: 12,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 41
                    },
                    end: {
                        line: 14,
                        column: 17
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 15,
                        column: 24
                    },
                    end: {
                        line: 15,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 41
                    },
                    end: {
                        line: 17,
                        column: 17
                    }
                },
                line: 15
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 20,
                        column: 24
                    },
                    end: {
                        line: 20,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 41
                    },
                    end: {
                        line: 22,
                        column: 17
                    }
                },
                line: 20
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 23,
                        column: 24
                    },
                    end: {
                        line: 23,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 41
                    },
                    end: {
                        line: 25,
                        column: 17
                    }
                },
                line: 23
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 13,
                        column: 27
                    },
                    end: {
                        line: 13,
                        column: 59
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 13,
                        column: 37
                    },
                    end: {
                        line: 13,
                        column: 52
                    }
                }, {
                    start: {
                        line: 13,
                        column: 55
                    },
                    end: {
                        line: 13,
                        column: 59
                    }
                }],
                line: 13
            },
            '1': {
                loc: {
                    start: {
                        line: 21,
                        column: 27
                    },
                    end: {
                        line: 21,
                        column: 59
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 21,
                        column: 37
                    },
                    end: {
                        line: 21,
                        column: 52
                    }
                }, {
                    start: {
                        line: 21,
                        column: 55
                    },
                    end: {
                        line: 21,
                        column: 59
                    }
                }],
                line: 21
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1glj2h5u51.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1glj2h5u51.f[0]++;
    cov_1glj2h5u51.s[1]++;
    angular.module('app').factory('ReportsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1glj2h5u51.f[1]++;
        cov_1glj2h5u51.s[2]++;

        return restmod.model('/reports').mix('MixinContainable', {
            start: {
                decode: function decode(value) {
                    cov_1glj2h5u51.f[2]++;
                    cov_1glj2h5u51.s[3]++;

                    return value ? (cov_1glj2h5u51.b[0][0]++, new Date(value)) : (cov_1glj2h5u51.b[0][1]++, null);
                },
                encode: function encode(value) {
                    cov_1glj2h5u51.f[3]++;
                    cov_1glj2h5u51.s[4]++;

                    return moment(value).format('YYYY-MM-DD');
                }
            },
            end: {
                decode: function decode(value) {
                    cov_1glj2h5u51.f[4]++;
                    cov_1glj2h5u51.s[5]++;

                    return value ? (cov_1glj2h5u51.b[1][0]++, new Date(value)) : (cov_1glj2h5u51.b[1][1]++, null);
                },
                encode: function encode(value) {
                    cov_1glj2h5u51.f[5]++;
                    cov_1glj2h5u51.s[6]++;

                    return moment(value).format('YYYY-MM-DD');
                }
            }
        });
    }
})();
'use strict';

var cov_2k54ponn2c = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.quotas.factory.js',
        hash = '68ac6eae294ff17a495cd9fa609d82a1fbc43b72',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.quotas.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 26,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 48
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 26,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2k54ponn2c.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2k54ponn2c.f[0]++;
    cov_2k54ponn2c.s[1]++;
    angular.module('app').factory('QuotasTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2k54ponn2c.f[1]++;
        cov_2k54ponn2c.s[2]++;


        return restmod.model('/quotas').mix('MixinContainable', {
            $config: {
                contains: {
                    order: {
                        type: 'belongsTo',
                        table: 'OrdersTable',
                        foreignKey: 'order'
                    }
                }
            },
            price: {
                decode: Number
            }
        });
    }
})();
'use strict';

var cov_1ffldfk3a9 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.paymentifthen.factory.js',
        hash = '9d2bce57711529ef0b786aa2f98310d7b0e733ae',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.paymentifthen.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 18,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 52
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 18,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1ffldfk3a9.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1ffldfk3a9.f[0]++;
    cov_1ffldfk3a9.s[1]++;
    angular.module('app').factory('PaymentsIfthenTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1ffldfk3a9.f[1]++;
        cov_1ffldfk3a9.s[2]++;


        return restmod.model('/payments-ifthen').mix('MixinContainable', {
            $config: {
                contains: {}
            }
        });
    }
})();
'use strict';

var cov_2bde7q3xh1 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.paymentcash.factory.js',
        hash = 'f33432d006f2328d1fac72e2350af8b8f98e7a66',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.paymentcash.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 18,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 18,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2bde7q3xh1.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2bde7q3xh1.f[0]++;
    cov_2bde7q3xh1.s[1]++;
    angular.module('app').factory('PaymentsCashTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2bde7q3xh1.f[1]++;
        cov_2bde7q3xh1.s[2]++;


        return restmod.model('/payments-cash').mix('MixinContainable', {
            $config: {
                contains: {}
            }
        });
    }
})();
'use strict';

var cov_2lkx3hr4ls = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.paymentTypes.factory.js',
        hash = 'a8146612e5cb7b767907a6a807be070a558bd63c',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.paymentTypes.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2lkx3hr4ls.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2lkx3hr4ls.f[0]++;
    cov_2lkx3hr4ls.s[1]++;
    angular.module('app').factory('PaymentTypesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2lkx3hr4ls.f[1]++;
        cov_2lkx3hr4ls.s[2]++;


        return restmod.model('/payment-types').mix('MixinContainable', {
            $config: {
                contains: {}
            }
        });
    }
})();
'use strict';

var cov_163mxr9bha = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.orders.factory.js',
        hash = 'a961263ab5605830c925bf3ed192fb5c2900817f',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.orders.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 63,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 48
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 61,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 63,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 62,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_163mxr9bha.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_163mxr9bha.f[0]++;
    cov_163mxr9bha.s[1]++;
    angular.module('app').factory('OrdersTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_163mxr9bha.f[1]++;
        cov_163mxr9bha.s[2]++;


        return restmod.model('/orders').mix('MixinContainable', {
            $config: {
                contains: {
                    paymentIfthen: {
                        type: 'belongsTo',
                        table: 'PaymentsIfthenTable',
                        foreignKey: 'paymentId',
                        filters: {
                            payment_type: 'IFTHEN'
                        }
                    },
                    paymentCash: {
                        type: 'belongsTo',
                        table: 'PaymentsCashTable',
                        foreignKey: 'paymentId',
                        filters: {
                            payment_type: 'CASH'
                        }
                    },
                    paymentType: {
                        type: 'belongsTo',
                        table: 'PaymentTypesTable',
                        foreignKey: 'paymentType'
                    },
                    gems: {
                        type: 'hasMany',
                        table: 'GemsTable',
                        foreignKey: 'order',
                        filters: {
                            page_size: 99999
                        }
                    },
                    quotas: {
                        type: 'hasMany',
                        table: 'QuotasTable',
                        foreignKey: 'order',
                        filters: {
                            page_size: 99999
                        }
                    },
                    donations: {
                        type: 'hasMany',
                        table: 'DonationsTable',
                        foreignKey: 'order',
                        filters: {
                            page_size: 99999
                        }
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_1st8j716eb = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.mixins.containable.factory.js',
        hash = '3ee73c088b068d8f8c66f291c6bdbbaafaf434bd',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.mixins.containable.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 154,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 53
                }
            },
            '2': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 12,
                    column: 56
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 16
                },
                end: {
                    line: 15,
                    column: 49
                }
            },
            '4': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 21,
                    column: 19
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 20
                },
                end: {
                    line: 17,
                    column: 70
                }
            },
            '6': {
                start: {
                    line: 18,
                    column: 20
                },
                end: {
                    line: 20,
                    column: 21
                }
            },
            '7': {
                start: {
                    line: 19,
                    column: 24
                },
                end: {
                    line: 19,
                    column: 51
                }
            },
            '8': {
                start: {
                    line: 25,
                    column: 16
                },
                end: {
                    line: 25,
                    column: 73
                }
            },
            '9': {
                start: {
                    line: 26,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 19
                }
            },
            '10': {
                start: {
                    line: 27,
                    column: 20
                },
                end: {
                    line: 30,
                    column: 21
                }
            },
            '11': {
                start: {
                    line: 28,
                    column: 24
                },
                end: {
                    line: 28,
                    column: 82
                }
            },
            '12': {
                start: {
                    line: 29,
                    column: 24
                },
                end: {
                    line: 29,
                    column: 51
                }
            },
            '13': {
                start: {
                    line: 34,
                    column: 25
                },
                end: {
                    line: 34,
                    column: 30
                }
            },
            '14': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 44,
                    column: 13
                }
            },
            '15': {
                start: {
                    line: 37,
                    column: 20
                },
                end: {
                    line: 37,
                    column: 49
                }
            },
            '16': {
                start: {
                    line: 38,
                    column: 20
                },
                end: {
                    line: 38,
                    column: 26
                }
            },
            '17': {
                start: {
                    line: 40,
                    column: 20
                },
                end: {
                    line: 40,
                    column: 47
                }
            },
            '18': {
                start: {
                    line: 41,
                    column: 20
                },
                end: {
                    line: 41,
                    column: 26
                }
            },
            '19': {
                start: {
                    line: 43,
                    column: 20
                },
                end: {
                    line: 43,
                    column: 103
                }
            },
            '20': {
                start: {
                    line: 46,
                    column: 12
                },
                end: {
                    line: 46,
                    column: 44
                }
            },
            '21': {
                start: {
                    line: 47,
                    column: 12
                },
                end: {
                    line: 47,
                    column: 37
                }
            },
            '22': {
                start: {
                    line: 49,
                    column: 12
                },
                end: {
                    line: 49,
                    column: 26
                }
            },
            '23': {
                start: {
                    line: 53,
                    column: 12
                },
                end: {
                    line: 53,
                    column: 56
                }
            },
            '24': {
                start: {
                    line: 57,
                    column: 16
                },
                end: {
                    line: 78,
                    column: 19
                }
            },
            '25': {
                start: {
                    line: 58,
                    column: 31
                },
                end: {
                    line: 60,
                    column: 22
                }
            },
            '26': {
                start: {
                    line: 59,
                    column: 24
                },
                end: {
                    line: 59,
                    column: 54
                }
            },
            '27': {
                start: {
                    line: 62,
                    column: 34
                },
                end: {
                    line: 73,
                    column: 22
                }
            },
            '28': {
                start: {
                    line: 65,
                    column: 39
                },
                end: {
                    line: 65,
                    column: 41
                }
            },
            '29': {
                start: {
                    line: 66,
                    column: 24
                },
                end: {
                    line: 68,
                    column: 27
                }
            },
            '30': {
                start: {
                    line: 67,
                    column: 28
                },
                end: {
                    line: 67,
                    column: 60
                }
            },
            '31': {
                start: {
                    line: 70,
                    column: 24
                },
                end: {
                    line: 72,
                    column: 27
                }
            },
            '32': {
                start: {
                    line: 71,
                    column: 28
                },
                end: {
                    line: 71,
                    column: 80
                }
            },
            '33': {
                start: {
                    line: 74,
                    column: 20
                },
                end: {
                    line: 76,
                    column: 23
                }
            },
            '34': {
                start: {
                    line: 75,
                    column: 24
                },
                end: {
                    line: 75,
                    column: 50
                }
            },
            '35': {
                start: {
                    line: 77,
                    column: 20
                },
                end: {
                    line: 77,
                    column: 52
                }
            },
            '36': {
                start: {
                    line: 82,
                    column: 16
                },
                end: {
                    line: 82,
                    column: 80
                }
            },
            '37': {
                start: {
                    line: 85,
                    column: 25
                },
                end: {
                    line: 85,
                    column: 30
                }
            },
            '38': {
                start: {
                    line: 86,
                    column: 12
                },
                end: {
                    line: 95,
                    column: 13
                }
            },
            '39': {
                start: {
                    line: 88,
                    column: 20
                },
                end: {
                    line: 88,
                    column: 53
                }
            },
            '40': {
                start: {
                    line: 89,
                    column: 20
                },
                end: {
                    line: 89,
                    column: 26
                }
            },
            '41': {
                start: {
                    line: 91,
                    column: 20
                },
                end: {
                    line: 91,
                    column: 51
                }
            },
            '42': {
                start: {
                    line: 92,
                    column: 20
                },
                end: {
                    line: 92,
                    column: 26
                }
            },
            '43': {
                start: {
                    line: 94,
                    column: 20
                },
                end: {
                    line: 94,
                    column: 103
                }
            },
            '44': {
                start: {
                    line: 97,
                    column: 12
                },
                end: {
                    line: 97,
                    column: 44
                }
            },
            '45': {
                start: {
                    line: 98,
                    column: 12
                },
                end: {
                    line: 98,
                    column: 37
                }
            },
            '46': {
                start: {
                    line: 100,
                    column: 12
                },
                end: {
                    line: 100,
                    column: 30
                }
            },
            '47': {
                start: {
                    line: 104,
                    column: 27
                },
                end: {
                    line: 104,
                    column: 62
                }
            },
            '48': {
                start: {
                    line: 105,
                    column: 12
                },
                end: {
                    line: 116,
                    column: 13
                }
            },
            '49': {
                start: {
                    line: 106,
                    column: 29
                },
                end: {
                    line: 106,
                    column: 65
                }
            },
            '50': {
                start: {
                    line: 107,
                    column: 16
                },
                end: {
                    line: 107,
                    column: 60
                }
            },
            '51': {
                start: {
                    line: 108,
                    column: 16
                },
                end: {
                    line: 112,
                    column: 19
                }
            },
            '52': {
                start: {
                    line: 109,
                    column: 20
                },
                end: {
                    line: 111,
                    column: 21
                }
            },
            '53': {
                start: {
                    line: 110,
                    column: 24
                },
                end: {
                    line: 110,
                    column: 54
                }
            },
            '54': {
                start: {
                    line: 113,
                    column: 16
                },
                end: {
                    line: 113,
                    column: 30
                }
            },
            '55': {
                start: {
                    line: 115,
                    column: 16
                },
                end: {
                    line: 115,
                    column: 92
                }
            },
            '56': {
                start: {
                    line: 119,
                    column: 8
                },
                end: {
                    line: 152,
                    column: 11
                }
            },
            '57': {
                start: {
                    line: 124,
                    column: 38
                },
                end: {
                    line: 124,
                    column: 73
                }
            },
            '58': {
                start: {
                    line: 125,
                    column: 24
                },
                end: {
                    line: 125,
                    column: 95
                }
            },
            '59': {
                start: {
                    line: 126,
                    column: 24
                },
                end: {
                    line: 126,
                    column: 94
                }
            },
            '60': {
                start: {
                    line: 131,
                    column: 38
                },
                end: {
                    line: 131,
                    column: 73
                }
            },
            '61': {
                start: {
                    line: 132,
                    column: 24
                },
                end: {
                    line: 132,
                    column: 95
                }
            },
            '62': {
                start: {
                    line: 133,
                    column: 24
                },
                end: {
                    line: 133,
                    column: 90
                }
            },
            '63': {
                start: {
                    line: 136,
                    column: 35
                },
                end: {
                    line: 136,
                    column: 53
                }
            },
            '64': {
                start: {
                    line: 137,
                    column: 24
                },
                end: {
                    line: 139,
                    column: 25
                }
            },
            '65': {
                start: {
                    line: 138,
                    column: 28
                },
                end: {
                    line: 138,
                    column: 53
                }
            },
            '66': {
                start: {
                    line: 140,
                    column: 24
                },
                end: {
                    line: 140,
                    column: 42
                }
            },
            '67': {
                start: {
                    line: 146,
                    column: 20
                },
                end: {
                    line: 148,
                    column: 21
                }
            },
            '68': {
                start: {
                    line: 147,
                    column: 24
                },
                end: {
                    line: 147,
                    column: 41
                }
            },
            '69': {
                start: {
                    line: 149,
                    column: 20
                },
                end: {
                    line: 149,
                    column: 93
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 154,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 48
                    },
                    end: {
                        line: 153,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'recordLoad',
                decl: {
                    start: {
                        line: 11,
                        column: 17
                    },
                    end: {
                        line: 11,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 68
                    },
                    end: {
                        line: 50,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: 'recordLoadBelongsTo',
                decl: {
                    start: {
                        line: 14,
                        column: 21
                    },
                    end: {
                        line: 14,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 48
                    },
                    end: {
                        line: 22,
                        column: 13
                    }
                },
                line: 14
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 16,
                        column: 29
                    },
                    end: {
                        line: 16,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 41
                    },
                    end: {
                        line: 21,
                        column: 17
                    }
                },
                line: 16
            },
            '5': {
                name: 'recordLoadHasMany',
                decl: {
                    start: {
                        line: 24,
                        column: 21
                    },
                    end: {
                        line: 24,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 46
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 24
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 26,
                        column: 29
                    },
                    end: {
                        line: 26,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 41
                    },
                    end: {
                        line: 31,
                        column: 17
                    }
                },
                line: 26
            },
            '7': {
                name: 'collectionLoad',
                decl: {
                    start: {
                        line: 52,
                        column: 17
                    },
                    end: {
                        line: 52,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 76
                    },
                    end: {
                        line: 101,
                        column: 9
                    }
                },
                line: 52
            },
            '8': {
                name: 'collectionLoadBelongsTo',
                decl: {
                    start: {
                        line: 56,
                        column: 21
                    },
                    end: {
                        line: 56,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 56,
                        column: 52
                    },
                    end: {
                        line: 79,
                        column: 13
                    }
                },
                line: 56
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 57,
                        column: 33
                    },
                    end: {
                        line: 57,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 45
                    },
                    end: {
                        line: 78,
                        column: 17
                    }
                },
                line: 57
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 58,
                        column: 46
                    },
                    end: {
                        line: 58,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 58,
                        column: 61
                    },
                    end: {
                        line: 60,
                        column: 21
                    }
                },
                line: 58
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 64,
                        column: 29
                    },
                    end: {
                        line: 64,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 45
                    },
                    end: {
                        line: 73,
                        column: 21
                    }
                },
                line: 64
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 66,
                        column: 46
                    },
                    end: {
                        line: 66,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 66,
                        column: 65
                    },
                    end: {
                        line: 68,
                        column: 25
                    }
                },
                line: 66
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 70,
                        column: 52
                    },
                    end: {
                        line: 70,
                        column: 53
                    }
                },
                loc: {
                    start: {
                        line: 70,
                        column: 68
                    },
                    end: {
                        line: 72,
                        column: 25
                    }
                },
                line: 70
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 74,
                        column: 48
                    },
                    end: {
                        line: 74,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 74,
                        column: 64
                    },
                    end: {
                        line: 76,
                        column: 21
                    }
                },
                line: 74
            },
            '15': {
                name: 'collectionLoadHasMany',
                decl: {
                    start: {
                        line: 81,
                        column: 21
                    },
                    end: {
                        line: 81,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 81,
                        column: 50
                    },
                    end: {
                        line: 83,
                        column: 13
                    }
                },
                line: 81
            },
            '16': {
                name: 'getModelConfigs',
                decl: {
                    start: {
                        line: 103,
                        column: 17
                    },
                    end: {
                        line: 103,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 103,
                        column: 54
                    },
                    end: {
                        line: 117,
                        column: 9
                    }
                },
                line: 103
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 108,
                        column: 48
                    },
                    end: {
                        line: 108,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 108,
                        column: 70
                    },
                    end: {
                        line: 112,
                        column: 17
                    }
                },
                line: 108
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 123,
                        column: 27
                    },
                    end: {
                        line: 123,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 123,
                        column: 70
                    },
                    end: {
                        line: 127,
                        column: 21
                    }
                },
                line: 123
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 130,
                        column: 27
                    },
                    end: {
                        line: 130,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 130,
                        column: 70
                    },
                    end: {
                        line: 134,
                        column: 21
                    }
                },
                line: 130
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 135,
                        column: 24
                    },
                    end: {
                        line: 135,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 135,
                        column: 48
                    },
                    end: {
                        line: 141,
                        column: 21
                    }
                },
                line: 135
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 145,
                        column: 37
                    },
                    end: {
                        line: 145,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 145,
                        column: 53
                    },
                    end: {
                        line: 150,
                        column: 17
                    }
                },
                line: 145
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 12,
                        column: 32
                    },
                    end: {
                        line: 12,
                        column: 55
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 12,
                        column: 32
                    },
                    end: {
                        line: 12,
                        column: 49
                    }
                }, {
                    start: {
                        line: 12,
                        column: 53
                    },
                    end: {
                        line: 12,
                        column: 55
                    }
                }],
                line: 12
            },
            '1': {
                loc: {
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 21
                    }
                }, {
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 21
                    }
                }],
                line: 18
            },
            '2': {
                loc: {
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 30,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 30,
                        column: 21
                    }
                }, {
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 30,
                        column: 21
                    }
                }],
                line: 27
            },
            '3': {
                loc: {
                    start: {
                        line: 35,
                        column: 12
                    },
                    end: {
                        line: 44,
                        column: 13
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 36,
                        column: 16
                    },
                    end: {
                        line: 38,
                        column: 26
                    }
                }, {
                    start: {
                        line: 39,
                        column: 16
                    },
                    end: {
                        line: 41,
                        column: 26
                    }
                }, {
                    start: {
                        line: 42,
                        column: 16
                    },
                    end: {
                        line: 43,
                        column: 103
                    }
                }],
                line: 35
            },
            '4': {
                loc: {
                    start: {
                        line: 53,
                        column: 32
                    },
                    end: {
                        line: 53,
                        column: 55
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 53,
                        column: 32
                    },
                    end: {
                        line: 53,
                        column: 49
                    }
                }, {
                    start: {
                        line: 53,
                        column: 53
                    },
                    end: {
                        line: 53,
                        column: 55
                    }
                }],
                line: 53
            },
            '5': {
                loc: {
                    start: {
                        line: 86,
                        column: 12
                    },
                    end: {
                        line: 95,
                        column: 13
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 87,
                        column: 16
                    },
                    end: {
                        line: 89,
                        column: 26
                    }
                }, {
                    start: {
                        line: 90,
                        column: 16
                    },
                    end: {
                        line: 92,
                        column: 26
                    }
                }, {
                    start: {
                        line: 93,
                        column: 16
                    },
                    end: {
                        line: 94,
                        column: 103
                    }
                }],
                line: 86
            },
            '6': {
                loc: {
                    start: {
                        line: 105,
                        column: 12
                    },
                    end: {
                        line: 116,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 105,
                        column: 12
                    },
                    end: {
                        line: 116,
                        column: 13
                    }
                }, {
                    start: {
                        line: 105,
                        column: 12
                    },
                    end: {
                        line: 116,
                        column: 13
                    }
                }],
                line: 105
            },
            '7': {
                loc: {
                    start: {
                        line: 105,
                        column: 16
                    },
                    end: {
                        line: 105,
                        column: 50
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 105,
                        column: 16
                    },
                    end: {
                        line: 105,
                        column: 24
                    }
                }, {
                    start: {
                        line: 105,
                        column: 28
                    },
                    end: {
                        line: 105,
                        column: 50
                    }
                }],
                line: 105
            },
            '8': {
                loc: {
                    start: {
                        line: 107,
                        column: 36
                    },
                    end: {
                        line: 107,
                        column: 59
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 107,
                        column: 36
                    },
                    end: {
                        line: 107,
                        column: 53
                    }
                }, {
                    start: {
                        line: 107,
                        column: 57
                    },
                    end: {
                        line: 107,
                        column: 59
                    }
                }],
                line: 107
            },
            '9': {
                loc: {
                    start: {
                        line: 109,
                        column: 20
                    },
                    end: {
                        line: 111,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 109,
                        column: 20
                    },
                    end: {
                        line: 111,
                        column: 21
                    }
                }, {
                    start: {
                        line: 109,
                        column: 20
                    },
                    end: {
                        line: 111,
                        column: 21
                    }
                }],
                line: 109
            },
            '10': {
                loc: {
                    start: {
                        line: 137,
                        column: 24
                    },
                    end: {
                        line: 139,
                        column: 25
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 137,
                        column: 24
                    },
                    end: {
                        line: 139,
                        column: 25
                    }
                }, {
                    start: {
                        line: 137,
                        column: 24
                    },
                    end: {
                        line: 139,
                        column: 25
                    }
                }],
                line: 137
            },
            '11': {
                loc: {
                    start: {
                        line: 146,
                        column: 20
                    },
                    end: {
                        line: 148,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 146,
                        column: 20
                    },
                    end: {
                        line: 148,
                        column: 21
                    }
                }, {
                    start: {
                        line: 146,
                        column: 20
                    },
                    end: {
                        line: 148,
                        column: 21
                    }
                }],
                line: 146
            },
            '12': {
                loc: {
                    start: {
                        line: 149,
                        column: 47
                    },
                    end: {
                        line: 149,
                        column: 92
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 149,
                        column: 47
                    },
                    end: {
                        line: 149,
                        column: 71
                    }
                }, {
                    start: {
                        line: 149,
                        column: 75
                    },
                    end: {
                        line: 149,
                        column: 86
                    }
                }, {
                    start: {
                        line: 149,
                        column: 90
                    },
                    end: {
                        line: 149,
                        column: 92
                    }
                }],
                line: 149
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0,
            '61': 0,
            '62': 0,
            '63': 0,
            '64': 0,
            '65': 0,
            '66': 0,
            '67': 0,
            '68': 0,
            '69': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0, 0],
            '4': [0, 0],
            '5': [0, 0, 0],
            '6': [0, 0],
            '7': [0, 0],
            '8': [0, 0],
            '9': [0, 0],
            '10': [0, 0],
            '11': [0, 0],
            '12': [0, 0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1st8j716eb.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod", "$injector"];
    cov_1st8j716eb.f[0]++;
    cov_1st8j716eb.s[1]++;
    angular.module('app').factory('MixinContainable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod, $injector) {
        cov_1st8j716eb.f[1]++;


        function recordLoad(record, key, config, additionalFilters) {
            cov_1st8j716eb.f[2]++;
            cov_1st8j716eb.s[2]++;

            additionalFilters = (cov_1st8j716eb.b[0][0]++, additionalFilters) || (cov_1st8j716eb.b[0][1]++, {});

            function recordLoadBelongsTo(table) {
                cov_1st8j716eb.f[3]++;
                cov_1st8j716eb.s[3]++;

                record['$' + key] = table.$new();
                cov_1st8j716eb.s[4]++;
                record.$then(function () {
                    cov_1st8j716eb.f[4]++;
                    cov_1st8j716eb.s[5]++;

                    record['$' + key].$pk = record[config.foreignKey];
                    cov_1st8j716eb.s[6]++;
                    if (record[config.foreignKey]) {
                        cov_1st8j716eb.b[1][0]++;
                        cov_1st8j716eb.s[7]++;

                        record['$' + key].$fetch();
                    } else {
                        cov_1st8j716eb.b[1][1]++;
                    }
                });
            }

            function recordLoadHasMany(table) {
                cov_1st8j716eb.f[5]++;
                cov_1st8j716eb.s[8]++;

                record['$' + key] = table.$collection(additionalFilters);
                cov_1st8j716eb.s[9]++;
                record.$then(function () {
                    cov_1st8j716eb.f[6]++;
                    cov_1st8j716eb.s[10]++;

                    if (record.$pk) {
                        cov_1st8j716eb.b[2][0]++;
                        cov_1st8j716eb.s[11]++;

                        record['$' + key].$params[config.foreignKey] = record.$pk;
                        cov_1st8j716eb.s[12]++;
                        record['$' + key].$fetch();
                    } else {
                        cov_1st8j716eb.b[2][1]++;
                    }
                });
            }

            var loader = (cov_1st8j716eb.s[13]++, false);
            cov_1st8j716eb.s[14]++;
            switch (config.type) {
                case 'belongsTo':
                    cov_1st8j716eb.b[3][0]++;
                    cov_1st8j716eb.s[15]++;

                    loader = recordLoadBelongsTo;
                    cov_1st8j716eb.s[16]++;
                    break;
                case 'hasMany':
                    cov_1st8j716eb.b[3][1]++;
                    cov_1st8j716eb.s[17]++;

                    loader = recordLoadHasMany;
                    cov_1st8j716eb.s[18]++;
                    break;
                default:
                    cov_1st8j716eb.b[3][2]++;
                    cov_1st8j716eb.s[19]++;

                    throw new Error('Unknown contain type "' + config.type + '" for MixinContainable');
            }

            cov_1st8j716eb.s[20]++;
            loader.$inject = [config.table];
            cov_1st8j716eb.s[21]++;
            $injector.invoke(loader);

            cov_1st8j716eb.s[22]++;
            return record;
        }

        function collectionLoad(collection, key, config, additionalFilters) {
            cov_1st8j716eb.f[7]++;
            cov_1st8j716eb.s[23]++;

            additionalFilters = (cov_1st8j716eb.b[4][0]++, additionalFilters) || (cov_1st8j716eb.b[4][1]++, {});

            function collectionLoadBelongsTo(table) {
                cov_1st8j716eb.f[8]++;
                cov_1st8j716eb.s[24]++;

                collection.$then(function () {
                    cov_1st8j716eb.f[9]++;

                    var keys = (cov_1st8j716eb.s[25]++, collection.map(function (obj) {
                        cov_1st8j716eb.f[10]++;
                        cov_1st8j716eb.s[26]++;

                        return obj[config.foreignKey];
                    }));

                    var request = (cov_1st8j716eb.s[27]++, table.$search({
                        'id__in': keys.join(',')
                    }).$then(function (data) {
                        cov_1st8j716eb.f[11]++;

                        var objsById = (cov_1st8j716eb.s[28]++, {});
                        cov_1st8j716eb.s[29]++;
                        angular.forEach(data, function (respObj) {
                            cov_1st8j716eb.f[12]++;
                            cov_1st8j716eb.s[30]++;

                            objsById[respObj.$pk] = respObj;
                        });

                        cov_1st8j716eb.s[31]++;
                        angular.forEach(collection, function (item) {
                            cov_1st8j716eb.f[13]++;
                            cov_1st8j716eb.s[32]++;

                            item['$' + key] = objsById[item[config.foreignKey]];
                        });
                    }));
                    cov_1st8j716eb.s[33]++;
                    angular.forEach(collection, function (item) {
                        cov_1st8j716eb.f[14]++;
                        cov_1st8j716eb.s[34]++;

                        item['$' + key] = request;
                    });
                    cov_1st8j716eb.s[35]++;
                    collection['$' + key] = request;
                });
            }

            function collectionLoadHasMany(table) {
                cov_1st8j716eb.f[15]++;
                cov_1st8j716eb.s[36]++;

                throw new Error('Collection load has many Not implemented yet');
            }

            var loader = (cov_1st8j716eb.s[37]++, false);
            cov_1st8j716eb.s[38]++;
            switch (config.type) {
                case 'belongsTo':
                    cov_1st8j716eb.b[5][0]++;
                    cov_1st8j716eb.s[39]++;

                    loader = collectionLoadBelongsTo;
                    cov_1st8j716eb.s[40]++;
                    break;
                case 'hasMany':
                    cov_1st8j716eb.b[5][1]++;
                    cov_1st8j716eb.s[41]++;

                    loader = collectionLoadHasMany;
                    cov_1st8j716eb.s[42]++;
                    break;
                default:
                    cov_1st8j716eb.b[5][2]++;
                    cov_1st8j716eb.s[43]++;

                    throw new Error('Unknown contain type "' + config.type + '" for MixinContainable');
            }

            cov_1st8j716eb.s[44]++;
            loader.$inject = [config.table];
            cov_1st8j716eb.s[45]++;
            $injector.invoke(loader);

            cov_1st8j716eb.s[46]++;
            return collection;
        }

        function getModelConfigs(model, relatedModel) {
            cov_1st8j716eb.f[16]++;

            var contains = (cov_1st8j716eb.s[47]++, model.$type.getProperty('contains'));
            cov_1st8j716eb.s[48]++;
            if ((cov_1st8j716eb.b[7][0]++, contains) && (cov_1st8j716eb.b[7][1]++, contains[relatedModel])) {
                cov_1st8j716eb.b[6][0]++;

                var config = (cov_1st8j716eb.s[49]++, angular.copy(contains[relatedModel]));
                cov_1st8j716eb.s[50]++;
                config['filters'] = (cov_1st8j716eb.b[8][0]++, config['filters']) || (cov_1st8j716eb.b[8][1]++, {});
                cov_1st8j716eb.s[51]++;
                angular.forEach(config.filters, function (value, key) {
                    cov_1st8j716eb.f[17]++;
                    cov_1st8j716eb.s[52]++;

                    if (angular.isFunction(config.filters[key])) {
                        cov_1st8j716eb.b[9][0]++;
                        cov_1st8j716eb.s[53]++;

                        config.filters[key] = value();
                    } else {
                        cov_1st8j716eb.b[9][1]++;
                    }
                });
                cov_1st8j716eb.s[54]++;
                return config;
            } else {
                cov_1st8j716eb.b[6][1]++;
                cov_1st8j716eb.s[55]++;

                throw new Error('Cannot find MixinContainable configs for ' + relatedModel);
            }
        }

        cov_1st8j716eb.s[56]++;
        return restmod.mixin({
            $extend: {
                Collection: {
                    $limit: 25,
                    $load: function $load(relatedModel, additionalFilters) {
                        cov_1st8j716eb.f[18]++;

                        var configs = (cov_1st8j716eb.s[57]++, getModelConfigs(this, relatedModel));
                        cov_1st8j716eb.s[58]++;
                        additionalFilters = angular.extend(configs.filters, additionalFilters);
                        cov_1st8j716eb.s[59]++;
                        return collectionLoad(this, relatedModel, configs, additionalFilters);
                    }
                },
                Record: {
                    $load: function $load(relatedModel, additionalFilters) {
                        cov_1st8j716eb.f[19]++;

                        var configs = (cov_1st8j716eb.s[60]++, getModelConfigs(this, relatedModel));
                        cov_1st8j716eb.s[61]++;
                        additionalFilters = angular.extend(configs.filters, additionalFilters);
                        cov_1st8j716eb.s[62]++;
                        return recordLoad(this, relatedModel, configs, additionalFilters);
                    },
                    $_: function $_(relatedModel) {
                        cov_1st8j716eb.f[20]++;

                        var name = (cov_1st8j716eb.s[63]++, '$' + relatedModel);
                        cov_1st8j716eb.s[64]++;
                        if (!this[name]) {
                            cov_1st8j716eb.b[10][0]++;
                            cov_1st8j716eb.s[65]++;

                            this.$load(relatedModel);
                        } else {
                            cov_1st8j716eb.b[10][1]++;
                        }
                        cov_1st8j716eb.s[66]++;
                        return this[name];
                    }
                }
            },
            $hooks: {
                'before-fetch-many': function beforeFetchMany(_req) {
                    cov_1st8j716eb.f[21]++;
                    cov_1st8j716eb.s[67]++;

                    if (_.isUndefined(_req.params)) {
                        cov_1st8j716eb.b[11][0]++;
                        cov_1st8j716eb.s[68]++;

                        _req.params = {};
                    } else {
                        cov_1st8j716eb.b[11][1]++;
                    }
                    cov_1st8j716eb.s[69]++;
                    _req.params['page_size'] = (cov_1st8j716eb.b[12][0]++, _req.params['page_size']) || (cov_1st8j716eb.b[12][1]++, this.$limit) || (cov_1st8j716eb.b[12][2]++, 25);
                }
            }
        });
    }
})();
'use strict';

var cov_7rxtsfun8 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.groupTypes.factory.js',
        hash = '51ed975a8e814e3ae84034fe3694be7a470e762a',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.groupTypes.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 52
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_7rxtsfun8.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_7rxtsfun8.f[0]++;
    cov_7rxtsfun8.s[1]++;
    angular.module('app').factory('GroupTypesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_7rxtsfun8.f[1]++;
        cov_7rxtsfun8.s[2]++;


        return restmod.model('/group-types').mix('MixinContainable', {
            $config: {
                contains: {}
            }
        });
    }
})();
'use strict';

var cov_1xu3ide793 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.gems.factory.js',
        hash = 'b52915ea8b9f0c4b051da037a00fe092ccc84017',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.gems.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 46
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 23,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1xu3ide793.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1xu3ide793.f[0]++;
    cov_1xu3ide793.s[1]++;
    angular.module('app').factory('GemsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1xu3ide793.f[1]++;
        cov_1xu3ide793.s[2]++;


        return restmod.model('/gems').mix('MixinContainable', {
            $config: {
                contains: {
                    order: {
                        type: 'belongsTo',
                        table: 'OrdersTable',
                        foreignKey: 'order'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_uyjoizsa6 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.eventcategories.factory.js',
        hash = '7b5bfb271c6825715f880a06bcd92fb46eedc9ef',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.eventcategories.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 53
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 23,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_uyjoizsa6.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_uyjoizsa6.f[0]++;
    cov_uyjoizsa6.s[1]++;
    angular.module('app').factory('EventCategoriesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_uyjoizsa6.f[1]++;
        cov_uyjoizsa6.s[2]++;


        return restmod.model('/event-categories').mix('MixinContainable', {
            $config: {
                contains: {
                    userInterests: {
                        type: 'hasMany',
                        table: 'UserInterestsTable',
                        foreignKey: 'event_category'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_nhck54da7 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.donations.factory.js',
        hash = '086d1efa611af58294ea2eef4fd2449580dd192f',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.donations.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 23,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_nhck54da7.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_nhck54da7.f[0]++;
    cov_nhck54da7.s[1]++;
    angular.module('app').factory('DonationsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_nhck54da7.f[1]++;
        cov_nhck54da7.s[2]++;


        return restmod.model('/donations').mix('MixinContainable', {
            $config: {
                contains: {
                    order: {
                        type: 'belongsTo',
                        table: 'OrdersTable',
                        foreignKey: 'order'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_jahfnylkc = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.configurations.js',
        hash = '59afba6f1722b5deaa475bd5e0249f3b36c9a057',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.configurations.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 1
                },
                end: {
                    line: 10,
                    column: 41
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_jahfnylkc.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_jahfnylkc.f[0]++;
    cov_jahfnylkc.s[1]++;
    angular.module('app').factory('ConfigurationsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_jahfnylkc.f[1]++;
        cov_jahfnylkc.s[2]++;

        return restmod.model('/configurations');
    }
})();
'use strict';

var cov_cln59asgc = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.config.js',
        hash = '60694b6c089f37481479bb48eca6acfe92ced560',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.config.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 24
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 52
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Config',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 50
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_cln59asgc.s[0]++;
(function () {
    'use strict';

    Config.$inject = ["restmodProvider", "AppSettings"];
    cov_cln59asgc.f[0]++;
    cov_cln59asgc.s[1]++;
    angular.module('app').config(Config);

    /* @ngInject */
    function Config(restmodProvider, AppSettings) {
        cov_cln59asgc.f[1]++;
        cov_cln59asgc.s[2]++;

        restmodProvider.rebase({
            $config: {
                urlPrefix: AppSettings.apiUrl
            }
        });
        cov_cln59asgc.s[3]++;
        restmodProvider.rebase('DjangoDRFPagedApi');
    }
})();
'use strict';

var cov_2l49a4lo9c = function () {
  var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/dirty.js',
      hash = 'c58195f990782665831323658ca5de9f865139a9',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/dirty.js',
    statementMap: {
      '0': {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 95,
          column: 16
        }
      },
      '1': {
        start: {
          line: 17,
          column: 0
        },
        end: {
          line: 95,
          column: 4
        }
      },
      '2': {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 94,
          column: 5
        }
      },
      '3': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 93,
          column: 11
        }
      },
      '4': {
        start: {
          line: 22,
          column: 25
        },
        end: {
          line: 22,
          column: 44
        }
      },
      '5': {
        start: {
          line: 23,
          column: 10
        },
        end: {
          line: 25,
          column: 13
        }
      },
      '6': {
        start: {
          line: 24,
          column: 12
        },
        end: {
          line: 24,
          column: 36
        }
      },
      '7': {
        start: {
          line: 46,
          column: 25
        },
        end: {
          line: 46,
          column: 39
        }
      },
      '8': {
        start: {
          line: 47,
          column: 10
        },
        end: {
          line: 60,
          column: 11
        }
      },
      '9': {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 72
        }
      },
      '10': {
        start: {
          line: 48,
          column: 59
        },
        end: {
          line: 48,
          column: 72
        }
      },
      '11': {
        start: {
          line: 49,
          column: 12
        },
        end: {
          line: 49,
          column: 51
        }
      },
      '12': {
        start: {
          line: 51,
          column: 26
        },
        end: {
          line: 51,
          column: 28
        }
      },
      '13': {
        start: {
          line: 52,
          column: 12
        },
        end: {
          line: 58,
          column: 13
        }
      },
      '14': {
        start: {
          line: 53,
          column: 14
        },
        end: {
          line: 57,
          column: 15
        }
      },
      '15': {
        start: {
          line: 54,
          column: 16
        },
        end: {
          line: 56,
          column: 17
        }
      },
      '16': {
        start: {
          line: 55,
          column: 18
        },
        end: {
          line: 55,
          column: 36
        }
      },
      '17': {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 59,
          column: 27
        }
      },
      '18': {
        start: {
          line: 83,
          column: 10
        },
        end: {
          line: 92,
          column: 13
        }
      },
      '19': {
        start: {
          line: 84,
          column: 27
        },
        end: {
          line: 84,
          column: 41
        }
      },
      '20': {
        start: {
          line: 85,
          column: 12
        },
        end: {
          line: 91,
          column: 13
        }
      },
      '21': {
        start: {
          line: 86,
          column: 14
        },
        end: {
          line: 86,
          column: 44
        }
      },
      '22': {
        start: {
          line: 88,
          column: 14
        },
        end: {
          line: 90,
          column: 15
        }
      },
      '23': {
        start: {
          line: 89,
          column: 16
        },
        end: {
          line: 89,
          column: 75
        }
      },
      '24': {
        start: {
          line: 89,
          column: 49
        },
        end: {
          line: 89,
          column: 75
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 9,
            column: 1
          },
          end: {
            line: 9,
            column: 2
          }
        },
        loc: {
          start: {
            line: 9,
            column: 30
          },
          end: {
            line: 95,
            column: 5
          }
        },
        line: 9
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 17,
            column: 60
          },
          end: {
            line: 17,
            column: 61
          }
        },
        loc: {
          start: {
            line: 17,
            column: 78
          },
          end: {
            line: 95,
            column: 1
          }
        },
        line: 17
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 24
          }
        },
        loc: {
          start: {
            line: 19,
            column: 34
          },
          end: {
            line: 94,
            column: 3
          }
        },
        line: 19
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 20,
            column: 26
          },
          end: {
            line: 20,
            column: 27
          }
        },
        loc: {
          start: {
            line: 20,
            column: 46
          },
          end: {
            line: 26,
            column: 9
          }
        },
        line: 20
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 23,
            column: 21
          },
          end: {
            line: 23,
            column: 22
          }
        },
        loc: {
          start: {
            line: 23,
            column: 44
          },
          end: {
            line: 25,
            column: 11
          }
        },
        line: 23
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 45,
            column: 26
          },
          end: {
            line: 45,
            column: 27
          }
        },
        loc: {
          start: {
            line: 45,
            column: 42
          },
          end: {
            line: 61,
            column: 9
          }
        },
        line: 45
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 82,
            column: 28
          },
          end: {
            line: 82,
            column: 29
          }
        },
        loc: {
          start: {
            line: 82,
            column: 44
          },
          end: {
            line: 93,
            column: 9
          }
        },
        line: 82
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 83,
            column: 30
          },
          end: {
            line: 83,
            column: 31
          }
        },
        loc: {
          start: {
            line: 83,
            column: 41
          },
          end: {
            line: 92,
            column: 11
          }
        },
        line: 83
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 47,
            column: 10
          },
          end: {
            line: 60,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 47,
            column: 10
          },
          end: {
            line: 60,
            column: 11
          }
        }, {
          start: {
            line: 47,
            column: 10
          },
          end: {
            line: 60,
            column: 11
          }
        }],
        line: 47
      },
      '1': {
        loc: {
          start: {
            line: 48,
            column: 12
          },
          end: {
            line: 48,
            column: 72
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 48,
            column: 12
          },
          end: {
            line: 48,
            column: 72
          }
        }, {
          start: {
            line: 48,
            column: 12
          },
          end: {
            line: 48,
            column: 72
          }
        }],
        line: 48
      },
      '2': {
        loc: {
          start: {
            line: 48,
            column: 15
          },
          end: {
            line: 48,
            column: 57
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 48,
            column: 15
          },
          end: {
            line: 48,
            column: 24
          }
        }, {
          start: {
            line: 48,
            column: 28
          },
          end: {
            line: 48,
            column: 57
          }
        }],
        line: 48
      },
      '3': {
        loc: {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 58,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 58,
            column: 13
          }
        }, {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 58,
            column: 13
          }
        }],
        line: 52
      },
      '4': {
        loc: {
          start: {
            line: 54,
            column: 16
          },
          end: {
            line: 56,
            column: 17
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 54,
            column: 16
          },
          end: {
            line: 56,
            column: 17
          }
        }, {
          start: {
            line: 54,
            column: 16
          },
          end: {
            line: 56,
            column: 17
          }
        }],
        line: 54
      },
      '5': {
        loc: {
          start: {
            line: 54,
            column: 19
          },
          end: {
            line: 54,
            column: 78
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 54,
            column: 19
          },
          end: {
            line: 54,
            column: 47
          }
        }, {
          start: {
            line: 54,
            column: 51
          },
          end: {
            line: 54,
            column: 78
          }
        }],
        line: 54
      },
      '6': {
        loc: {
          start: {
            line: 85,
            column: 12
          },
          end: {
            line: 91,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 85,
            column: 12
          },
          end: {
            line: 91,
            column: 13
          }
        }, {
          start: {
            line: 85,
            column: 12
          },
          end: {
            line: 91,
            column: 13
          }
        }],
        line: 85
      },
      '7': {
        loc: {
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 89,
            column: 75
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 89,
            column: 75
          }
        }, {
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 89,
            column: 75
          }
        }],
        line: 89
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2l49a4lo9c.s[0]++;
/**
 * API Bound Models for AngularJS
 * @version v1.1.11 - 2015-10-26
 * @link https://github.com/angular-platanus/restmod
 * @author Ignacio Baixas <ignacio@platan.us>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */

(function (angular, undefined) {
  'use strict';
  /**
   * @mixin DirtyModel
   *
   * @description Adds the `$dirty` method to a model`s instances.
   */

  cov_2l49a4lo9c.f[0]++;
  cov_2l49a4lo9c.s[1]++;
  angular.module('restmod').factory('DirtyModel', ['restmod', function (restmod) {
    cov_2l49a4lo9c.f[1]++;
    cov_2l49a4lo9c.s[2]++;


    return restmod.mixin(function () {
      cov_2l49a4lo9c.f[2]++;
      cov_2l49a4lo9c.s[3]++;

      this.on('after-feed', function (_original) {
        cov_2l49a4lo9c.f[3]++;

        // store original information in a model's special property
        var original = (cov_2l49a4lo9c.s[4]++, this.$cmStatus = {});
        cov_2l49a4lo9c.s[5]++;
        this.$each(function (_value, _key) {
          cov_2l49a4lo9c.f[4]++;
          cov_2l49a4lo9c.s[6]++;

          original[_key] = _value;
        });
      })
      /**
       * @method $dirty
       * @memberof DirtyModel#
       *
       * @description Retrieves the model changes
       *
       * Property changes are determined using the strict equality operator.
       *
       * IDEA: allow changing the equality function per attribute.
       *
       * If given a property name, this method will return true if property has changed
       * or false if it has not.
       *
       * Called without arguments, this method will return a list of changed property names.
       *
       * @param {string} _prop Property to query
       * @return {boolean|array} Property state or array of changed properties
       */
      .define('$dirty', function (_prop) {
        cov_2l49a4lo9c.f[5]++;

        var original = (cov_2l49a4lo9c.s[7]++, this.$cmStatus);
        cov_2l49a4lo9c.s[8]++;
        if (_prop) {
          cov_2l49a4lo9c.b[0][0]++;
          cov_2l49a4lo9c.s[9]++;

          if ((cov_2l49a4lo9c.b[2][0]++, !original) || (cov_2l49a4lo9c.b[2][1]++, original[_prop] === undefined)) {
              cov_2l49a4lo9c.b[1][0]++;
              cov_2l49a4lo9c.s[10]++;
              return false;
            } else {
            cov_2l49a4lo9c.b[1][1]++;
          }cov_2l49a4lo9c.s[11]++;
          return original[_prop] !== this[_prop];
        } else {
          cov_2l49a4lo9c.b[0][1]++;

          var changes = (cov_2l49a4lo9c.s[12]++, []),
              key;
          cov_2l49a4lo9c.s[13]++;
          if (original) {
            cov_2l49a4lo9c.b[3][0]++;
            cov_2l49a4lo9c.s[14]++;

            for (key in original) {
              cov_2l49a4lo9c.s[15]++;

              if ((cov_2l49a4lo9c.b[5][0]++, original.hasOwnProperty(key)) && (cov_2l49a4lo9c.b[5][1]++, original[key] !== this[key])) {
                cov_2l49a4lo9c.b[4][0]++;
                cov_2l49a4lo9c.s[16]++;

                changes.push(key);
              } else {
                cov_2l49a4lo9c.b[4][1]++;
              }
            }
          } else {
            cov_2l49a4lo9c.b[3][1]++;
          }
          cov_2l49a4lo9c.s[17]++;
          return changes;
        }
      })
      /**
       * @method $restore
       * @memberof DirtyModel#
       *
       * @description Restores the model's last fetched values.
       *
       * Usage:
       *
       * ```javascript
       * bike = Bike.$create({ brand: 'Trek' });
       * // later on...
       * bike.brand = 'Giant';
       * bike.$restore();
       *
       * console.log(bike.brand); // outputs 'Trek'
       * ```
       *
       * @param {string} _prop If provided, only _prop is restored
       * @return {Model} self
       */
      .define('$restore', function (_prop) {
        cov_2l49a4lo9c.f[6]++;
        cov_2l49a4lo9c.s[18]++;

        return this.$action(function () {
          cov_2l49a4lo9c.f[7]++;

          var original = (cov_2l49a4lo9c.s[19]++, this.$cmStatus);
          cov_2l49a4lo9c.s[20]++;
          if (_prop) {
            cov_2l49a4lo9c.b[6][0]++;
            cov_2l49a4lo9c.s[21]++;

            this[_prop] = original[_prop];
          } else {
            cov_2l49a4lo9c.b[6][1]++;
            cov_2l49a4lo9c.s[22]++;

            for (var key in original) {
              cov_2l49a4lo9c.s[23]++;

              if (original.hasOwnProperty(key)) {
                  cov_2l49a4lo9c.b[7][0]++;
                  cov_2l49a4lo9c.s[24]++;
                  this[key] = original[key];
                } else {
                cov_2l49a4lo9c.b[7][1]++;
              }
            }
          }
        });
      });
    });
  }]);
})(angular);
'use strict';

var cov_14jct53plk = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/html/menuBtn/menuBtn.js',
        hash = 'cae9e966e41e99e1160e257a81bc25ca2d28b674',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/html/menuBtn/menuBtn.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 7,
                    column: 12
                },
                end: {
                    line: 7,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 39
                }
            },
            '4': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 40
                }
            },
            '5': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 25,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 42
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 33
                    },
                    end: {
                        line: 6,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 39
                    },
                    end: {
                        line: 8,
                        column: 9
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 4
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 15
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 15,
                        column: 4
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 16
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 15
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MenuBtnController = function () {
    MenuBtnController.$inject = ["$mdSidenav", "$transitions"];
    function MenuBtnController($mdSidenav, $transitions) {
        var _this = this;

        _classCallCheck(this, MenuBtnController);

        cov_14jct53plk.f[0]++;
        cov_14jct53plk.s[0]++;

        this.$mdSidenav = $mdSidenav;

        cov_14jct53plk.s[1]++;
        $transitions.onStart({}, function () {
            cov_14jct53plk.f[1]++;
            cov_14jct53plk.s[2]++;

            _this.closeMenu();
        });
    }

    _createClass(MenuBtnController, [{
        key: 'openMenu',
        value: function openMenu() {
            cov_14jct53plk.f[2]++;
            cov_14jct53plk.s[3]++;

            this.$mdSidenav('menu').open();
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            cov_14jct53plk.f[3]++;
            cov_14jct53plk.s[4]++;

            this.$mdSidenav('menu').close();
        }
    }]);

    return MenuBtnController;
}();

cov_14jct53plk.s[5]++;


angular.module('app').component('menuBtn', {
    templateUrl: 'app/shared/html/menuBtn/menuBtn.html',
    controller: MenuBtnController
});
'use strict';

var cov_iovf372ef = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/users/membersList/membersList.js',
        hash = '51e0259fbcf55d2a05e66f01fd9b75824f6249d5',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/users/membersList/membersList.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 35
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 12
                },
                end: {
                    line: 12,
                    column: 15
                }
            },
            '3': {
                start: {
                    line: 9,
                    column: 16
                },
                end: {
                    line: 9,
                    column: 94
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 16
                },
                end: {
                    line: 11,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 31
                }
            },
            '6': {
                start: {
                    line: 19,
                    column: 22
                },
                end: {
                    line: 28,
                    column: 9
                }
            },
            '7': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 39,
                    column: 9
                }
            },
            '8': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 56
                }
            },
            '9': {
                start: {
                    line: 32,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 22
                }
            },
            '10': {
                start: {
                    line: 34,
                    column: 16
                },
                end: {
                    line: 34,
                    column: 56
                }
            },
            '11': {
                start: {
                    line: 35,
                    column: 16
                },
                end: {
                    line: 35,
                    column: 22
                }
            },
            '12': {
                start: {
                    line: 37,
                    column: 16
                },
                end: {
                    line: 37,
                    column: 56
                }
            },
            '13': {
                start: {
                    line: 38,
                    column: 16
                },
                end: {
                    line: 38,
                    column: 22
                }
            },
            '14': {
                start: {
                    line: 41,
                    column: 8
                },
                end: {
                    line: 43,
                    column: 9
                }
            },
            '15': {
                start: {
                    line: 42,
                    column: 12
                },
                end: {
                    line: 42,
                    column: 41
                }
            },
            '16': {
                start: {
                    line: 45,
                    column: 8
                },
                end: {
                    line: 47,
                    column: 9
                }
            },
            '17': {
                start: {
                    line: 46,
                    column: 12
                },
                end: {
                    line: 46,
                    column: 45
                }
            },
            '18': {
                start: {
                    line: 49,
                    column: 8
                },
                end: {
                    line: 51,
                    column: 9
                }
            },
            '19': {
                start: {
                    line: 50,
                    column: 12
                },
                end: {
                    line: 50,
                    column: 43
                }
            },
            '20': {
                start: {
                    line: 53,
                    column: 8
                },
                end: {
                    line: 53,
                    column: 39
                }
            },
            '21': {
                start: {
                    line: 54,
                    column: 8
                },
                end: {
                    line: 54,
                    column: 32
                }
            },
            '22': {
                start: {
                    line: 58,
                    column: 8
                },
                end: {
                    line: 58,
                    column: 29
                }
            },
            '23': {
                start: {
                    line: 59,
                    column: 8
                },
                end: {
                    line: 59,
                    column: 30
                }
            },
            '24': {
                start: {
                    line: 63,
                    column: 8
                },
                end: {
                    line: 63,
                    column: 33
                }
            },
            '25': {
                start: {
                    line: 67,
                    column: 8
                },
                end: {
                    line: 67,
                    column: 61
                }
            },
            '26': {
                start: {
                    line: 67,
                    column: 42
                },
                end: {
                    line: 67,
                    column: 49
                }
            },
            '27': {
                start: {
                    line: 71,
                    column: 0
                },
                end: {
                    line: 79,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 27
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 4
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 17
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 7,
                        column: 124
                    },
                    end: {
                        line: 7,
                        column: 125
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 130
                    },
                    end: {
                        line: 13,
                        column: 9
                    }
                },
                line: 7
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 8,
                        column: 62
                    },
                    end: {
                        line: 8,
                        column: 63
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 68
                    },
                    end: {
                        line: 10,
                        column: 13
                    }
                },
                line: 8
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 21
                    },
                    end: {
                        line: 12,
                        column: 13
                    }
                },
                line: 10
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 16,
                        column: 4
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 23
                    },
                    end: {
                        line: 55,
                        column: 5
                    }
                },
                line: 16
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 57,
                        column: 4
                    },
                    end: {
                        line: 57,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 15
                    },
                    end: {
                        line: 60,
                        column: 5
                    }
                },
                line: 57
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 62,
                        column: 4
                    },
                    end: {
                        line: 62,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 62,
                        column: 14
                    },
                    end: {
                        line: 64,
                        column: 5
                    }
                },
                line: 62
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 66,
                        column: 4
                    },
                    end: {
                        line: 66,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 66,
                        column: 17
                    },
                    end: {
                        line: 68,
                        column: 5
                    }
                },
                line: 66
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 67,
                        column: 32
                    },
                    end: {
                        line: 67,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 67,
                        column: 42
                    },
                    end: {
                        line: 67,
                        column: 49
                    }
                },
                line: 67
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 29,
                        column: 8
                    },
                    end: {
                        line: 39,
                        column: 9
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 30,
                        column: 12
                    },
                    end: {
                        line: 32,
                        column: 22
                    }
                }, {
                    start: {
                        line: 33,
                        column: 12
                    },
                    end: {
                        line: 35,
                        column: 22
                    }
                }, {
                    start: {
                        line: 36,
                        column: 12
                    },
                    end: {
                        line: 38,
                        column: 22
                    }
                }],
                line: 29
            },
            '1': {
                loc: {
                    start: {
                        line: 41,
                        column: 8
                    },
                    end: {
                        line: 43,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 41,
                        column: 8
                    },
                    end: {
                        line: 43,
                        column: 9
                    }
                }, {
                    start: {
                        line: 41,
                        column: 8
                    },
                    end: {
                        line: 43,
                        column: 9
                    }
                }],
                line: 41
            },
            '2': {
                loc: {
                    start: {
                        line: 45,
                        column: 8
                    },
                    end: {
                        line: 47,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 45,
                        column: 8
                    },
                    end: {
                        line: 47,
                        column: 9
                    }
                }, {
                    start: {
                        line: 45,
                        column: 8
                    },
                    end: {
                        line: 47,
                        column: 9
                    }
                }],
                line: 45
            },
            '3': {
                loc: {
                    start: {
                        line: 49,
                        column: 8
                    },
                    end: {
                        line: 51,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 49,
                        column: 8
                    },
                    end: {
                        line: 51,
                        column: 9
                    }
                }, {
                    start: {
                        line: 49,
                        column: 8
                    },
                    end: {
                        line: 51,
                        column: 9
                    }
                }],
                line: 49
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        b: {
            '0': [0, 0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MembersListController = function () {
    MembersListController.$inject = ["$mdDialog"];
    function MembersListController($mdDialog) {
        _classCallCheck(this, MembersListController);

        cov_iovf372ef.f[0]++;
        cov_iovf372ef.s[0]++;

        this.$mdDialog = $mdDialog;
    }

    _createClass(MembersListController, [{
        key: 'changeInfo',
        value: function changeInfo() {
            var _this = this;

            cov_iovf372ef.f[1]++;
            cov_iovf372ef.s[1]++;

            this.member.$save(['name', 'email', 'address', 'zip_code', 'locality', 'cellphone', 'cc', 'nif', 'birthday']).$then(function () {
                cov_iovf372ef.f[2]++;
                cov_iovf372ef.s[2]++;

                _this.AuthService.refreshAuthenticatedInfo().$then(function () {
                    cov_iovf372ef.f[3]++;
                    cov_iovf372ef.s[3]++;

                    _this.$mdToast.show(_this.$mdToast.simple().textContent('Perfil actualizado!'));
                }, function () {
                    cov_iovf372ef.f[4]++;
                    cov_iovf372ef.s[4]++;

                    _this.$state.go('logout');
                });
            });
        }
    }, {
        key: 'updateMembers',
        value: function updateMembers(all) {
            cov_iovf372ef.f[5]++;
            cov_iovf372ef.s[5]++;

            this.members.$page = 1;

            var filters = (cov_iovf372ef.s[6]++, {
                'search': this.memberName,
                'gender': this.memberGender,
                'birthday__gt': this.deBirthday,
                'birthday__lt': this.ateBirthday,
                'admission_date__gt': this.deAdmission,
                'admission_date__lt': this.ateAdmission,
                // 'type__in': 'GROUP,MEMBER',
                'ordering': 'member_id'
            });
            cov_iovf372ef.s[7]++;
            switch (this.associationStateFilter) {
                case 'REGULAR':
                    cov_iovf372ef.b[0][0]++;
                    cov_iovf372ef.s[8]++;

                    filters['quotas_state__in'] = 'REGULAR';
                    cov_iovf372ef.s[9]++;
                    break;
                case 'PENDING':
                    cov_iovf372ef.b[0][1]++;
                    cov_iovf372ef.s[10]++;

                    filters['quotas_state__in'] = 'PENDING';
                    cov_iovf372ef.s[11]++;
                    break;
                case 'UNKNOWN':
                    cov_iovf372ef.b[0][2]++;
                    cov_iovf372ef.s[12]++;

                    filters['quotas_state__in'] = 'UNKNOWN';
                    cov_iovf372ef.s[13]++;
                    break;
            }

            cov_iovf372ef.s[14]++;
            if (this.showOnlyMembersWithNotes) {
                cov_iovf372ef.b[1][0]++;
                cov_iovf372ef.s[15]++;

                filters['notes__isnull'] = 3;
            } else {
                cov_iovf372ef.b[1][1]++;
            }

            cov_iovf372ef.s[16]++;
            if (this.showOnlyMembersWithoutMemberId) {
                cov_iovf372ef.b[2][0]++;
                cov_iovf372ef.s[17]++;

                filters['member_id__isnull'] = 2;
            } else {
                cov_iovf372ef.b[2][1]++;
            }

            cov_iovf372ef.s[18]++;
            if (all) {
                cov_iovf372ef.b[3][0]++;
                cov_iovf372ef.s[19]++;

                filters['page_size'] = 9999999;
            } else {
                cov_iovf372ef.b[3][1]++;
            }

            cov_iovf372ef.s[20]++;
            this.members.$params = filters;
            cov_iovf372ef.s[21]++;
            this.members.$refresh();
        }
    }, {
        key: 'loadMore',
        value: function loadMore() {
            cov_iovf372ef.f[6]++;
            cov_iovf372ef.s[22]++;

            this.members.$page++;
            cov_iovf372ef.s[23]++;
            this.members.$fetch();
        }
    }, {
        key: 'loadAll',
        value: function loadAll() {
            cov_iovf372ef.f[7]++;
            cov_iovf372ef.s[24]++;

            this.updateMembers(true);
        }
    }, {
        key: 'getUserIds',
        value: function getUserIds() {
            cov_iovf372ef.f[8]++;
            cov_iovf372ef.s[25]++;

            return this.members.map(function (user) {
                cov_iovf372ef.f[9]++;
                cov_iovf372ef.s[26]++;
                return user.id;
            }).join(',');
        }
    }]);

    return MembersListController;
}();

cov_iovf372ef.s[27]++;


angular.module('app').component('membersList', {
    templateUrl: 'app/components/users/membersList/membersList.html',
    controller: MembersListController,
    bindings: {
        members: '<'
    }
});
'use strict';

var cov_2r9nqu5dcg = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/users/editProfile/editProfile.js',
        hash = '8bcbd941df4dcfb81846007f9e88241d0a0657e4',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/users/editProfile/editProfile.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 33
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 39
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 53
                }
            },
            '4': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 62
                }
            },
            '5': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 37
                }
            },
            '6': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 11
                }
            },
            '7': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 19,
                    column: 13
                }
            },
            '8': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 17,
                    column: 19
                }
            },
            '9': {
                start: {
                    line: 13,
                    column: 20
                },
                end: {
                    line: 13,
                    column: 110
                }
            },
            '10': {
                start: {
                    line: 14,
                    column: 20
                },
                end: {
                    line: 14,
                    column: 59
                }
            },
            '11': {
                start: {
                    line: 16,
                    column: 20
                },
                end: {
                    line: 16,
                    column: 94
                }
            },
            '12': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 11
                }
            },
            '13': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 15
                }
            },
            '14': {
                start: {
                    line: 26,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 19
                }
            },
            '15': {
                start: {
                    line: 29,
                    column: 20
                },
                end: {
                    line: 31,
                    column: 21
                }
            },
            '16': {
                start: {
                    line: 30,
                    column: 24
                },
                end: {
                    line: 30,
                    column: 50
                }
            },
            '17': {
                start: {
                    line: 38,
                    column: 8
                },
                end: {
                    line: 45,
                    column: 9
                }
            },
            '18': {
                start: {
                    line: 39,
                    column: 12
                },
                end: {
                    line: 42,
                    column: 15
                }
            },
            '19': {
                start: {
                    line: 44,
                    column: 12
                },
                end: {
                    line: 44,
                    column: 50
                }
            },
            '20': {
                start: {
                    line: 49,
                    column: 8
                },
                end: {
                    line: 55,
                    column: 11
                }
            },
            '21': {
                start: {
                    line: 50,
                    column: 12
                },
                end: {
                    line: 54,
                    column: 15
                }
            },
            '22': {
                start: {
                    line: 51,
                    column: 16
                },
                end: {
                    line: 51,
                    column: 94
                }
            },
            '23': {
                start: {
                    line: 53,
                    column: 16
                },
                end: {
                    line: 53,
                    column: 41
                }
            },
            '24': {
                start: {
                    line: 59,
                    column: 8
                },
                end: {
                    line: 62,
                    column: 11
                }
            },
            '25': {
                start: {
                    line: 60,
                    column: 12
                },
                end: {
                    line: 60,
                    column: 94
                }
            },
            '26': {
                start: {
                    line: 61,
                    column: 12
                },
                end: {
                    line: 61,
                    column: 67
                }
            },
            '27': {
                start: {
                    line: 66,
                    column: 0
                },
                end: {
                    line: 74,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 109
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 10,
                        column: 43
                    },
                    end: {
                        line: 10,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 49
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                },
                line: 10
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 50
                    },
                    end: {
                        line: 12,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 56
                    },
                    end: {
                        line: 15,
                        column: 17
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 15,
                        column: 19
                    },
                    end: {
                        line: 15,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 25
                    },
                    end: {
                        line: 17,
                        column: 17
                    }
                },
                line: 15
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 23,
                        column: 4
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 14
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 23
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 24,
                        column: 35
                    },
                    end: {
                        line: 24,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 51
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                },
                line: 24
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 25,
                        column: 31
                    },
                    end: {
                        line: 25,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 45
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                line: 25
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 28,
                        column: 40
                    },
                    end: {
                        line: 28,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 57
                    },
                    end: {
                        line: 32,
                        column: 17
                    }
                },
                line: 28
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 37,
                        column: 4
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 33
                    },
                    end: {
                        line: 46,
                        column: 5
                    }
                },
                line: 37
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 48,
                        column: 4
                    },
                    end: {
                        line: 48,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 48,
                        column: 17
                    },
                    end: {
                        line: 56,
                        column: 5
                    }
                },
                line: 48
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 49,
                        column: 133
                    },
                    end: {
                        line: 49,
                        column: 134
                    }
                },
                loc: {
                    start: {
                        line: 49,
                        column: 139
                    },
                    end: {
                        line: 55,
                        column: 9
                    }
                },
                line: 49
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 50,
                        column: 62
                    },
                    end: {
                        line: 50,
                        column: 63
                    }
                },
                loc: {
                    start: {
                        line: 50,
                        column: 68
                    },
                    end: {
                        line: 52,
                        column: 13
                    }
                },
                line: 50
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 52,
                        column: 15
                    },
                    end: {
                        line: 52,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 21
                    },
                    end: {
                        line: 54,
                        column: 13
                    }
                },
                line: 52
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 58,
                        column: 4
                    },
                    end: {
                        line: 58,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 58,
                        column: 17
                    },
                    end: {
                        line: 63,
                        column: 5
                    }
                },
                line: 58
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 59,
                        column: 64
                    },
                    end: {
                        line: 59,
                        column: 65
                    }
                },
                loc: {
                    start: {
                        line: 59,
                        column: 70
                    },
                    end: {
                        line: 62,
                        column: 9
                    }
                },
                line: 59
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 19,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 19,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 19,
                        column: 13
                    }
                }],
                line: 11
            },
            '1': {
                loc: {
                    start: {
                        line: 11,
                        column: 16
                    },
                    end: {
                        line: 11,
                        column: 94
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 11,
                        column: 16
                    },
                    end: {
                        line: 11,
                        column: 50
                    }
                }, {
                    start: {
                        line: 11,
                        column: 54
                    },
                    end: {
                        line: 11,
                        column: 94
                    }
                }],
                line: 11
            },
            '2': {
                loc: {
                    start: {
                        line: 29,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 29,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                }, {
                    start: {
                        line: 29,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                }],
                line: 29
            },
            '3': {
                loc: {
                    start: {
                        line: 38,
                        column: 8
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 38,
                        column: 8
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                }, {
                    start: {
                        line: 38,
                        column: 8
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                }],
                line: 38
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditProfileController = function () {
    EditProfileController.$inject = ["$mdToast", "AuthService", "$state", "$rootScope", "$scope", "EventCategoriesTable", "UserInterestsTable"];
    function EditProfileController($mdToast, AuthService, $state, $rootScope, $scope, EventCategoriesTable, UserInterestsTable) {
        var _this = this;

        _classCallCheck(this, EditProfileController);

        cov_2r9nqu5dcg.f[0]++;
        cov_2r9nqu5dcg.s[0]++;

        this.$mdToast = $mdToast;
        cov_2r9nqu5dcg.s[1]++;
        this.AuthService = AuthService;
        cov_2r9nqu5dcg.s[2]++;
        this.$state = $state;
        cov_2r9nqu5dcg.s[3]++;
        this.UserInterestsTable = UserInterestsTable;
        cov_2r9nqu5dcg.s[4]++;
        this.eventCategories = EventCategoriesTable.$search();
        cov_2r9nqu5dcg.s[5]++;
        this.$rootScope = $rootScope;

        cov_2r9nqu5dcg.s[6]++;
        $scope.$watch('$ctrl.user.avatar', function () {
            cov_2r9nqu5dcg.f[1]++;
            cov_2r9nqu5dcg.s[7]++;

            if ((cov_2r9nqu5dcg.b[1][0]++, angular.isString(_this.user.avatar)) && (cov_2r9nqu5dcg.b[1][1]++, _this.user.avatar != $rootScope.me.avatar)) {
                cov_2r9nqu5dcg.b[0][0]++;
                cov_2r9nqu5dcg.s[8]++;

                _this.user.$save(['avatar']).$then(function () {
                    cov_2r9nqu5dcg.f[2]++;
                    cov_2r9nqu5dcg.s[9]++;

                    $mdToast.show($mdToast.simple().textContent(gettext('Imagem de perfil foi atualizada!')));
                    cov_2r9nqu5dcg.s[10]++;
                    AuthService.refreshAuthenticatedInfo();
                }, function () {
                    cov_2r9nqu5dcg.f[3]++;
                    cov_2r9nqu5dcg.s[11]++;

                    $mdToast.show($mdToast.simple().textContent(gettext('Ocorreu um erro!')));
                });
            } else {
                cov_2r9nqu5dcg.b[0][1]++;
            }
        });
    }

    _createClass(EditProfileController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            cov_2r9nqu5dcg.f[4]++;
            cov_2r9nqu5dcg.s[12]++;

            this.eventCategories.$then(function (categories) {
                cov_2r9nqu5dcg.f[5]++;
                cov_2r9nqu5dcg.s[13]++;

                categories.forEach(function (category) {
                    cov_2r9nqu5dcg.f[6]++;
                    cov_2r9nqu5dcg.s[14]++;

                    category.$load('userInterests', {
                        user: _this2.$rootScope.me.id
                    }).$userInterests.$then(function (preferences) {
                        cov_2r9nqu5dcg.f[7]++;
                        cov_2r9nqu5dcg.s[15]++;

                        if (preferences.length) {
                            cov_2r9nqu5dcg.b[2][0]++;
                            cov_2r9nqu5dcg.s[16]++;

                            category.isChecked = true;
                        } else {
                            cov_2r9nqu5dcg.b[2][1]++;
                        }
                    });
                });
            });
        }
    }, {
        key: 'changeUserCategory',
        value: function changeUserCategory(category) {
            cov_2r9nqu5dcg.f[8]++;
            cov_2r9nqu5dcg.s[17]++;

            if (category.isChecked) {
                cov_2r9nqu5dcg.b[3][0]++;
                cov_2r9nqu5dcg.s[18]++;

                category.$userInterests.$create({
                    user: this.$rootScope.me.id,
                    'event_category': category.id
                });
            } else {
                cov_2r9nqu5dcg.b[3][1]++;
                cov_2r9nqu5dcg.s[19]++;

                category.$userInterests[0].$destroy();
            }
        }
    }, {
        key: 'changeInfo',
        value: function changeInfo() {
            var _this3 = this;

            cov_2r9nqu5dcg.f[9]++;
            cov_2r9nqu5dcg.s[20]++;

            this.user.$save(['name', 'email', 'address', 'zipCode', 'zip_code', 'location', 'cellphone', 'cc', 'nif', 'birthday']).$then(function () {
                cov_2r9nqu5dcg.f[10]++;
                cov_2r9nqu5dcg.s[21]++;

                _this3.AuthService.refreshAuthenticatedInfo().$then(function () {
                    cov_2r9nqu5dcg.f[11]++;
                    cov_2r9nqu5dcg.s[22]++;

                    _this3.$mdToast.show(_this3.$mdToast.simple().textContent('Perfil actualizado!'));
                }, function () {
                    cov_2r9nqu5dcg.f[12]++;
                    cov_2r9nqu5dcg.s[23]++;

                    _this3.$state.go('logout');
                });
            });
        }
    }, {
        key: 'changePass',
        value: function changePass() {
            var _this4 = this;

            cov_2r9nqu5dcg.f[13]++;
            cov_2r9nqu5dcg.s[24]++;

            this.user.$save(['password', 'confirm_password']).$then(function () {
                cov_2r9nqu5dcg.f[14]++;
                cov_2r9nqu5dcg.s[25]++;

                _this4.$mdToast.show(_this4.$mdToast.simple().textContent('Palavra-passe alterada!'));
                cov_2r9nqu5dcg.s[26]++;
                _this4.user.password = _this4.user.confirm_password = null;
            });
        }
    }]);

    return EditProfileController;
}();

cov_2r9nqu5dcg.s[27]++;


angular.module('app').component('editProfile', {
    templateUrl: 'app/components/users/editProfile/editProfile.html',
    controller: EditProfileController,
    bindings: {
        user: '<'
    }
});
'use strict';

var cov_1i1d7m3gkg = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/users/memberDetails/memberDetails.js',
        hash = '2c1660a1493eeefba76a04f3d2c760da105293b3',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/users/memberDetails/memberDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 49
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 32
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 34
                }
            },
            '3': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 11
                }
            },
            '4': {
                start: {
                    line: 9,
                    column: 12
                },
                end: {
                    line: 13,
                    column: 13
                }
            },
            '5': {
                start: {
                    line: 10,
                    column: 16
                },
                end: {
                    line: 10,
                    column: 111
                }
            },
            '6': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 12,
                    column: 45
                }
            },
            '7': {
                start: {
                    line: 18,
                    column: 22
                },
                end: {
                    line: 21,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 11
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 12
                },
                end: {
                    line: 24,
                    column: 35
                }
            },
            '10': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 37,
                    column: 11
                }
            },
            '12': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 36,
                    column: 15
                }
            },
            '13': {
                start: {
                    line: 33,
                    column: 16
                },
                end: {
                    line: 33,
                    column: 94
                }
            },
            '14': {
                start: {
                    line: 35,
                    column: 16
                },
                end: {
                    line: 35,
                    column: 41
                }
            },
            '15': {
                start: {
                    line: 41,
                    column: 21
                },
                end: {
                    line: 41,
                    column: 41
                }
            },
            '16': {
                start: {
                    line: 43,
                    column: 8
                },
                end: {
                    line: 45,
                    column: 11
                }
            },
            '17': {
                start: {
                    line: 44,
                    column: 12
                },
                end: {
                    line: 44,
                    column: 90
                }
            },
            '18': {
                start: {
                    line: 49,
                    column: 0
                },
                end: {
                    line: 57,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 73
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 54
                    },
                    end: {
                        line: 8,
                        column: 55
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 72
                    },
                    end: {
                        line: 14,
                        column: 9
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 17,
                        column: 4
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 20
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                line: 17
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 23,
                        column: 42
                    },
                    end: {
                        line: 23,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 48
                    },
                    end: {
                        line: 25,
                        column: 9
                    }
                },
                line: 23
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 28,
                        column: 4
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 22
                    },
                    end: {
                        line: 38,
                        column: 5
                    }
                },
                line: 28
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 31,
                        column: 41
                    },
                    end: {
                        line: 31,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 31,
                        column: 47
                    },
                    end: {
                        line: 37,
                        column: 9
                    }
                },
                line: 31
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 32,
                        column: 62
                    },
                    end: {
                        line: 32,
                        column: 63
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 68
                    },
                    end: {
                        line: 34,
                        column: 13
                    }
                },
                line: 32
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 34,
                        column: 15
                    },
                    end: {
                        line: 34,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 21
                    },
                    end: {
                        line: 36,
                        column: 13
                    }
                },
                line: 34
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 40,
                        column: 4
                    },
                    end: {
                        line: 40,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 11
                    },
                    end: {
                        line: 46,
                        column: 5
                    }
                },
                line: 40
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 43,
                        column: 40
                    },
                    end: {
                        line: 43,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 43,
                        column: 46
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                },
                line: 43
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                }, {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                }],
                line: 9
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MemberDetailsController = function () {
    MemberDetailsController.$inject = ["UserTypesTable", "$mdToast", "$mdDialog", "$scope", "$rootScope"];
    function MemberDetailsController(UserTypesTable, $mdToast, $mdDialog, $scope, $rootScope) {
        _classCallCheck(this, MemberDetailsController);

        cov_1i1d7m3gkg.f[0]++;
        cov_1i1d7m3gkg.s[0]++;

        this.userTypes = UserTypesTable.$search();
        cov_1i1d7m3gkg.s[1]++;
        this.$mdToast = $mdToast;
        cov_1i1d7m3gkg.s[2]++;
        this.$mdDialog = $mdDialog;

        cov_1i1d7m3gkg.s[3]++;
        $scope.$watch('$ctrl.member.$dirty().length', function (length) {
            cov_1i1d7m3gkg.f[1]++;
            cov_1i1d7m3gkg.s[4]++;

            if (length) {
                cov_1i1d7m3gkg.b[0][0]++;
                cov_1i1d7m3gkg.s[5]++;

                $rootScope.preventNavigation("As alterações não foram gravadas. Têm certeza que deseja sair?");
            } else {
                cov_1i1d7m3gkg.b[0][1]++;
                cov_1i1d7m3gkg.s[6]++;

                $rootScope.allowNavigation();
            }
        });
    }

    _createClass(MemberDetailsController, [{
        key: 'unlockEditing',
        value: function unlockEditing() {
            var _this = this;

            cov_1i1d7m3gkg.f[2]++;

            var confirm = (cov_1i1d7m3gkg.s[7]++, this.$mdDialog.confirm().title('Tem certeza que deseja desbloquear a edição?').ok('Desbloquear').cancel('Cancelar'));

            cov_1i1d7m3gkg.s[8]++;
            this.$mdDialog.show(confirm).then(function () {
                cov_1i1d7m3gkg.f[3]++;
                cov_1i1d7m3gkg.s[9]++;

                _this.isUnlocked = true;
            });
        }
    }, {
        key: 'changeInfo',
        value: function changeInfo(field) {
            var _this2 = this;

            cov_1i1d7m3gkg.f[4]++;
            cov_1i1d7m3gkg.s[10]++;

            return; // Auto save is disabled at this moment

            cov_1i1d7m3gkg.s[11]++;
            this.member.$save([field]).$then(function () {
                cov_1i1d7m3gkg.f[5]++;
                cov_1i1d7m3gkg.s[12]++;

                _this2.AuthService.refreshAuthenticatedInfo().$then(function () {
                    cov_1i1d7m3gkg.f[6]++;
                    cov_1i1d7m3gkg.s[13]++;

                    _this2.$mdToast.show(_this2.$mdToast.simple().textContent('Perfil actualizado!'));
                }, function () {
                    cov_1i1d7m3gkg.f[7]++;
                    cov_1i1d7m3gkg.s[14]++;

                    _this2.$state.go('logout');
                });
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this3 = this;

            cov_1i1d7m3gkg.f[8]++;

            var fields = (cov_1i1d7m3gkg.s[15]++, this.member.$dirty());

            cov_1i1d7m3gkg.s[16]++;
            this.member.$save(fields).$then(function () {
                cov_1i1d7m3gkg.f[9]++;
                cov_1i1d7m3gkg.s[17]++;

                _this3.$mdToast.show(_this3.$mdToast.simple().textContent('Perfil actualizado!'));
            });
        }
    }]);

    return MemberDetailsController;
}();

cov_1i1d7m3gkg.s[18]++;


angular.module('app').component('memberDetails', {
    templateUrl: 'app/components/users/memberDetails/memberDetails.html',
    controller: MemberDetailsController,
    bindings: {
        member: '<'
    }
});
'use strict';

var cov_2dzjgl4ys2 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/users/adminsList/adminsList.js',
        hash = 'ff49db865a969948f3240b95548630d51a88f262',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/users/adminsList/adminsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 33
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 34
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 36
                }
            },
            '3': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 36
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 10
                }
            },
            '5': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 10
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 44
                }
            },
            '8': {
                start: {
                    line: 27,
                    column: 12
                },
                end: {
                    line: 27,
                    column: 73
                }
            },
            '9': {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 28,
                    column: 39
                }
            },
            '10': {
                start: {
                    line: 33,
                    column: 8
                },
                end: {
                    line: 37,
                    column: 10
                }
            },
            '11': {
                start: {
                    line: 34,
                    column: 12
                },
                end: {
                    line: 34,
                    column: 43
                }
            },
            '12': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 35,
                    column: 73
                }
            },
            '13': {
                start: {
                    line: 36,
                    column: 12
                },
                end: {
                    line: 36,
                    column: 39
                }
            },
            '14': {
                start: {
                    line: 41,
                    column: 22
                },
                end: {
                    line: 45,
                    column: 31
                }
            },
            '15': {
                start: {
                    line: 47,
                    column: 8
                },
                end: {
                    line: 49,
                    column: 11
                }
            },
            '16': {
                start: {
                    line: 48,
                    column: 12
                },
                end: {
                    line: 48,
                    column: 27
                }
            },
            '17': {
                start: {
                    line: 53,
                    column: 0
                },
                end: {
                    line: 62,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 37
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 14
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 4
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 27
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 18,
                        column: 4
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 27
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 18
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 24,
                        column: 4
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 21
                    },
                    end: {
                        line: 30,
                        column: 5
                    }
                },
                line: 24
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 25,
                        column: 41
                    },
                    end: {
                        line: 25,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 47
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                },
                line: 25
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 32,
                        column: 4
                    },
                    end: {
                        line: 32,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 20
                    },
                    end: {
                        line: 38,
                        column: 5
                    }
                },
                line: 32
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 33,
                        column: 40
                    },
                    end: {
                        line: 33,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 46
                    },
                    end: {
                        line: 37,
                        column: 9
                    }
                },
                line: 33
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 40,
                        column: 4
                    },
                    end: {
                        line: 40,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 21
                    },
                    end: {
                        line: 50,
                        column: 5
                    }
                },
                line: 40
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 47,
                        column: 42
                    },
                    end: {
                        line: 47,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 47,
                        column: 54
                    },
                    end: {
                        line: 49,
                        column: 9
                    }
                },
                line: 47
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminsListController = function () {
    AdminsListController.$inject = ["$mdToast", "$mdDialog"];
    function AdminsListController($mdToast, $mdDialog) {
        _classCallCheck(this, AdminsListController);

        cov_2dzjgl4ys2.f[0]++;
        cov_2dzjgl4ys2.s[0]++;

        this.$mdToast = $mdToast;
        cov_2dzjgl4ys2.s[1]++;
        this.$mdDialog = $mdDialog;
    }

    _createClass(AdminsListController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_2dzjgl4ys2.f[1]++;
            cov_2dzjgl4ys2.s[2]++;

            this._prepareNewAccoutant();
            cov_2dzjgl4ys2.s[3]++;
            this._prepareNewMarketeer();
        }
    }, {
        key: '_prepareNewAccoutant',
        value: function _prepareNewAccoutant() {
            cov_2dzjgl4ys2.f[2]++;
            cov_2dzjgl4ys2.s[4]++;

            this.newAccountant = this.accountants.$build({
                type: 'ACCOUNTANT'
            });
        }
    }, {
        key: '_prepareNewMarketeer',
        value: function _prepareNewMarketeer() {
            cov_2dzjgl4ys2.f[3]++;
            cov_2dzjgl4ys2.s[5]++;

            this.newMarketeer = this.marketeers.$build({
                type: 'MARKETEER'
            });
        }
    }, {
        key: 'saveAccountant',
        value: function saveAccountant() {
            var _this = this;

            cov_2dzjgl4ys2.f[4]++;
            cov_2dzjgl4ys2.s[6]++;

            this.newAccountant.$save().$then(function () {
                cov_2dzjgl4ys2.f[5]++;
                cov_2dzjgl4ys2.s[7]++;

                _this.creatingAccountant = false;
                cov_2dzjgl4ys2.s[8]++;
                _this.$mdToast.showSimple('Administrador criado com sucesso!');
                cov_2dzjgl4ys2.s[9]++;
                _this._prepareNewAccoutant();
            });
        }
    }, {
        key: 'saveMarketeer',
        value: function saveMarketeer() {
            var _this2 = this;

            cov_2dzjgl4ys2.f[6]++;
            cov_2dzjgl4ys2.s[10]++;

            this.newMarketeer.$save().$then(function () {
                cov_2dzjgl4ys2.f[7]++;
                cov_2dzjgl4ys2.s[11]++;

                _this2.creatingMarketeer = false;
                cov_2dzjgl4ys2.s[12]++;
                _this2.$mdToast.showSimple('Administrador criado com sucesso!');
                cov_2dzjgl4ys2.s[13]++;
                _this2._prepareNewMarketeer();
            });
        }
    }, {
        key: 'removeUser',
        value: function removeUser(user) {
            cov_2dzjgl4ys2.f[8]++;

            var confirm = (cov_2dzjgl4ys2.s[14]++, this.$mdDialog.confirm().title('Têm certeza que deseja remover esse administrador?').textContent('Essa ação é irreversível').ok('Remover').cancel('Cancelar'));

            cov_2dzjgl4ys2.s[15]++;
            this.$mdDialog.show(confirm).then(function () {
                cov_2dzjgl4ys2.f[9]++;
                cov_2dzjgl4ys2.s[16]++;

                user.$destroy();
            });
        }
    }]);

    return AdminsListController;
}();

cov_2dzjgl4ys2.s[17]++;


angular.module('app').component('adminsList', {
    templateUrl: 'app/components/users/adminsList/adminsList.html',
    controller: AdminsListController,
    bindings: {
        marketeers: '<',
        accountants: '<'
    }
});
'use strict';

var cov_1w3rnomo8a = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/strings.js',
        hash = 'ce00719f47f746906f4bac1b4a3e5d47e6f1fb06',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/strings.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 3,
                    column: 2
                }
            },
            '1': {
                start: {
                    line: 2,
                    column: 4
                },
                end: {
                    line: 2,
                    column: 42
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 0
                },
                end: {
                    line: 10,
                    column: 2
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 4
                },
                end: {
                    line: 9,
                    column: 7
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 49
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 2
                }
            },
            '6': {
                start: {
                    line: 14,
                    column: 4
                },
                end: {
                    line: 16,
                    column: 7
                }
            },
            '7': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 38
                }
            },
            '8': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 24,
                    column: 2
                }
            },
            '9': {
                start: {
                    line: 21,
                    column: 4
                },
                end: {
                    line: 23,
                    column: 7
                }
            },
            '10': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 38
                }
            },
            '11': {
                start: {
                    line: 26,
                    column: 0
                },
                end: {
                    line: 34,
                    column: 2
                }
            },
            '12': {
                start: {
                    line: 27,
                    column: 18
                },
                end: {
                    line: 27,
                    column: 36
                }
            },
            '13': {
                start: {
                    line: 28,
                    column: 16
                },
                end: {
                    line: 28,
                    column: 42
                }
            },
            '14': {
                start: {
                    line: 29,
                    column: 18
                },
                end: {
                    line: 29,
                    column: 61
                }
            },
            '15': {
                start: {
                    line: 31,
                    column: 4
                },
                end: {
                    line: 31,
                    column: 42
                }
            },
            '16': {
                start: {
                    line: 31,
                    column: 21
                },
                end: {
                    line: 31,
                    column: 41
                }
            },
            '17': {
                start: {
                    line: 32,
                    column: 4
                },
                end: {
                    line: 32,
                    column: 48
                }
            },
            '18': {
                start: {
                    line: 32,
                    column: 23
                },
                end: {
                    line: 32,
                    column: 47
                }
            },
            '19': {
                start: {
                    line: 33,
                    column: 4
                },
                end: {
                    line: 33,
                    column: 33
                }
            },
            '20': {
                start: {
                    line: 36,
                    column: 0
                },
                end: {
                    line: 46,
                    column: 2
                }
            },
            '21': {
                start: {
                    line: 37,
                    column: 18
                },
                end: {
                    line: 37,
                    column: 36
                }
            },
            '22': {
                start: {
                    line: 38,
                    column: 16
                },
                end: {
                    line: 38,
                    column: 42
                }
            },
            '23': {
                start: {
                    line: 39,
                    column: 18
                },
                end: {
                    line: 39,
                    column: 61
                }
            },
            '24': {
                start: {
                    line: 40,
                    column: 18
                },
                end: {
                    line: 40,
                    column: 59
                }
            },
            '25': {
                start: {
                    line: 42,
                    column: 4
                },
                end: {
                    line: 42,
                    column: 42
                }
            },
            '26': {
                start: {
                    line: 42,
                    column: 21
                },
                end: {
                    line: 42,
                    column: 41
                }
            },
            '27': {
                start: {
                    line: 43,
                    column: 4
                },
                end: {
                    line: 43,
                    column: 48
                }
            },
            '28': {
                start: {
                    line: 43,
                    column: 23
                },
                end: {
                    line: 43,
                    column: 47
                }
            },
            '29': {
                start: {
                    line: 44,
                    column: 4
                },
                end: {
                    line: 44,
                    column: 48
                }
            },
            '30': {
                start: {
                    line: 44,
                    column: 23
                },
                end: {
                    line: 44,
                    column: 47
                }
            },
            '31': {
                start: {
                    line: 45,
                    column: 4
                },
                end: {
                    line: 45,
                    column: 49
                }
            },
            '32': {
                start: {
                    line: 48,
                    column: 0
                },
                end: {
                    line: 55,
                    column: 2
                }
            },
            '33': {
                start: {
                    line: 49,
                    column: 18
                },
                end: {
                    line: 49,
                    column: 36
                }
            },
            '34': {
                start: {
                    line: 50,
                    column: 16
                },
                end: {
                    line: 50,
                    column: 42
                }
            },
            '35': {
                start: {
                    line: 51,
                    column: 18
                },
                end: {
                    line: 51,
                    column: 61
                }
            },
            '36': {
                start: {
                    line: 52,
                    column: 18
                },
                end: {
                    line: 52,
                    column: 59
                }
            },
            '37': {
                start: {
                    line: 54,
                    column: 4
                },
                end: {
                    line: 54,
                    column: 99
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 24
                    },
                    end: {
                        line: 1,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 36
                    },
                    end: {
                        line: 3,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 27
                    },
                    end: {
                        line: 6,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 39
                    },
                    end: {
                        line: 10,
                        column: 1
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 7,
                        column: 38
                    },
                    end: {
                        line: 7,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 52
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 7
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 13,
                        column: 26
                    },
                    end: {
                        line: 13,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 38
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 13
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 14,
                        column: 36
                    },
                    end: {
                        line: 14,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 50
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 14
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 20,
                        column: 32
                    },
                    end: {
                        line: 20,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 44
                    },
                    end: {
                        line: 24,
                        column: 1
                    }
                },
                line: 20
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 21,
                        column: 36
                    },
                    end: {
                        line: 21,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 50
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 21
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 26,
                        column: 26
                    },
                    end: {
                        line: 26,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 38
                    },
                    end: {
                        line: 34,
                        column: 1
                    }
                },
                line: 26
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 36,
                        column: 28
                    },
                    end: {
                        line: 36,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 40
                    },
                    end: {
                        line: 46,
                        column: 1
                    }
                },
                line: 36
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 48,
                        column: 29
                    },
                    end: {
                        line: 48,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 48,
                        column: 41
                    },
                    end: {
                        line: 55,
                        column: 1
                    }
                },
                line: 48
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 31,
                        column: 42
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 31,
                        column: 42
                    }
                }, {
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 31,
                        column: 42
                    }
                }],
                line: 31
            },
            '1': {
                loc: {
                    start: {
                        line: 32,
                        column: 4
                    },
                    end: {
                        line: 32,
                        column: 48
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 32,
                        column: 4
                    },
                    end: {
                        line: 32,
                        column: 48
                    }
                }, {
                    start: {
                        line: 32,
                        column: 4
                    },
                    end: {
                        line: 32,
                        column: 48
                    }
                }],
                line: 32
            },
            '2': {
                loc: {
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 42
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 42
                    }
                }, {
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 42
                    }
                }],
                line: 42
            },
            '3': {
                loc: {
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 48
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 48
                    }
                }, {
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 48
                    }
                }],
                line: 43
            },
            '4': {
                loc: {
                    start: {
                        line: 44,
                        column: 4
                    },
                    end: {
                        line: 44,
                        column: 48
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 44,
                        column: 4
                    },
                    end: {
                        line: 44,
                        column: 48
                    }
                }, {
                    start: {
                        line: 44,
                        column: 4
                    },
                    end: {
                        line: 44,
                        column: 48
                    }
                }],
                line: 44
            },
            '5': {
                loc: {
                    start: {
                        line: 54,
                        column: 12
                    },
                    end: {
                        line: 54,
                        column: 43
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 54,
                        column: 26
                    },
                    end: {
                        line: 54,
                        column: 38
                    }
                }, {
                    start: {
                        line: 54,
                        column: 41
                    },
                    end: {
                        line: 54,
                        column: 43
                    }
                }],
                line: 54
            },
            '6': {
                loc: {
                    start: {
                        line: 54,
                        column: 65
                    },
                    end: {
                        line: 54,
                        column: 97
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 54,
                        column: 79
                    },
                    end: {
                        line: 54,
                        column: 81
                    }
                }, {
                    start: {
                        line: 54,
                        column: 84
                    },
                    end: {
                        line: 54,
                        column: 97
                    }
                }],
                line: 54
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1w3rnomo8a.s[0]++;
String.prototype.trim = function () {
    cov_1w3rnomo8a.f[0]++;
    cov_1w3rnomo8a.s[1]++;

    return this.replace(/^\s+|\s+$/g, "");
};

//To Camel Case
cov_1w3rnomo8a.s[2]++;
String.prototype.toCamel = function () {
    cov_1w3rnomo8a.f[1]++;
    cov_1w3rnomo8a.s[3]++;

    return this.replace(/(\-[a-z])/g, function ($1) {
        cov_1w3rnomo8a.f[2]++;
        cov_1w3rnomo8a.s[4]++;

        return $1.toUpperCase().replace('-', '');
    });
};

//To Dashed from Camel Case
cov_1w3rnomo8a.s[5]++;
String.prototype.toDash = function () {
    cov_1w3rnomo8a.f[3]++;
    cov_1w3rnomo8a.s[6]++;

    return this.replace(/([A-Z])/g, function ($1) {
        cov_1w3rnomo8a.f[4]++;
        cov_1w3rnomo8a.s[7]++;

        return "-" + $1.toLowerCase();
    });
};

//To Underscore from Camel Case
cov_1w3rnomo8a.s[8]++;
String.prototype.toUnderscore = function () {
    cov_1w3rnomo8a.f[5]++;
    cov_1w3rnomo8a.s[9]++;

    return this.replace(/([A-Z])/g, function ($1) {
        cov_1w3rnomo8a.f[6]++;
        cov_1w3rnomo8a.s[10]++;

        return "_" + $1.toLowerCase();
    });
};

cov_1w3rnomo8a.s[11]++;
String.prototype.toHHMM = function () {
    cov_1w3rnomo8a.f[7]++;

    var sec_num = (cov_1w3rnomo8a.s[12]++, parseInt(this, 10)); // don't forget the second param
    var hours = (cov_1w3rnomo8a.s[13]++, Math.floor(sec_num / 3600));
    var minutes = (cov_1w3rnomo8a.s[14]++, Math.floor((sec_num - hours * 3600) / 60));

    cov_1w3rnomo8a.s[15]++;
    if (hours < 10) {
        cov_1w3rnomo8a.b[0][0]++;
        cov_1w3rnomo8a.s[16]++;
        hours = "0" + hours;
    } else {
        cov_1w3rnomo8a.b[0][1]++;
    }
    cov_1w3rnomo8a.s[17]++;
    if (minutes < 10) {
        cov_1w3rnomo8a.b[1][0]++;
        cov_1w3rnomo8a.s[18]++;
        minutes = "0" + minutes;
    } else {
        cov_1w3rnomo8a.b[1][1]++;
    }
    cov_1w3rnomo8a.s[19]++;
    return hours + ':' + minutes;
};

cov_1w3rnomo8a.s[20]++;
String.prototype.toHHMMSS = function () {
    cov_1w3rnomo8a.f[8]++;

    var sec_num = (cov_1w3rnomo8a.s[21]++, parseInt(this, 10)); // don't forget the second param
    var hours = (cov_1w3rnomo8a.s[22]++, Math.floor(sec_num / 3600));
    var minutes = (cov_1w3rnomo8a.s[23]++, Math.floor((sec_num - hours * 3600) / 60));
    var seconds = (cov_1w3rnomo8a.s[24]++, sec_num - hours * 3600 - minutes * 60);

    cov_1w3rnomo8a.s[25]++;
    if (hours < 10) {
        cov_1w3rnomo8a.b[2][0]++;
        cov_1w3rnomo8a.s[26]++;
        hours = "0" + hours;
    } else {
        cov_1w3rnomo8a.b[2][1]++;
    }
    cov_1w3rnomo8a.s[27]++;
    if (minutes < 10) {
        cov_1w3rnomo8a.b[3][0]++;
        cov_1w3rnomo8a.s[28]++;
        minutes = "0" + minutes;
    } else {
        cov_1w3rnomo8a.b[3][1]++;
    }
    cov_1w3rnomo8a.s[29]++;
    if (seconds < 10) {
        cov_1w3rnomo8a.b[4][0]++;
        cov_1w3rnomo8a.s[30]++;
        seconds = "0" + seconds;
    } else {
        cov_1w3rnomo8a.b[4][1]++;
    }
    cov_1w3rnomo8a.s[31]++;
    return hours + ':' + minutes + ':' + seconds;
};

cov_1w3rnomo8a.s[32]++;
String.prototype.toHhMmSSs = function () {
    cov_1w3rnomo8a.f[9]++;

    var sec_num = (cov_1w3rnomo8a.s[33]++, parseInt(this, 10)); // don't forget the second param
    var hours = (cov_1w3rnomo8a.s[34]++, Math.floor(sec_num / 3600));
    var minutes = (cov_1w3rnomo8a.s[35]++, Math.floor((sec_num - hours * 3600) / 60));
    var seconds = (cov_1w3rnomo8a.s[36]++, sec_num - hours * 3600 - minutes * 60);

    cov_1w3rnomo8a.s[37]++;
    return (hours > 0 ? (cov_1w3rnomo8a.b[5][0]++, hours + 'h ') : (cov_1w3rnomo8a.b[5][1]++, '')) + minutes + 'm ' + (hours > 0 ? (cov_1w3rnomo8a.b[6][0]++, '') : (cov_1w3rnomo8a.b[6][1]++, seconds + 's'));
};
'use strict';

var cov_yzb77vuup = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/reportNames.filter.js',
        hash = '5a14e9c40c7e2b338cec3ad89f738fa29785a1a3',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/reportNames.filter.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 19,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 44
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 26
                },
                end: {
                    line: 15,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 16,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 32
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 19,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'reportNames',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 27
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_yzb77vuup.s[0]++;
(function () {
    'use strict';

    cov_yzb77vuup.f[0]++;
    cov_yzb77vuup.s[1]++;
    angular.module('app').filter('reportNames', reportNames);

    /* @ngInject */
    function reportNames() {
        cov_yzb77vuup.f[1]++;
        cov_yzb77vuup.s[2]++;

        return function (value) {
            cov_yzb77vuup.f[2]++;

            var names = (cov_yzb77vuup.s[3]++, {
                NEW_MEMBERS: "Novos Associados",
                EXCLUDED_MEMBERS: "Associados Excluídos",
                DONATIONS: "Donativos"
            });
            cov_yzb77vuup.s[4]++;
            return names[value];
        };
    }
})();
'use strict';

var cov_p316518e2 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/preventLoss.js',
        hash = 'd1c708eef191dbcac230c1f4f4468814f43ea809',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/preventLoss.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 42,
                    column: 8
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 33
                },
                end: {
                    line: 5,
                    column: 38
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 36
                },
                end: {
                    line: 6,
                    column: 40
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 36
                },
                end: {
                    line: 7,
                    column: 40
                }
            },
            '4': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 10
                }
            },
            '5': {
                start: {
                    line: 10,
                    column: 12
                },
                end: {
                    line: 10,
                    column: 39
                }
            },
            '6': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 9
                }
            },
            '7': {
                start: {
                    line: 14,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 38
                }
            },
            '8': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 15,
                    column: 55
                }
            },
            '9': {
                start: {
                    line: 16,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 40
                }
            },
            '10': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 11
                }
            },
            '11': {
                start: {
                    line: 27,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 13
                }
            },
            '12': {
                start: {
                    line: 28,
                    column: 16
                },
                end: {
                    line: 28,
                    column: 36
                }
            },
            '13': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 45
                }
            },
            '14': {
                start: {
                    line: 35,
                    column: 8
                },
                end: {
                    line: 40,
                    column: 9
                }
            },
            '15': {
                start: {
                    line: 37,
                    column: 12
                },
                end: {
                    line: 39,
                    column: 13
                }
            },
            '16': {
                start: {
                    line: 38,
                    column: 16
                },
                end: {
                    line: 38,
                    column: 45
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 53
                    },
                    end: {
                        line: 3,
                        column: 54
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 100
                    },
                    end: {
                        line: 42,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 9,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 49
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 13,
                        column: 39
                    },
                    end: {
                        line: 13,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 109
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 13
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 19,
                        column: 33
                    },
                    end: {
                        line: 19,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 19,
                        column: 56
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 19
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 35,
                        column: 32
                    },
                    end: {
                        line: 35,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 44
                    },
                    end: {
                        line: 40,
                        column: 9
                    }
                },
                line: 35
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 13,
                        column: 49
                    },
                    end: {
                        line: 13,
                        column: 107
                    }
                },
                type: 'default-arg',
                locations: [{
                    start: {
                        line: 13,
                        column: 55
                    },
                    end: {
                        line: 13,
                        column: 107
                    }
                }],
                line: 13
            },
            '1': {
                loc: {
                    start: {
                        line: 27,
                        column: 12
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 27,
                        column: 12
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                }, {
                    start: {
                        line: 27,
                        column: 12
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                }],
                line: 27
            },
            '2': {
                loc: {
                    start: {
                        line: 27,
                        column: 16
                    },
                    end: {
                        line: 27,
                        column: 69
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 27,
                        column: 16
                    },
                    end: {
                        line: 27,
                        column: 34
                    }
                }, {
                    start: {
                        line: 27,
                        column: 38
                    },
                    end: {
                        line: 27,
                        column: 69
                    }
                }],
                line: 27
            },
            '3': {
                loc: {
                    start: {
                        line: 37,
                        column: 12
                    },
                    end: {
                        line: 39,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 37,
                        column: 12
                    },
                    end: {
                        line: 39,
                        column: 13
                    }
                }, {
                    start: {
                        line: 37,
                        column: 12
                    },
                    end: {
                        line: 39,
                        column: 13
                    }
                }],
                line: 37
            },
            '4': {
                loc: {
                    start: {
                        line: 37,
                        column: 16
                    },
                    end: {
                        line: 37,
                        column: 81
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 37,
                        column: 16
                    },
                    end: {
                        line: 37,
                        column: 34
                    }
                }, {
                    start: {
                        line: 37,
                        column: 38
                    },
                    end: {
                        line: 37,
                        column: 81
                    }
                }],
                line: 37
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_p316518e2.s[0]++;
angular.module('app').run(['$rootScope', '$location', '$transitions', function ($rootScope, $location, $transitions) {
    cov_p316518e2.f[0]++;


    var _preventNavigation = (cov_p316518e2.s[1]++, false);
    var _preventNavigationUrl = (cov_p316518e2.s[2]++, null);
    var _preventNavigationMsg = (cov_p316518e2.s[3]++, null);

    cov_p316518e2.s[4]++;
    $rootScope.allowNavigation = function () {
        cov_p316518e2.f[1]++;
        cov_p316518e2.s[5]++;

        _preventNavigation = false;
    };

    cov_p316518e2.s[6]++;
    $rootScope.preventNavigation = function () {
        var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_p316518e2.b[0][0]++, "You have unsaved changes, do you want to continue?");
        cov_p316518e2.f[2]++;
        cov_p316518e2.s[7]++;

        _preventNavigation = true;
        cov_p316518e2.s[8]++;
        _preventNavigationUrl = $location.absUrl();
        cov_p316518e2.s[9]++;
        _preventNavigationMsg = msg;
    };

    cov_p316518e2.s[10]++;
    $transitions.onStart({}, function ($transition) {
        cov_p316518e2.f[3]++;
        cov_p316518e2.s[11]++;


        // Allow navigation if our old url wasn't where we prevented navigation from
        /*if (_preventNavigationUrl != oldUrl || _preventNavigationUrl == null) {
            $rootScope.allowNavigation();
            return;
        }*/

        if ((cov_p316518e2.b[2][0]++, _preventNavigation) && (cov_p316518e2.b[2][1]++, !confirm(_preventNavigationMsg))) {
            cov_p316518e2.b[1][0]++;
            cov_p316518e2.s[12]++;

            $transition.abort();
        } else {
            cov_p316518e2.b[1][1]++;
            cov_p316518e2.s[13]++;

            $rootScope.allowNavigation();
        }
    });

    // Take care of preventing navigation out of our angular app
    cov_p316518e2.s[14]++;
    window.onbeforeunload = function () {
        cov_p316518e2.f[4]++;
        cov_p316518e2.s[15]++;

        // Use the same data that we've set in our angular app
        if ((cov_p316518e2.b[4][0]++, _preventNavigation) && (cov_p316518e2.b[4][1]++, $location.absUrl() == _preventNavigationUrl)) {
            cov_p316518e2.b[3][0]++;
            cov_p316518e2.s[16]++;

            return _preventNavigationMsg;
        } else {
            cov_p316518e2.b[3][1]++;
        }
    };
}]);
'use strict';

var cov_173nhyx2dg = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/contenteditable.directive.js',
        hash = 'cdb72ce45fdb6e6f84b0756b9c146e72d3e7a938',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/contenteditable.directive.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 27,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 3,
                    column: 4
                },
                end: {
                    line: 25,
                    column: 7
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 20
                },
                end: {
                    line: 12,
                    column: 58
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 20
                },
                end: {
                    line: 13,
                    column: 59
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 18,
                    column: 18
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 20
                },
                end: {
                    line: 17,
                    column: 59
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 19
                }
            },
            '8': {
                start: {
                    line: 21,
                    column: 20
                },
                end: {
                    line: 21,
                    column: 39
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 27,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 34
                    },
                    end: {
                        line: 5,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 46
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 5
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 9,
                        column: 18
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 60
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                },
                line: 9
            },
            '3': {
                name: 'read',
                decl: {
                    start: {
                        line: 11,
                        column: 25
                    },
                    end: {
                        line: 11,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 33
                    },
                    end: {
                        line: 14,
                        column: 17
                    }
                },
                line: 11
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 16,
                        column: 34
                    },
                    end: {
                        line: 16,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 46
                    },
                    end: {
                        line: 18,
                        column: 17
                    }
                },
                line: 16
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 20,
                        column: 50
                    },
                    end: {
                        line: 20,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 62
                    },
                    end: {
                        line: 22,
                        column: 17
                    }
                },
                line: 20
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 13,
                        column: 33
                    },
                    end: {
                        line: 13,
                        column: 57
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 13,
                        column: 33
                    },
                    end: {
                        line: 13,
                        column: 51
                    }
                }, {
                    start: {
                        line: 13,
                        column: 55
                    },
                    end: {
                        line: 13,
                        column: 57
                    }
                }],
                line: 13
            },
            '1': {
                loc: {
                    start: {
                        line: 17,
                        column: 33
                    },
                    end: {
                        line: 17,
                        column: 57
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 17,
                        column: 33
                    },
                    end: {
                        line: 17,
                        column: 51
                    }
                }, {
                    start: {
                        line: 17,
                        column: 55
                    },
                    end: {
                        line: 17,
                        column: 57
                    }
                }],
                line: 17
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_173nhyx2dg.s[0]++;
(function () {
    'use strict';

    cov_173nhyx2dg.f[0]++;
    cov_173nhyx2dg.s[1]++;
    angular.module('app').directive("contenteditable", function () {
        cov_173nhyx2dg.f[1]++;
        cov_173nhyx2dg.s[2]++;

        return {
            restrict: "A",
            require: "ngModel",
            link: function link(scope, element, attrs, ngModel) {
                cov_173nhyx2dg.f[2]++;


                function read() {
                    cov_173nhyx2dg.f[3]++;
                    cov_173nhyx2dg.s[3]++;

                    ngModel.$setViewValue(element.text());
                    cov_173nhyx2dg.s[4]++;
                    element.text((cov_173nhyx2dg.b[0][0]++, ngModel.$viewValue) || (cov_173nhyx2dg.b[0][1]++, ""));
                }

                cov_173nhyx2dg.s[5]++;
                ngModel.$render = function () {
                    cov_173nhyx2dg.f[4]++;
                    cov_173nhyx2dg.s[6]++;

                    element.text((cov_173nhyx2dg.b[1][0]++, ngModel.$viewValue) || (cov_173nhyx2dg.b[1][1]++, ""));
                };

                cov_173nhyx2dg.s[7]++;
                element.bind("blur keyup change", function () {
                    cov_173nhyx2dg.f[5]++;
                    cov_173nhyx2dg.s[8]++;

                    scope.$apply(read);
                });
            }
        };
    });
})();
'use strict';

var cov_15otv1kedo = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/yearFilterSelect/yearFilterSelect.js',
        hash = '587200182fb01bdc6beaceaf32edb5560279eafe',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/yearFilterSelect/yearFilterSelect.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 27
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 53
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 64
                }
            },
            '3': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 23
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 9
                }
            },
            '5': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 12,
                    column: 30
                }
            },
            '6': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 9
                }
            },
            '7': {
                start: {
                    line: 16,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 48
                }
            },
            '8': {
                start: {
                    line: 17,
                    column: 12
                },
                end: {
                    line: 19,
                    column: 13
                }
            },
            '9': {
                start: {
                    line: 18,
                    column: 16
                },
                end: {
                    line: 18,
                    column: 56
                }
            },
            '10': {
                start: {
                    line: 24,
                    column: 0
                },
                end: {
                    line: 34,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 14
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 7
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 8,
                        column: 27
                    },
                    end: {
                        line: 8,
                        column: 64
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 8,
                        column: 27
                    },
                    end: {
                        line: 8,
                        column: 43
                    }
                }, {
                    start: {
                        line: 8,
                        column: 47
                    },
                    end: {
                        line: 8,
                        column: 64
                    }
                }],
                line: 8
            },
            '1': {
                loc: {
                    start: {
                        line: 15,
                        column: 8
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 15,
                        column: 8
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                }, {
                    start: {
                        line: 15,
                        column: 8
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                }],
                line: 15
            },
            '2': {
                loc: {
                    start: {
                        line: 17,
                        column: 12
                    },
                    end: {
                        line: 19,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 17,
                        column: 12
                    },
                    end: {
                        line: 19,
                        column: 13
                    }
                }, {
                    start: {
                        line: 17,
                        column: 12
                    },
                    end: {
                        line: 19,
                        column: 13
                    }
                }],
                line: 17
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var YearFilterSelectController = function () {
    function YearFilterSelectController() {
        _classCallCheck(this, YearFilterSelectController);

        cov_15otv1kedo.f[0]++;
        cov_15otv1kedo.s[0]++;

        this.minYear = 1960;
        cov_15otv1kedo.s[1]++;
        this.maxYear = new Date().getFullYear() + 5;
    }

    _createClass(YearFilterSelectController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_15otv1kedo.f[1]++;
            cov_15otv1kedo.s[2]++;

            this.placeholder = (cov_15otv1kedo.b[0][0]++, this.placeholder) || (cov_15otv1kedo.b[0][1]++, 'Filtrar por ano');
            cov_15otv1kedo.s[3]++;
            this.years = [];

            cov_15otv1kedo.s[4]++;
            for (var i = this.maxYear; i >= this.minYear; i--) {
                cov_15otv1kedo.s[5]++;

                this.years.push(i);
            }

            cov_15otv1kedo.s[6]++;
            if (this.initialYear) {
                cov_15otv1kedo.b[1][0]++;
                cov_15otv1kedo.s[7]++;

                this.filterByYear = this.initialYear;
                cov_15otv1kedo.s[8]++;
                if (this.onChange) {
                    cov_15otv1kedo.b[2][0]++;
                    cov_15otv1kedo.s[9]++;

                    this.onChange({ year: this.filterByYear });
                } else {
                    cov_15otv1kedo.b[2][1]++;
                }
            } else {
                cov_15otv1kedo.b[1][1]++;
            }
        }
    }]);

    return YearFilterSelectController;
}();

cov_15otv1kedo.s[10]++;


angular.module('app').component('yearFilterSelect', {
    templateUrl: 'app/components/yearFilterSelect/yearFilterSelect.html',
    controller: YearFilterSelectController,
    bindings: {
        onChange: '&',
        placeholder: '@',
        initialYear: '<'
    }
});
'use strict';

var cov_1dtopt1gli = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/settingsView/settingsView.js',
        hash = '2aa185e02b7d1072fd3b21c9ddbdb515c82df5af',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/settingsView/settingsView.js',
        statementMap: {
            '0': {
                start: {
                    line: 6,
                    column: 0
                },
                end: {
                    line: 11,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                line: 2
            }
        },
        branchMap: {},
        s: {
            '0': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SettingsViewController = function SettingsViewController() {
    _classCallCheck(this, SettingsViewController);

    cov_1dtopt1gli.f[0]++;
};

cov_1dtopt1gli.s[0]++;


angular.module('app').component('settingsView', {
    templateUrl: 'app/components/settingsView/settingsView.html',
    controller: SettingsViewController
});
'use strict';

var cov_22zefez6tq = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/sendEmail/sendEmail.js',
        hash = '3b191a2fb9bda743e86a3ccd07e7f424647ef243',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/sendEmail/sendEmail.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 49
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 45
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 33
                }
            },
            '4': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 11
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 61
                }
            },
            '6': {
                start: {
                    line: 16,
                    column: 52
                },
                end: {
                    line: 16,
                    column: 59
                }
            },
            '7': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 11
                }
            },
            '8': {
                start: {
                    line: 18,
                    column: 12
                },
                end: {
                    line: 18,
                    column: 87
                }
            },
            '9': {
                start: {
                    line: 19,
                    column: 12
                },
                end: {
                    line: 19,
                    column: 53
                }
            },
            '10': {
                start: {
                    line: 24,
                    column: 0
                },
                end: {
                    line: 32,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 63
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 9,
                        column: 4
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 15
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 15,
                        column: 4
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 15
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 16,
                        column: 42
                    },
                    end: {
                        line: 16,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 52
                    },
                    end: {
                        line: 16,
                        column: 59
                    }
                },
                line: 16
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 17,
                        column: 33
                    },
                    end: {
                        line: 17,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 39
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                },
                line: 17
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SendEmailController = function () {
    SendEmailController.$inject = ["UsersTable", "SendemailTable", "$state", "$mdToast"];
    function SendEmailController(UsersTable, SendemailTable, $state, $mdToast) {
        _classCallCheck(this, SendEmailController);

        cov_22zefez6tq.f[0]++;
        cov_22zefez6tq.s[0]++;

        this.contacts = UsersTable.$collection();
        cov_22zefez6tq.s[1]++;
        this.email = SendemailTable.$build();
        cov_22zefez6tq.s[2]++;
        this.$state = $state;
        cov_22zefez6tq.s[3]++;
        this.$mdToast = $mdToast;
    }

    _createClass(SendEmailController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_22zefez6tq.f[1]++;
            cov_22zefez6tq.s[4]++;

            this.contacts.$refresh({
                'id__in': this.members
            });
        }
    }, {
        key: 'send',
        value: function send() {
            var _this = this;

            cov_22zefez6tq.f[2]++;
            cov_22zefez6tq.s[5]++;

            this.email.to = this.contacts.map(function (user) {
                cov_22zefez6tq.f[3]++;
                cov_22zefez6tq.s[6]++;
                return user.id;
            });
            cov_22zefez6tq.s[7]++;
            this.email.$save().$then(function () {
                cov_22zefez6tq.f[4]++;
                cov_22zefez6tq.s[8]++;

                _this.$mdToast.show(_this.$mdToast.simple().textContent(_this.email.message));
                cov_22zefez6tq.s[9]++;
                _this.$state.go('marketeers.membersList');
            });
        }
    }]);

    return SendEmailController;
}();

cov_22zefez6tq.s[10]++;


angular.module('app').component('sendEmail', {
    templateUrl: 'app/components/sendEmail//sendEmail.html',
    controller: SendEmailController,
    bindings: {
        members: '<'
    }
});
'use strict';

var cov_1824uqh44x = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/quotaSettingsView/quotaSettingsView.js',
        hash = '2bf7fbca0058b0e028e33b4ecd00330da33ac6ec',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/quotaSettingsView/quotaSettingsView.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 54
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 97
                }
            },
            '3': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 32
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 23
                },
                end: {
                    line: 25,
                    column: 9
                }
            },
            '5': {
                start: {
                    line: 18,
                    column: 16
                },
                end: {
                    line: 18,
                    column: 79
                }
            },
            '6': {
                start: {
                    line: 19,
                    column: 16
                },
                end: {
                    line: 19,
                    column: 41
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 36
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 27
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 21
                },
                end: {
                    line: 24,
                    column: 101
                }
            },
            '10': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 34
                }
            },
            '11': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 9
                }
            },
            '12': {
                start: {
                    line: 33,
                    column: 16
                },
                end: {
                    line: 33,
                    column: 45
                }
            },
            '13': {
                start: {
                    line: 34,
                    column: 16
                },
                end: {
                    line: 34,
                    column: 44
                }
            },
            '14': {
                start: {
                    line: 40,
                    column: 0
                },
                end: {
                    line: 47,
                    column: 57
                }
            },
            '15': {
                start: {
                    line: 50,
                    column: 4
                },
                end: {
                    line: 50,
                    column: 20
                }
            },
            '16': {
                start: {
                    line: 53,
                    column: 23
                },
                end: {
                    line: 53,
                    column: 53
                }
            },
            '17': {
                start: {
                    line: 54,
                    column: 8
                },
                end: {
                    line: 65,
                    column: 11
                }
            },
            '18': {
                start: {
                    line: 70,
                    column: 4
                },
                end: {
                    line: 70,
                    column: 23
                }
            },
            '19': {
                start: {
                    line: 71,
                    column: 4
                },
                end: {
                    line: 73,
                    column: 5
                }
            },
            '20': {
                start: {
                    line: 72,
                    column: 8
                },
                end: {
                    line: 72,
                    column: 25
                }
            },
            '21': {
                start: {
                    line: 74,
                    column: 4
                },
                end: {
                    line: 76,
                    column: 5
                }
            },
            '22': {
                start: {
                    line: 75,
                    column: 8
                },
                end: {
                    line: 75,
                    column: 29
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 84
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 11,
                        column: 4
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 34
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                line: 11
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 17,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 22
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                },
                line: 17
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 24,
                        column: 12
                    },
                    end: {
                        line: 24,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 21
                    },
                    end: {
                        line: 24,
                        column: 101
                    }
                },
                line: 24
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 30,
                        column: 4
                    },
                    end: {
                        line: 30,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 20
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                line: 30
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 32,
                        column: 12
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 18
                    },
                    end: {
                        line: 35,
                        column: 13
                    }
                },
                line: 32
            },
            '6': {
                name: 'editQuotaPriceModal',
                decl: {
                    start: {
                        line: 49,
                        column: 9
                    },
                    end: {
                        line: 49,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 49,
                        column: 40
                    },
                    end: {
                        line: 67,
                        column: 1
                    }
                },
                line: 49
            },
            '7': {
                name: 'show',
                decl: {
                    start: {
                        line: 52,
                        column: 13
                    },
                    end: {
                        line: 52,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 24
                    },
                    end: {
                        line: 66,
                        column: 5
                    }
                },
                line: 52
            },
            '8': {
                name: 'editQuotaPriceModalDialog',
                decl: {
                    start: {
                        line: 69,
                        column: 9
                    },
                    end: {
                        line: 69,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 70
                    },
                    end: {
                        line: 77,
                        column: 1
                    }
                },
                line: 69
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 71,
                        column: 25
                    },
                    end: {
                        line: 71,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 71,
                        column: 37
                    },
                    end: {
                        line: 73,
                        column: 5
                    }
                },
                line: 71
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 74,
                        column: 22
                    },
                    end: {
                        line: 74,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 74,
                        column: 34
                    },
                    end: {
                        line: 76,
                        column: 5
                    }
                },
                line: 74
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuotaSettingsViewController = function () {
    QuotaSettingsViewController.$inject = ["UserTypesTable", "UserTypePricesTable", "editQuotaPriceModal", "$mdToast"];
    function QuotaSettingsViewController(UserTypesTable, UserTypePricesTable, editQuotaPriceModal, $mdToast) {
        _classCallCheck(this, QuotaSettingsViewController);

        cov_1824uqh44x.f[0]++;
        cov_1824uqh44x.s[0]++;

        this.editQuotaPriceModal = editQuotaPriceModal;

        cov_1824uqh44x.s[1]++;
        this.userTypes = UserTypesTable.$search();
        cov_1824uqh44x.s[2]++;
        this.userTypePrices = UserTypePricesTable.$search({ page_size: 9999, ordering: 'created' });

        cov_1824uqh44x.s[3]++;
        this.$mdToast = $mdToast;
    }

    _createClass(QuotaSettingsViewController, [{
        key: 'changePrice',
        value: function changePrice(type, gem, quota) {
            var _this = this;

            cov_1824uqh44x.f[1]++;

            var newprice = (cov_1824uqh44x.s[4]++, this.userTypePrices.$create({
                user_type: type.id,
                gem_amount: gem,
                quota_amount: quota
            }).$then(function (cont) {
                cov_1824uqh44x.f[2]++;
                cov_1824uqh44x.s[5]++;

                _this.$mdToast.showSimple('Novo periodo de vigência adicionado');
                cov_1824uqh44x.s[6]++;
                _this.userTypes.$refresh();
                cov_1824uqh44x.s[7]++;
                type.editing = false;

                cov_1824uqh44x.s[8]++;
                return cont;
            }, function (err) {
                cov_1824uqh44x.f[3]++;
                cov_1824uqh44x.s[9]++;
                return _this.$mdToast.showSimple('Erro! Não foi possível alterar o periodo de vigência');
            }));

            cov_1824uqh44x.s[10]++;
            newprice.$highlight = true;
        }
    }, {
        key: 'editPrice',
        value: function editPrice(type) {
            var _this2 = this;

            cov_1824uqh44x.f[4]++;
            cov_1824uqh44x.s[11]++;

            this.editQuotaPriceModal.show(type).then(function () {
                cov_1824uqh44x.f[5]++;
                cov_1824uqh44x.s[12]++;

                _this2.memberPrices.$refresh();
                cov_1824uqh44x.s[13]++;
                _this2.groupPrices.$refresh();
            });
        }
    }]);

    return QuotaSettingsViewController;
}();

cov_1824uqh44x.s[14]++;


angular.module('app').component('quotaSettingsView', {
    templateUrl: 'app/components/quotaSettingsView/quotaSettingsView.html',
    controller: QuotaSettingsViewController,
    bindings: {}
}).service('editQuotaPriceModal', editQuotaPriceModal);

function editQuotaPriceModal($mdDialog) {
    cov_1824uqh44x.f[6]++;
    cov_1824uqh44x.s[15]++;

    this.show = show;

    function show(type) {
        cov_1824uqh44x.f[7]++;

        var parentEl = (cov_1824uqh44x.s[16]++, angular.element(document.body));
        cov_1824uqh44x.s[17]++;
        return $mdDialog.show({
            parent: parentEl,
            template: '<md-dialog aria-label="List dialog" style="min-width: 500px">' + '  <md-dialog-content>' + '    <edit-quota-price-view type="type" on-change="onChange()"/>' + '  </md-dialog-content>' + '</md-dialog>',
            locals: { type: type },
            controller: editQuotaPriceModalDialog,
            clickOutsideToClose: true
        });
    }
}

function editQuotaPriceModalDialog($scope, $mdDialog, $mdToast, type) {
    cov_1824uqh44x.f[8]++;
    cov_1824uqh44x.s[18]++;

    $scope.type = type;
    cov_1824uqh44x.s[19]++;
    $scope.closeDialog = function () {
        cov_1824uqh44x.f[9]++;
        cov_1824uqh44x.s[20]++;

        $mdDialog.hide();
    };
    cov_1824uqh44x.s[21]++;
    $scope.onChange = function () {
        cov_1824uqh44x.f[10]++;
        cov_1824uqh44x.s[22]++;

        $scope.closeDialog();
    };
}
'use strict';

var cov_1i1ymmg5ml = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/reportsList/reportsList.js',
        hash = '08d44b90e226007e5a711614e06145363aeadf53',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/reportsList/reportsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 45
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 35
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 26
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 11
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 11,
                    column: 36
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 29
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 30
                }
            },
            '7': {
                start: {
                    line: 21,
                    column: 24
                },
                end: {
                    line: 25,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 67
                }
            },
            '9': {
                start: {
                    line: 27,
                    column: 48
                },
                end: {
                    line: 27,
                    column: 65
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 9
                }
            },
            '11': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 36
                }
            },
            '12': {
                start: {
                    line: 35,
                    column: 8
                },
                end: {
                    line: 40,
                    column: 9
                }
            },
            '13': {
                start: {
                    line: 36,
                    column: 12
                },
                end: {
                    line: 36,
                    column: 40
                }
            },
            '14': {
                start: {
                    line: 37,
                    column: 12
                },
                end: {
                    line: 37,
                    column: 48
                }
            },
            '15': {
                start: {
                    line: 39,
                    column: 12
                },
                end: {
                    line: 39,
                    column: 41
                }
            },
            '16': {
                start: {
                    line: 42,
                    column: 8
                },
                end: {
                    line: 42,
                    column: 44
                }
            },
            '17': {
                start: {
                    line: 43,
                    column: 8
                },
                end: {
                    line: 43,
                    column: 32
                }
            },
            '18': {
                start: {
                    line: 48,
                    column: 0
                },
                end: {
                    line: 56,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 43
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 9,
                        column: 4
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 16
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 43
                    },
                    end: {
                        line: 10,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 49
                    },
                    end: {
                        line: 12,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 15,
                        column: 4
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 15
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 15
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 20,
                        column: 4
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 26
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                line: 20
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 27,
                        column: 42
                    },
                    end: {
                        line: 27,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 48
                    },
                    end: {
                        line: 27,
                        column: 65
                    }
                },
                line: 27
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 30,
                        column: 4
                    },
                    end: {
                        line: 30,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 33
                    },
                    end: {
                        line: 44,
                        column: 5
                    }
                },
                line: 30
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 31,
                        column: 8
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 31,
                        column: 8
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                }, {
                    start: {
                        line: 31,
                        column: 8
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                }],
                line: 31
            },
            '1': {
                loc: {
                    start: {
                        line: 35,
                        column: 8
                    },
                    end: {
                        line: 40,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 35,
                        column: 8
                    },
                    end: {
                        line: 40,
                        column: 9
                    }
                }, {
                    start: {
                        line: 35,
                        column: 8
                    },
                    end: {
                        line: 40,
                        column: 9
                    }
                }],
                line: 35
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsListController = function () {
    ReportsListController.$inject = ["NewReportModal", "$mdDialog"];
    function ReportsListController(NewReportModal, $mdDialog) {
        _classCallCheck(this, ReportsListController);

        cov_1i1ymmg5ml.f[0]++;
        cov_1i1ymmg5ml.s[0]++;

        this.NewReportModal = NewReportModal;
        cov_1i1ymmg5ml.s[1]++;
        this.$mdDialog = $mdDialog;
        cov_1i1ymmg5ml.s[2]++;
        this.filters = {};
    }

    _createClass(ReportsListController, [{
        key: 'newReport',
        value: function newReport() {
            var _this = this;

            cov_1i1ymmg5ml.f[1]++;
            cov_1i1ymmg5ml.s[3]++;

            this.NewReportModal.display().then(function () {
                cov_1i1ymmg5ml.f[2]++;
                cov_1i1ymmg5ml.s[4]++;

                _this.reports.$refresh();
            });
        }
    }, {
        key: 'loadMore',
        value: function loadMore() {
            cov_1i1ymmg5ml.f[3]++;
            cov_1i1ymmg5ml.s[5]++;

            this.reports.$page++;
            cov_1i1ymmg5ml.s[6]++;
            this.reports.$fetch();
        }
    }, {
        key: 'destroyReport',
        value: function destroyReport(report) {
            cov_1i1ymmg5ml.f[4]++;

            var confirm = (cov_1i1ymmg5ml.s[7]++, this.$mdDialog.confirm().title('Eliminar Relatório?').textContent('Tem a certeza que quer eliminar este relatório? Esta ação é irreversível.').ok('Sim, quero eliminar.').cancel('Cancelar'));

            cov_1i1ymmg5ml.s[8]++;
            this.$mdDialog.show(confirm).then(function () {
                cov_1i1ymmg5ml.f[5]++;
                cov_1i1ymmg5ml.s[9]++;
                return report.$destroy();
            });
        }
    }, {
        key: 'changeFilters',
        value: function changeFilters(filter, value) {
            cov_1i1ymmg5ml.f[6]++;
            cov_1i1ymmg5ml.s[10]++;

            if (angular.isArray(value)) {
                cov_1i1ymmg5ml.b[0][0]++;
                cov_1i1ymmg5ml.s[11]++;

                value = value.join(',');
            } else {
                cov_1i1ymmg5ml.b[0][1]++;
            }

            cov_1i1ymmg5ml.s[12]++;
            if (value === null) {
                cov_1i1ymmg5ml.b[1][0]++;
                cov_1i1ymmg5ml.s[13]++;

                delete this.filters[filter];
                cov_1i1ymmg5ml.s[14]++;
                delete this.reports.$params[filter];
            } else {
                cov_1i1ymmg5ml.b[1][1]++;
                cov_1i1ymmg5ml.s[15]++;

                this.filters[filter] = value;
            }

            cov_1i1ymmg5ml.s[16]++;
            this.reports.$params = this.filters;
            cov_1i1ymmg5ml.s[17]++;
            this.reports.$refresh();
        }
    }]);

    return ReportsListController;
}();

cov_1i1ymmg5ml.s[18]++;


angular.module('app').component('reportsList', {
    templateUrl: 'app/components/reportsList/reportsList.html',
    controller: ReportsListController,
    bindings: {
        reports: '<'
    }
});
'use strict';

var cov_1g4gw1ot62 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/paymentStateBadge/paymentStateBadge.js',
        hash = 'e54b6e24d2751b3397e0cadb23e8a67bda995a0f',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/paymentStateBadge/paymentStateBadge.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 9
                }
            },
            '1': {
                start: {
                    line: 9,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 2
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentStateBadgeController = function PaymentStateBadgeController() {
    _classCallCheck(this, PaymentStateBadgeController);

    cov_1g4gw1ot62.f[0]++;
    cov_1g4gw1ot62.s[0]++;

    this.paymentStates = {
        CREATED: 'Em Rascunho', IN_PAYMENT: 'Pendente', PAID: 'Pago', CANCELED: 'Cancelado', INVALID: 'Inválido'
    };
};

cov_1g4gw1ot62.s[1]++;


angular.module('app').component('paymentStateBadge', {
    templateUrl: 'app/components/paymentStateBadge/paymentStateBadge.html',
    controller: PaymentStateBadgeController,
    bindings: {
        state: '<'
    }
});
'use strict';

var cov_hmjg8newb = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/paymentDetailsView/paymentDetailsView.js',
        hash = '3cd0429c01998143355f00a5a8b37297dcd825b0',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/paymentDetailsView/paymentDetailsView.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 35
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 9
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 69
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 48
                },
                end: {
                    line: 14,
                    column: 68
                }
            },
            '6': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 39
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 71
                }
            },
            '8': {
                start: {
                    line: 20,
                    column: 48
                },
                end: {
                    line: 20,
                    column: 70
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 45
                }
            },
            '10': {
                start: {
                    line: 39,
                    column: 4
                },
                end: {
                    line: 39,
                    column: 20
                }
            },
            '11': {
                start: {
                    line: 42,
                    column: 23
                },
                end: {
                    line: 42,
                    column: 53
                }
            },
            '12': {
                start: {
                    line: 43,
                    column: 8
                },
                end: {
                    line: 54,
                    column: 11
                }
            },
            '13': {
                start: {
                    line: 59,
                    column: 4
                },
                end: {
                    line: 59,
                    column: 29
                }
            },
            '14': {
                start: {
                    line: 60,
                    column: 4
                },
                end: {
                    line: 62,
                    column: 5
                }
            },
            '15': {
                start: {
                    line: 61,
                    column: 8
                },
                end: {
                    line: 61,
                    column: 27
                }
            },
            '16': {
                start: {
                    line: 64,
                    column: 4
                },
                end: {
                    line: 67,
                    column: 5
                }
            },
            '17': {
                start: {
                    line: 65,
                    column: 8
                },
                end: {
                    line: 65,
                    column: 50
                }
            },
            '18': {
                start: {
                    line: 66,
                    column: 8
                },
                end: {
                    line: 66,
                    column: 44
                }
            },
            '19': {
                start: {
                    line: 69,
                    column: 4
                },
                end: {
                    line: 72,
                    column: 5
                }
            },
            '20': {
                start: {
                    line: 70,
                    column: 8
                },
                end: {
                    line: 70,
                    column: 50
                }
            },
            '21': {
                start: {
                    line: 71,
                    column: 8
                },
                end: {
                    line: 71,
                    column: 40
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 46
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 17
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 10
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 13,
                        column: 17
                    },
                    end: {
                        line: 13,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 23
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                },
                line: 13
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 42
                    },
                    end: {
                        line: 14,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 48
                    },
                    end: {
                        line: 14,
                        column: 68
                    }
                },
                line: 14
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 18,
                        column: 4
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 18
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 20,
                        column: 35
                    },
                    end: {
                        line: 20,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 48
                    },
                    end: {
                        line: 20,
                        column: 70
                    }
                },
                line: 20
            },
            '6': {
                name: 'Service',
                decl: {
                    start: {
                        line: 38,
                        column: 9
                    },
                    end: {
                        line: 38,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 38,
                        column: 28
                    },
                    end: {
                        line: 56,
                        column: 1
                    }
                },
                line: 38
            },
            '7': {
                name: 'show',
                decl: {
                    start: {
                        line: 41,
                        column: 13
                    },
                    end: {
                        line: 41,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 41,
                        column: 27
                    },
                    end: {
                        line: 55,
                        column: 5
                    }
                },
                line: 41
            },
            '8': {
                name: 'DialogController',
                decl: {
                    start: {
                        line: 58,
                        column: 9
                    },
                    end: {
                        line: 58,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 58,
                        column: 64
                    },
                    end: {
                        line: 73,
                        column: 1
                    }
                },
                line: 58
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 60,
                        column: 25
                    },
                    end: {
                        line: 60,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 60,
                        column: 37
                    },
                    end: {
                        line: 62,
                        column: 5
                    }
                },
                line: 60
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 64,
                        column: 29
                    },
                    end: {
                        line: 64,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 41
                    },
                    end: {
                        line: 67,
                        column: 5
                    }
                },
                line: 64
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 69,
                        column: 27
                    },
                    end: {
                        line: 69,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 39
                    },
                    end: {
                        line: 72,
                        column: 5
                    }
                },
                line: 69
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentDetailsViewController = function () {
    PaymentDetailsViewController.$inject = ["$mdDialog", "PaymentsCashTable"];
    function PaymentDetailsViewController($mdDialog, PaymentsCashTable) {
        _classCallCheck(this, PaymentDetailsViewController);

        cov_hmjg8newb.f[0]++;
        cov_hmjg8newb.s[0]++;

        this.$mdDialog = $mdDialog;
        cov_hmjg8newb.s[1]++;
        this.PaymentsCashTable = PaymentsCashTable;
        cov_hmjg8newb.s[2]++;
        this.paymentStates = {
            CREATED: 'Em Rascunho', IN_PAYMENT: 'Pendente', PAID: 'Pago', CANCELED: 'Cancelado', INVALID: 'Inválido'
        };
    }

    _createClass(PaymentDetailsViewController, [{
        key: 'markAsPaid',
        value: function markAsPaid() {
            var _this = this;

            cov_hmjg8newb.f[1]++;
            cov_hmjg8newb.s[3]++;

            this.PaymentsCashTable.$create({
                order: this.payment.id
            }).$then(function () {
                cov_hmjg8newb.f[2]++;
                cov_hmjg8newb.s[4]++;

                _this.payment.$refresh().$then(function () {
                    cov_hmjg8newb.f[3]++;
                    cov_hmjg8newb.s[5]++;
                    return _this.onPaymentPaid();
                });
            });
        }
    }, {
        key: 'cancelPayment',
        value: function cancelPayment() {
            var _this2 = this;

            cov_hmjg8newb.f[4]++;
            cov_hmjg8newb.s[6]++;

            this.payment.state = 'CANCELED';
            cov_hmjg8newb.s[7]++;
            this.payment.$save().$then(function (payment) {
                cov_hmjg8newb.f[5]++;
                cov_hmjg8newb.s[8]++;
                return _this2.onCancelPayment();
            });
        }
    }]);

    return PaymentDetailsViewController;
}();

cov_hmjg8newb.s[9]++;


angular.module('app').component('paymentDetailsView', {
    templateUrl: 'app/components/paymentDetailsView/paymentDetailsView.html',
    controller: PaymentDetailsViewController,
    bindings: {
        payment: '<',
        onCancelPayment: '&',
        onPaymentPaid: '&',
        onClose: '&'
    }
}).service('PaymentDetailsModal', Service);

function Service($mdDialog) {
    cov_hmjg8newb.f[6]++;
    cov_hmjg8newb.s[10]++;

    this.show = show;

    function show(payment) {
        cov_hmjg8newb.f[7]++;

        var parentEl = (cov_hmjg8newb.s[11]++, angular.element(document.body));
        cov_hmjg8newb.s[12]++;
        return $mdDialog.show({
            parent: parentEl,
            template: '<md-dialog aria-label="List dialog" style="min-width: 500px">' + '  <md-dialog-content>' + '    <payment-details-view payment="payment" on-cancel-payment="onCancelPayment()" on-payment-paid="onPaymentPaid()" on-close="closeDialog()"/>' + '  </md-dialog-content>' + '</md-dialog>',
            locals: { payment: payment },
            controller: DialogController,
            clickOutsideToClose: true
        });
    }
}

function DialogController($scope, $mdDialog, payment, $mdToast) {
    cov_hmjg8newb.f[8]++;
    cov_hmjg8newb.s[13]++;

    $scope.payment = payment;
    cov_hmjg8newb.s[14]++;
    $scope.closeDialog = function () {
        cov_hmjg8newb.f[9]++;
        cov_hmjg8newb.s[15]++;

        $mdDialog.cancel();
    };

    cov_hmjg8newb.s[16]++;
    $scope.onCancelPayment = function () {
        cov_hmjg8newb.f[10]++;
        cov_hmjg8newb.s[17]++;

        $mdToast.showSimple('Pagamento cancelado');
        cov_hmjg8newb.s[18]++;
        $mdDialog.hide({ action: 'CANCELED' });
    };

    cov_hmjg8newb.s[19]++;
    $scope.onPaymentPaid = function () {
        cov_hmjg8newb.f[11]++;
        cov_hmjg8newb.s[20]++;

        $mdToast.showSimple('Pagamento efectuado');
        cov_hmjg8newb.s[21]++;
        $mdDialog.hide({ action: 'PAID' });
    };
}
'use strict';

var cov_s09nl1cq8 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/paginator/paginator.js',
        hash = 'e85fc798b888b5f3411adb770d881f609b062cce',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/paginator/paginator.js',
        statementMap: {
            '0': {
                start: {
                    line: 6,
                    column: 23
                },
                end: {
                    line: 6,
                    column: 63
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 31
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 38
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 12,
                    column: 38
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 20
                },
                end: {
                    line: 13,
                    column: 45
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 27
                }
            },
            '6': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 37
                }
            },
            '7': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 35
                }
            },
            '8': {
                start: {
                    line: 23,
                    column: 0
                },
                end: {
                    line: 31,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 4
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 23
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 5
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 19
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 17,
                        column: 4
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 19
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                line: 17
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 12,
                        column: 38
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 12,
                        column: 38
                    }
                }, {
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 12,
                        column: 38
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaginatorController = function () {
    function PaginatorController() {
        _classCallCheck(this, PaginatorController);

        cov_s09nl1cq8.f[0]++;
    }

    _createClass(PaginatorController, [{
        key: 'goToPreviousPage',
        value: function goToPreviousPage() {
            cov_s09nl1cq8.f[1]++;

            var previous = (cov_s09nl1cq8.s[0]++, Math.max(1, this.collection.$page - 1));
            cov_s09nl1cq8.s[1]++;
            this.goToPage(previous);
        }
    }, {
        key: 'goToNextPage',
        value: function goToNextPage() {
            cov_s09nl1cq8.f[2]++;
            cov_s09nl1cq8.s[2]++;

            if (!this.collection.$page) {
                    cov_s09nl1cq8.b[0][0]++;
                    cov_s09nl1cq8.s[3]++;

                    this.collection.$page = 0;
                } else {
                cov_s09nl1cq8.b[0][1]++;
            }var next = (cov_s09nl1cq8.s[4]++, this.collection.$page + 1);
            cov_s09nl1cq8.s[5]++;
            this.goToPage(next);
        }
    }, {
        key: 'goToPage',
        value: function goToPage(page) {
            cov_s09nl1cq8.f[3]++;
            cov_s09nl1cq8.s[6]++;

            this.collection.$page = page;
            cov_s09nl1cq8.s[7]++;
            this.collection.$refresh();
        }
    }]);

    return PaginatorController;
}();

cov_s09nl1cq8.s[8]++;


angular.module('app').component('paginator', {
    templateUrl: 'app/components/paginator/paginator.html',
    controller: PaginatorController,
    bindings: {
        collection: '<'
    }
});
'use strict';

var cov_15hz1qowgd = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/offline/offline.js',
        hash = 'c5be98dd06c51496a56eb6d4c9374db8626253bd',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/offline/offline.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 31
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 22
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 12
                },
                end: {
                    line: 15,
                    column: 14
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 20
                },
                end: {
                    line: 10,
                    column: 43
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 20
                },
                end: {
                    line: 13,
                    column: 42
                }
            },
            '5': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 25,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 48
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 18
                    },
                    end: {
                        line: 5,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 24
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                },
                line: 5
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 9,
                        column: 16
                    },
                    end: {
                        line: 9,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 22
                    },
                    end: {
                        line: 11,
                        column: 17
                    }
                },
                line: 9
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 12,
                        column: 16
                    },
                    end: {
                        line: 12,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 22
                    },
                    end: {
                        line: 14,
                        column: 17
                    }
                },
                line: 12
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfflineController = function OfflineController($interval, $http, AppSettings) {
    var _this = this;

    _classCallCheck(this, OfflineController);

    cov_15hz1qowgd.f[0]++;
    cov_15hz1qowgd.s[0]++;

    this.isOffline = false;

    cov_15hz1qowgd.s[1]++;
    $interval(function () {
        cov_15hz1qowgd.f[1]++;
        cov_15hz1qowgd.s[2]++;

        $http.get(AppSettings.apiUrl + '/api-status/', {
            timeout: 4500
        }).then(function () {
            cov_15hz1qowgd.f[2]++;
            cov_15hz1qowgd.s[3]++;

            _this.isOffline = false;
        }, function () {
            cov_15hz1qowgd.f[3]++;
            cov_15hz1qowgd.s[4]++;

            _this.isOffline = true;
        });
    }, 1000 * 10);
};
OfflineController.$inject = ["$interval", "$http", "AppSettings"];

cov_15hz1qowgd.s[5]++;


angular.module('app').component('offline', {
    templateUrl: 'app/components/offline/offline.html',
    controller: OfflineController
});
'use strict';

var cov_1zcwi82g4 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/notfound/notfound.module.js',
        hash = '9f2377db24af4e624b1bec21a59b73503e04aed5',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/notfound/notfound.module.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 6,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 5,
                    column: 36
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 6,
                        column: 1
                    }
                },
                line: 1
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1zcwi82g4.s[0]++;
(function () {
    'use strict';

    cov_1zcwi82g4.f[0]++;
    cov_1zcwi82g4.s[1]++;
    angular.module('app.notfound', []);
})();
'use strict';

var cov_scsw64cyk = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/notfound/notfound.run.js',
        hash = '986d74fa3c7d407f83fc2bca026029c3e497a5b1',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/notfound/notfound.run.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 23
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 11
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 12,
                    column: 32
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 13,
                    column: 34
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 42
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 82
                    },
                    end: {
                        line: 11,
                        column: 83
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 95
                    },
                    end: {
                        line: 14,
                        column: 9
                    }
                },
                line: 11
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_scsw64cyk.s[0]++;
(function () {
    'use strict';

    runBlock.$inject = ["$rootScope", "$state"];
    cov_scsw64cyk.f[0]++;
    cov_scsw64cyk.s[1]++;
    angular.module('app.notfound').run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state) {
        cov_scsw64cyk.f[1]++;
        cov_scsw64cyk.s[2]++;

        console.log('runned');
        cov_scsw64cyk.s[3]++;
        $rootScope.notfoundStateChangeError = $rootScope.$on('$stateChangeError', function (e) {
            cov_scsw64cyk.f[2]++;
            cov_scsw64cyk.s[4]++;

            console.log('error');
            cov_scsw64cyk.s[5]++;
            $state.go('notfound');
        });
    }
})();
'use strict';

var cov_2icf2vc567 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/notfound/notfound.route.js',
        hash = 'b976bfe9b41ad495778fef6a83276286c97c9570',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/notfound/notfound.route.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 18,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 24
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 10
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 18,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'appRun',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 36
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2icf2vc567.s[0]++;
(function () {
    'use strict';

    appRun.$inject = ["$stateProvider"];
    cov_2icf2vc567.f[0]++;
    cov_2icf2vc567.s[1]++;
    angular.module('app.notfound').config(appRun);

    /* @ngInject */
    function appRun($stateProvider) {
        cov_2icf2vc567.f[1]++;
        cov_2icf2vc567.s[2]++;

        $stateProvider.state('notfound', {
            templateUrl: 'app/components/notfound/views/notfound.html',
            controller: 'NotFoundController',
            controllerAs: 'vm',
            url: '/notfound'
        });
    }
})();
'use strict';

var cov_nwla672a3 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/notfound/notfound.404.controller.js',
        hash = '54eeb3b9c594c48c7a078b5dc6fb071f739e81a3',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/notfound/notfound.404.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 18,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 19
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 18,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Controller',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 26
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 15,
                        column: 17
                    },
                    end: {
                        line: 15,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 28
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                },
                line: 15
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_nwla672a3.s[0]++;
(function () {
    'use strict';

    cov_nwla672a3.f[0]++;
    cov_nwla672a3.s[1]++;
    angular.module('app.notfound').controller('NotFoundController', Controller);

    /* @ngInject */
    function Controller() {
        cov_nwla672a3.f[1]++;

        var vm = (cov_nwla672a3.s[2]++, this);

        cov_nwla672a3.s[3]++;
        activate();

        function activate() {
            cov_nwla672a3.f[2]++;
        }
    }
})();
'use strict';

var cov_kjxieu6f8 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/newReportModal/newReportModal.js',
        hash = 'c9f408c4d40d12bd5af2a98f55913f8e3dc4e432',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/newReportModal/newReportModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 38,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            },
            '5': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 30,
                    column: 10
                }
            },
            '6': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 29,
                    column: 31
                }
            },
            '7': {
                start: {
                    line: 32,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 33,
                    column: 12
                },
                end: {
                    line: 35,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 34,
                    column: 16
                },
                end: {
                    line: 34,
                    column: 39
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewReportModal',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 39
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'NewReportModalController',
                decl: {
                    start: {
                        line: 22,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 71
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                line: 22
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 28,
                        column: 29
                    },
                    end: {
                        line: 28,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 41
                    },
                    end: {
                        line: 30,
                        column: 9
                    }
                },
                line: 28
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 32,
                        column: 30
                    },
                    end: {
                        line: 32,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 42
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                },
                line: 32
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 33,
                        column: 43
                    },
                    end: {
                        line: 33,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 61
                    },
                    end: {
                        line: 35,
                        column: 13
                    }
                },
                line: 33
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_kjxieu6f8.s[0]++;
(function () {
    'use strict';

    NewReportModal.$inject = ["$mdDialog"];
    NewReportModalController.$inject = ["$scope", "$mdDialog", "ReportsTable"];
    cov_kjxieu6f8.f[0]++;
    cov_kjxieu6f8.s[1]++;
    angular.module('app').service('NewReportModal', NewReportModal);

    /* @ngInject */
    function NewReportModal($mdDialog) {
        cov_kjxieu6f8.f[1]++;
        cov_kjxieu6f8.s[2]++;

        this.display = function () {
            cov_kjxieu6f8.f[2]++;
            cov_kjxieu6f8.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/newReportModal/newReportModal.html',
                controller: NewReportModalController,
                controllerAs: '$ctrl',
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function NewReportModalController($scope, $mdDialog, ReportsTable) {
        cov_kjxieu6f8.f[3]++;
        cov_kjxieu6f8.s[4]++;

        $scope.newReport = ReportsTable.$build({
            start: new Date(),
            end: new Date()
        });

        cov_kjxieu6f8.s[5]++;
        $scope.closeDialog = function () {
            cov_kjxieu6f8.f[4]++;
            cov_kjxieu6f8.s[6]++;

            $mdDialog.cancel();
        };

        cov_kjxieu6f8.s[7]++;
        $scope.createReport = function () {
            cov_kjxieu6f8.f[5]++;
            cov_kjxieu6f8.s[8]++;

            $scope.newReport.$save().$then(function (report) {
                cov_kjxieu6f8.f[6]++;
                cov_kjxieu6f8.s[9]++;

                $mdDialog.hide(report);
            });
        };
    }
})(angular);
'use strict';

var cov_zhnaovenu = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/monthName/monthName.js',
        hash = '0523f370bd51a9e70997380070d42e2a1b149c41',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/monthName/monthName.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 58
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 46
                }
            },
            '2': {
                start: {
                    line: 12,
                    column: 0
                },
                end: {
                    line: 20,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 14
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 7
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MonthNameController = function () {
    function MonthNameController() {
        _classCallCheck(this, MonthNameController);

        cov_zhnaovenu.f[0]++;
        cov_zhnaovenu.s[0]++;

        this.names = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
    }

    _createClass(MonthNameController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_zhnaovenu.f[1]++;
            cov_zhnaovenu.s[1]++;

            this.name = this.names[this.month - 1];
        }
    }]);

    return MonthNameController;
}();

cov_zhnaovenu.s[2]++;


angular.module('app').component('monthName', {
    templateUrl: 'app/components/monthName/monthName.html',
    controller: MonthNameController,
    bindings: {
        month: '<'
    }
});
"use strict";

var cov_h1kbxt19b = function () {
    var path = "/home/lobo/repos/coliseu-app/src/app/components/newMemberView/newMemberView.js",
        hash = "c57e1bee8544eb7689a72f23ac991d371dfa97b3",
        global = new Function('return this')(),
        gcv = "__coverage__",
        coverageData = {
        path: "/home/lobo/repos/coliseu-app/src/app/components/newMemberView/newMemberView.js",
        statementMap: {
            "0": {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 10
                }
            },
            "1": {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 28
                }
            },
            "2": {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 75
                }
            },
            "3": {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 10
                }
            },
            "4": {
                start: {
                    line: 15,
                    column: 30
                },
                end: {
                    line: 15,
                    column: 74
                }
            },
            "5": {
                start: {
                    line: 15,
                    column: 53
                },
                end: {
                    line: 15,
                    column: 73
                }
            },
            "6": {
                start: {
                    line: 16,
                    column: 12
                },
                end: {
                    line: 18,
                    column: 13
                }
            },
            "7": {
                start: {
                    line: 17,
                    column: 16
                },
                end: {
                    line: 17,
                    column: 55
                }
            },
            "8": {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 92
                }
            },
            "9": {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 95
                }
            },
            "10": {
                start: {
                    line: 24,
                    column: 45
                },
                end: {
                    line: 24,
                    column: 94
                }
            },
            "11": {
                start: {
                    line: 28,
                    column: 19
                },
                end: {
                    line: 28,
                    column: 21
                }
            },
            "12": {
                start: {
                    line: 29,
                    column: 23
                },
                end: {
                    line: 29,
                    column: 87
                }
            },
            "13": {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 81
                }
            },
            "14": {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 81
                }
            },
            "15": {
                start: {
                    line: 34,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 20
                }
            },
            "16": {
                start: {
                    line: 38,
                    column: 0
                },
                end: {
                    line: 44,
                    column: 7
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 52
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 2
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 14
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                line: 10
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 14,
                        column: 29
                    },
                    end: {
                        line: 14,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 38
                    },
                    end: {
                        line: 19,
                        column: 9
                    }
                },
                line: 14
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 15,
                        column: 43
                    },
                    end: {
                        line: 15,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 53
                    },
                    end: {
                        line: 15,
                        column: 73
                    }
                },
                line: 15
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 22,
                        column: 4
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 11
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 22
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 24,
                        column: 37
                    },
                    end: {
                        line: 24,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 45
                    },
                    end: {
                        line: 24,
                        column: 94
                    }
                },
                line: 24
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 27,
                        column: 4
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 24
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 27
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 16,
                        column: 12
                    },
                    end: {
                        line: 18,
                        column: 13
                    }
                },
                type: "if",
                locations: [{
                    start: {
                        line: 16,
                        column: 12
                    },
                    end: {
                        line: 18,
                        column: 13
                    }
                }, {
                    start: {
                        line: 16,
                        column: 12
                    },
                    end: {
                        line: 18,
                        column: 13
                    }
                }],
                line: 16
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0
        },
        b: {
            "0": [0, 0]
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NewMemberViewController = function () {
    NewMemberViewController.$inject = ["UsersTable", "$state", "UserTypesTable"];
    function NewMemberViewController(UsersTable, $state, UserTypesTable) {
        _classCallCheck(this, NewMemberViewController);

        cov_h1kbxt19b.f[0]++;
        cov_h1kbxt19b.s[0]++;

        this.newMember = UsersTable.$build({
            admissionDate: new Date()
        });
        cov_h1kbxt19b.s[1]++;
        this.$state = $state;
        cov_h1kbxt19b.s[2]++;
        this.userTypes = UserTypesTable.$search({ is_accepting_users: true });
    }

    _createClass(NewMemberViewController, [{
        key: "$onInit",
        value: function $onInit() {
            var _this = this;

            cov_h1kbxt19b.f[1]++;
            cov_h1kbxt19b.s[3]++;

            /*
            Select the default user type if there is one
             */
            this.userTypes.$then(function (types) {
                cov_h1kbxt19b.f[2]++;

                var defaultType = (cov_h1kbxt19b.s[4]++, types.filter(function (item) {
                    cov_h1kbxt19b.f[3]++;
                    cov_h1kbxt19b.s[5]++;
                    return item.defaultUserType;
                }));
                cov_h1kbxt19b.s[6]++;
                if (defaultType[0]) {
                    cov_h1kbxt19b.b[0][0]++;
                    cov_h1kbxt19b.s[7]++;

                    _this.newMember.type = defaultType[0].id;
                } else {
                    cov_h1kbxt19b.b[0][1]++;
                }
            });
        }
    }, {
        key: "save",
        value: function save() {
            var _this2 = this;

            cov_h1kbxt19b.f[4]++;
            cov_h1kbxt19b.s[8]++;

            this.newMember.password = this.newMember.confirm_password = this._generatePassword();
            cov_h1kbxt19b.s[9]++;
            this.newMember.$save().$then(function (user) {
                cov_h1kbxt19b.f[5]++;
                cov_h1kbxt19b.s[10]++;
                return _this2.$state.go('^.member.details', { id: user.id });
            });
        }
    }, {
        key: "_generatePassword",
        value: function _generatePassword() {
            cov_h1kbxt19b.f[6]++;

            var text = (cov_h1kbxt19b.s[11]++, "");
            var possible = (cov_h1kbxt19b.s[12]++, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789");

            cov_h1kbxt19b.s[13]++;
            for (var i = 0; i < 10; i++) {
                cov_h1kbxt19b.s[14]++;

                text += possible.charAt(Math.floor(Math.random() * possible.length));
            }cov_h1kbxt19b.s[15]++;
            return text;
        }
    }]);

    return NewMemberViewController;
}();

cov_h1kbxt19b.s[16]++;


angular.module('app').component('newMemberView', {
    templateUrl: 'app/components/newMemberView/newMemberView.html',
    controller: NewMemberViewController,
    bindings: {}
});
'use strict';

var cov_12degubr2c = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/monthSelector/monthSelector.js',
        hash = 'f96ea3f9fb23235a6372b58cf7005cd50456f863',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/monthSelector/monthSelector.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 62
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 64
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 0
                },
                end: {
                    line: 21,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 4
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 14
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 6
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 7,
                        column: 27
                    },
                    end: {
                        line: 7,
                        column: 64
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 7,
                        column: 27
                    },
                    end: {
                        line: 7,
                        column: 43
                    }
                }, {
                    start: {
                        line: 7,
                        column: 47
                    },
                    end: {
                        line: 7,
                        column: 64
                    }
                }],
                line: 7
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MonthSelectorController = function () {
    function MonthSelectorController() {
        _classCallCheck(this, MonthSelectorController);

        cov_12degubr2c.f[0]++;
        cov_12degubr2c.s[0]++;

        this.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    }

    _createClass(MonthSelectorController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_12degubr2c.f[1]++;
            cov_12degubr2c.s[1]++;

            this.placeholder = (cov_12degubr2c.b[0][0]++, this.placeholder) || (cov_12degubr2c.b[0][1]++, 'Filtrar por ano');
        }
    }]);

    return MonthSelectorController;
}();

cov_12degubr2c.s[2]++;


angular.module('app').component('monthSelector', {
    templateUrl: 'app/components/monthSelector/monthSelector.html',
    controller: MonthSelectorController,
    bindings: {
        onChange: '&',
        placeholder: '@',
        selectedMonths: '='
    }
});
'use strict';

var cov_1rt0my2dbi = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/memberView/memberView.js',
        hash = 'a2c19b56e8757615b043d1922595f986f95a4709',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/memberView/memberView.js',
        statementMap: {
            '0': {
                start: {
                    line: 6,
                    column: 0
                },
                end: {
                    line: 14,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                line: 2
            }
        },
        branchMap: {},
        s: {
            '0': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MemberViewController = function MemberViewController() {
    _classCallCheck(this, MemberViewController);

    cov_1rt0my2dbi.f[0]++;
};

cov_1rt0my2dbi.s[0]++;


angular.module('app').component('memberView', {
    templateUrl: 'app/components/memberView/memberView.html',
    controller: MemberViewController,
    bindings: {
        member: '<'
    }
});
'use strict';

var cov_1iphnik2yw = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/memberQuotas/memberQuotas.js',
        hash = '56b0a60fd02855ab68d2dd7e6cc41006751bc3f0',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/memberQuotas/memberQuotas.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 39
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 55
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 55
                }
            },
            '3': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 20
                }
            },
            '4': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 54
                }
            },
            '5': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 53
                }
            },
            '6': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 15,
                    column: 13
                }
            },
            '8': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 14,
                    column: 39
                }
            },
            '9': {
                start: {
                    line: 20,
                    column: 8
                },
                end: {
                    line: 35,
                    column: 10
                }
            },
            '10': {
                start: {
                    line: 21,
                    column: 27
                },
                end: {
                    line: 21,
                    column: 29
                }
            },
            '11': {
                start: {
                    line: 22,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 14
                }
            },
            '12': {
                start: {
                    line: 23,
                    column: 16
                },
                end: {
                    line: 23,
                    column: 38
                }
            },
            '13': {
                start: {
                    line: 24,
                    column: 16
                },
                end: {
                    line: 24,
                    column: 53
                }
            },
            '14': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 34,
                    column: 14
                }
            },
            '15': {
                start: {
                    line: 27,
                    column: 16
                },
                end: {
                    line: 27,
                    column: 41
                }
            },
            '16': {
                start: {
                    line: 28,
                    column: 16
                },
                end: {
                    line: 33,
                    column: 18
                }
            },
            '17': {
                start: {
                    line: 29,
                    column: 20
                },
                end: {
                    line: 32,
                    column: 22
                }
            },
            '18': {
                start: {
                    line: 30,
                    column: 24
                },
                end: {
                    line: 30,
                    column: 48
                }
            },
            '19': {
                start: {
                    line: 31,
                    column: 24
                },
                end: {
                    line: 31,
                    column: 44
                }
            },
            '20': {
                start: {
                    line: 39,
                    column: 8
                },
                end: {
                    line: 42,
                    column: 10
                }
            },
            '21': {
                start: {
                    line: 40,
                    column: 12
                },
                end: {
                    line: 40,
                    column: 49
                }
            },
            '22': {
                start: {
                    line: 41,
                    column: 12
                },
                end: {
                    line: 41,
                    column: 42
                }
            },
            '23': {
                start: {
                    line: 46,
                    column: 8
                },
                end: {
                    line: 48,
                    column: 10
                }
            },
            '24': {
                start: {
                    line: 47,
                    column: 12
                },
                end: {
                    line: 47,
                    column: 43
                }
            },
            '25': {
                start: {
                    line: 52,
                    column: 0
                },
                end: {
                    line: 60,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 94
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 11,
                        column: 4
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 16
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 11
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 36
                    },
                    end: {
                        line: 12,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 45
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 19,
                        column: 4
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 19,
                        column: 26
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                line: 19
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 20,
                        column: 83
                    },
                    end: {
                        line: 20,
                        column: 84
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 92
                    },
                    end: {
                        line: 35,
                        column: 9
                    }
                },
                line: 20
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 22,
                        column: 40
                    },
                    end: {
                        line: 22,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 49
                    },
                    end: {
                        line: 25,
                        column: 13
                    }
                },
                line: 22
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 26,
                        column: 39
                    },
                    end: {
                        line: 26,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 45
                    },
                    end: {
                        line: 34,
                        column: 13
                    }
                },
                line: 26
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 28,
                        column: 36
                    },
                    end: {
                        line: 28,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 47
                    },
                    end: {
                        line: 33,
                        column: 17
                    }
                },
                line: 28
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 29,
                        column: 48
                    },
                    end: {
                        line: 29,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 57
                    },
                    end: {
                        line: 32,
                        column: 21
                    }
                },
                line: 29
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 38,
                        column: 4
                    },
                    end: {
                        line: 38,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 38,
                        column: 21
                    },
                    end: {
                        line: 43,
                        column: 5
                    }
                },
                line: 38
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 39,
                        column: 56
                    },
                    end: {
                        line: 39,
                        column: 57
                    }
                },
                loc: {
                    start: {
                        line: 39,
                        column: 66
                    },
                    end: {
                        line: 42,
                        column: 9
                    }
                },
                line: 39
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 45,
                        column: 4
                    },
                    end: {
                        line: 45,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 25
                    },
                    end: {
                        line: 49,
                        column: 5
                    }
                },
                line: 45
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 46,
                        column: 52
                    },
                    end: {
                        line: 46,
                        column: 53
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 60
                    },
                    end: {
                        line: 48,
                        column: 9
                    }
                },
                line: 46
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 13,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 13,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                }, {
                    start: {
                        line: 13,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                }],
                line: 13
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MemberQuotasController = function () {
    MemberQuotasController.$inject = ["OrdersTable", "GenerateQuotasModal", "PaymentTypesTable", "$q", "PaymentDetailsModal"];
    function MemberQuotasController(OrdersTable, GenerateQuotasModal, PaymentTypesTable, $q, PaymentDetailsModal) {
        _classCallCheck(this, MemberQuotasController);

        cov_1iphnik2yw.f[0]++;
        cov_1iphnik2yw.s[0]++;

        this.OrdersTable = OrdersTable;
        cov_1iphnik2yw.s[1]++;
        this.GenerateQuotasModal = GenerateQuotasModal;
        cov_1iphnik2yw.s[2]++;
        this.paymentTypes = PaymentTypesTable.$search();
        cov_1iphnik2yw.s[3]++;
        this.$q = $q;
        cov_1iphnik2yw.s[4]++;
        this.PaymentDetailsModal = PaymentDetailsModal;
        cov_1iphnik2yw.s[5]++;
        this.currentYear = new Date().getFullYear();
    }

    _createClass(MemberQuotasController, [{
        key: 'selectAll',
        value: function selectAll() {
            cov_1iphnik2yw.f[1]++;
            cov_1iphnik2yw.s[6]++;

            this.member.$quotas.forEach(function (quota) {
                cov_1iphnik2yw.f[2]++;
                cov_1iphnik2yw.s[7]++;

                if (quota.state == 'PENDING') {
                    cov_1iphnik2yw.b[0][0]++;
                    cov_1iphnik2yw.s[8]++;

                    quota.isSelected = true;
                } else {
                    cov_1iphnik2yw.b[0][1]++;
                }
            });
        }
    }, {
        key: 'generatePayment',
        value: function generatePayment(type) {
            var _this = this;

            cov_1iphnik2yw.f[3]++;
            cov_1iphnik2yw.s[9]++;

            this.OrdersTable.$create({ user: this.member.id, payment_type: type }).$then(function (order) {
                cov_1iphnik2yw.f[4]++;

                var requests = (cov_1iphnik2yw.s[10]++, []);
                cov_1iphnik2yw.s[11]++;
                _this.selectedQuotas.forEach(function (quota) {
                    cov_1iphnik2yw.f[5]++;
                    cov_1iphnik2yw.s[12]++;

                    quota.order = order.id;
                    cov_1iphnik2yw.s[13]++;
                    requests.push(quota.$save().$promise);
                });
                cov_1iphnik2yw.s[14]++;
                _this.$q.all(requests).then(function () {
                    cov_1iphnik2yw.f[6]++;
                    cov_1iphnik2yw.s[15]++;

                    order.paymentType = type;
                    cov_1iphnik2yw.s[16]++;
                    order.$save().$then(function (order) {
                        cov_1iphnik2yw.f[7]++;
                        cov_1iphnik2yw.s[17]++;

                        _this.selectedQuotas.forEach(function (quota) {
                            cov_1iphnik2yw.f[8]++;
                            cov_1iphnik2yw.s[18]++;

                            quota.isSelected = false;
                            cov_1iphnik2yw.s[19]++;
                            quota.$order = order;
                        });
                    });
                });
            });
        }
    }, {
        key: 'generateQuotas',
        value: function generateQuotas() {
            var _this2 = this;

            cov_1iphnik2yw.f[9]++;
            cov_1iphnik2yw.s[20]++;

            this.GenerateQuotasModal.show(this.member).then(function (quotas) {
                cov_1iphnik2yw.f[10]++;
                cov_1iphnik2yw.s[21]++;

                console.log('created quotas', quotas);
                cov_1iphnik2yw.s[22]++;
                _this2.member.$quotas.$refresh();
            });
        }
    }, {
        key: 'showPayment',
        value: function showPayment(payment) {
            var _this3 = this;

            cov_1iphnik2yw.f[11]++;
            cov_1iphnik2yw.s[23]++;

            this.PaymentDetailsModal.show(payment).then(function (data) {
                cov_1iphnik2yw.f[12]++;
                cov_1iphnik2yw.s[24]++;

                _this3.member.$quotas.$refresh();
            });
        }
    }]);

    return MemberQuotasController;
}();

cov_1iphnik2yw.s[25]++;


angular.module('app').component('memberQuotas', {
    templateUrl: 'app/components/memberQuotas/memberQuotas.html',
    controller: MemberQuotasController,
    bindings: {
        member: '<'
    }
});
'use strict';

var cov_14ydsvtniq = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/homeView/homeView.js',
        hash = '97b88b46792c0280812bcd2b5fcf1a1a857a934a',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/homeView/homeView.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 43
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 39
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 37
                }
            },
            '4': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 76
                }
            },
            '5': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 9
                }
            },
            '6': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 21,
                    column: 15
                }
            },
            '7': {
                start: {
                    line: 13,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 17
                }
            },
            '8': {
                start: {
                    line: 14,
                    column: 20
                },
                end: {
                    line: 14,
                    column: 61
                }
            },
            '9': {
                start: {
                    line: 15,
                    column: 23
                },
                end: {
                    line: 20,
                    column: 17
                }
            },
            '10': {
                start: {
                    line: 16,
                    column: 20
                },
                end: {
                    line: 16,
                    column: 62
                }
            },
            '11': {
                start: {
                    line: 19,
                    column: 20
                },
                end: {
                    line: 19,
                    column: 55
                }
            },
            '12': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 25
                }
            },
            '13': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 31
                }
            },
            '14': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 25
                }
            },
            '15': {
                start: {
                    line: 32,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 31
                }
            },
            '16': {
                start: {
                    line: 36,
                    column: 8
                },
                end: {
                    line: 39,
                    column: 9
                }
            },
            '17': {
                start: {
                    line: 37,
                    column: 12
                },
                end: {
                    line: 37,
                    column: 41
                }
            },
            '18': {
                start: {
                    line: 38,
                    column: 12
                },
                end: {
                    line: 38,
                    column: 19
                }
            },
            '19': {
                start: {
                    line: 44,
                    column: 28
                },
                end: {
                    line: 44,
                    column: 32
                }
            },
            '20': {
                start: {
                    line: 45,
                    column: 8
                },
                end: {
                    line: 49,
                    column: 11
                }
            },
            '21': {
                start: {
                    line: 46,
                    column: 12
                },
                end: {
                    line: 48,
                    column: 13
                }
            },
            '22': {
                start: {
                    line: 47,
                    column: 16
                },
                end: {
                    line: 47,
                    column: 41
                }
            },
            '23': {
                start: {
                    line: 51,
                    column: 8
                },
                end: {
                    line: 51,
                    column: 29
                }
            },
            '24': {
                start: {
                    line: 56,
                    column: 8
                },
                end: {
                    line: 66,
                    column: 9
                }
            },
            '25': {
                start: {
                    line: 57,
                    column: 12
                },
                end: {
                    line: 64,
                    column: 14
                }
            },
            '26': {
                start: {
                    line: 65,
                    column: 12
                },
                end: {
                    line: 65,
                    column: 19
                }
            },
            '27': {
                start: {
                    line: 68,
                    column: 8
                },
                end: {
                    line: 78,
                    column: 9
                }
            },
            '28': {
                start: {
                    line: 69,
                    column: 12
                },
                end: {
                    line: 76,
                    column: 14
                }
            },
            '29': {
                start: {
                    line: 77,
                    column: 12
                },
                end: {
                    line: 77,
                    column: 19
                }
            },
            '30': {
                start: {
                    line: 80,
                    column: 8
                },
                end: {
                    line: 87,
                    column: 15
                }
            },
            '31': {
                start: {
                    line: 82,
                    column: 16
                },
                end: {
                    line: 82,
                    column: 39
                }
            },
            '32': {
                start: {
                    line: 91,
                    column: 8
                },
                end: {
                    line: 91,
                    column: 90
                }
            },
            '33': {
                start: {
                    line: 93,
                    column: 8
                },
                end: {
                    line: 95,
                    column: 11
                }
            },
            '34': {
                start: {
                    line: 94,
                    column: 12
                },
                end: {
                    line: 94,
                    column: 47
                }
            },
            '35': {
                start: {
                    line: 99,
                    column: 0
                },
                end: {
                    line: 107,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 83
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 14
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 10
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 37
                    },
                    end: {
                        line: 12,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 47
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 25,
                        column: 4
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 21
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                line: 25
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 30,
                        column: 4
                    },
                    end: {
                        line: 30,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 21
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                line: 30
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 35,
                        column: 4
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 22
                    },
                    end: {
                        line: 40,
                        column: 5
                    }
                },
                line: 35
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 43,
                        column: 25
                    },
                    end: {
                        line: 52,
                        column: 5
                    }
                },
                line: 43
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 45,
                        column: 32
                    },
                    end: {
                        line: 45,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 46
                    },
                    end: {
                        line: 49,
                        column: 9
                    }
                },
                line: 45
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 55,
                        column: 4
                    },
                    end: {
                        line: 55,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 55,
                        column: 15
                    },
                    end: {
                        line: 88,
                        column: 5
                    }
                },
                line: 55
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 81,
                        column: 12
                    },
                    end: {
                        line: 81,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 81,
                        column: 22
                    },
                    end: {
                        line: 84,
                        column: 13
                    }
                },
                line: 81
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 85,
                        column: 12
                    },
                    end: {
                        line: 85,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 85,
                        column: 18
                    },
                    end: {
                        line: 87,
                        column: 13
                    }
                },
                line: 85
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 90,
                        column: 4
                    },
                    end: {
                        line: 90,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 90,
                        column: 12
                    },
                    end: {
                        line: 96,
                        column: 5
                    }
                },
                line: 90
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 93,
                        column: 31
                    },
                    end: {
                        line: 93,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 93,
                        column: 37
                    },
                    end: {
                        line: 95,
                        column: 9
                    }
                },
                line: 93
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                }, {
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                }],
                line: 11
            },
            '1': {
                loc: {
                    start: {
                        line: 13,
                        column: 16
                    },
                    end: {
                        line: 20,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 13,
                        column: 16
                    },
                    end: {
                        line: 20,
                        column: 17
                    }
                }, {
                    start: {
                        line: 13,
                        column: 16
                    },
                    end: {
                        line: 20,
                        column: 17
                    }
                }],
                line: 13
            },
            '2': {
                loc: {
                    start: {
                        line: 15,
                        column: 23
                    },
                    end: {
                        line: 20,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 15,
                        column: 23
                    },
                    end: {
                        line: 20,
                        column: 17
                    }
                }, {
                    start: {
                        line: 15,
                        column: 23
                    },
                    end: {
                        line: 20,
                        column: 17
                    }
                }],
                line: 15
            },
            '3': {
                loc: {
                    start: {
                        line: 36,
                        column: 8
                    },
                    end: {
                        line: 39,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 36,
                        column: 8
                    },
                    end: {
                        line: 39,
                        column: 9
                    }
                }, {
                    start: {
                        line: 36,
                        column: 8
                    },
                    end: {
                        line: 39,
                        column: 9
                    }
                }],
                line: 36
            },
            '4': {
                loc: {
                    start: {
                        line: 36,
                        column: 12
                    },
                    end: {
                        line: 36,
                        column: 36
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 36,
                        column: 12
                    },
                    end: {
                        line: 36,
                        column: 22
                    }
                }, {
                    start: {
                        line: 36,
                        column: 26
                    },
                    end: {
                        line: 36,
                        column: 36
                    }
                }],
                line: 36
            },
            '5': {
                loc: {
                    start: {
                        line: 46,
                        column: 12
                    },
                    end: {
                        line: 48,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 46,
                        column: 12
                    },
                    end: {
                        line: 48,
                        column: 13
                    }
                }, {
                    start: {
                        line: 46,
                        column: 12
                    },
                    end: {
                        line: 48,
                        column: 13
                    }
                }],
                line: 46
            },
            '6': {
                loc: {
                    start: {
                        line: 56,
                        column: 8
                    },
                    end: {
                        line: 66,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 56,
                        column: 8
                    },
                    end: {
                        line: 66,
                        column: 9
                    }
                }, {
                    start: {
                        line: 56,
                        column: 8
                    },
                    end: {
                        line: 66,
                        column: 9
                    }
                }],
                line: 56
            },
            '7': {
                loc: {
                    start: {
                        line: 68,
                        column: 8
                    },
                    end: {
                        line: 78,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 68,
                        column: 8
                    },
                    end: {
                        line: 78,
                        column: 9
                    }
                }, {
                    start: {
                        line: 68,
                        column: 8
                    },
                    end: {
                        line: 78,
                        column: 9
                    }
                }],
                line: 68
            },
            '8': {
                loc: {
                    start: {
                        line: 68,
                        column: 12
                    },
                    end: {
                        line: 68,
                        column: 90
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 68,
                        column: 12
                    },
                    end: {
                        line: 68,
                        column: 28
                    }
                }, {
                    start: {
                        line: 68,
                        column: 33
                    },
                    end: {
                        line: 68,
                        column: 59
                    }
                }, {
                    start: {
                        line: 68,
                        column: 63
                    },
                    end: {
                        line: 68,
                        column: 89
                    }
                }],
                line: 68
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0],
            '7': [0, 0],
            '8': [0, 0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HomeViewController = function () {
    HomeViewController.$inject = ["UsersTable", "AuthService", "$state", "$rootScope", "EventCategoriesTable"];
    function HomeViewController(UsersTable, AuthService, $state, $rootScope, EventCategoriesTable) {
        _classCallCheck(this, HomeViewController);

        cov_14ydsvtniq.f[0]++;
        cov_14ydsvtniq.s[0]++;

        this.newUser = UsersTable.$build();
        cov_14ydsvtniq.s[1]++;
        this.AuthService = AuthService;
        cov_14ydsvtniq.s[2]++;
        this.$state = $state;
        cov_14ydsvtniq.s[3]++;
        this.$rootScope = $rootScope;
        cov_14ydsvtniq.s[4]++;
        this.eventCategories = EventCategoriesTable.$search({ page_size: 8 });
    }

    _createClass(HomeViewController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            cov_14ydsvtniq.f[1]++;
            cov_14ydsvtniq.s[5]++;

            if (this.$rootScope.me) {
                cov_14ydsvtniq.b[0][0]++;
                cov_14ydsvtniq.s[6]++;

                this.$rootScope.me.$then(function (user) {
                    cov_14ydsvtniq.f[2]++;
                    cov_14ydsvtniq.s[7]++;

                    if (user.type == 'MARKETEER') {
                        cov_14ydsvtniq.b[1][0]++;
                        cov_14ydsvtniq.s[8]++;

                        _this.$state.go('marketeers.membersList');
                    } else {
                            cov_14ydsvtniq.b[1][1]++;
                            cov_14ydsvtniq.s[9]++;
                            if (user.type == 'ACCOUNTANT') {
                                cov_14ydsvtniq.b[2][0]++;
                                cov_14ydsvtniq.s[10]++;

                                _this.$state.go('accountants.membersList');
                            } else {
                                cov_14ydsvtniq.b[2][1]++;
                                cov_14ydsvtniq.s[11]++;

                                _this.$state.go('amigos.dashboard');
                            }
                        }
                });
            } else {
                cov_14ydsvtniq.b[0][1]++;
            }
        }
    }, {
        key: 'selectType',
        value: function selectType(type) {
            cov_14ydsvtniq.f[3]++;
            cov_14ydsvtniq.s[12]++;

            this.type = type;
            cov_14ydsvtniq.s[13]++;
            this._selectCategory();
        }
    }, {
        key: 'selectPlan',
        value: function selectPlan(plan) {
            cov_14ydsvtniq.f[4]++;
            cov_14ydsvtniq.s[14]++;

            this.plan = plan;
            cov_14ydsvtniq.s[15]++;
            this._selectCategory();
        }
    }, {
        key: '_selectCategory',
        value: function _selectCategory() {
            cov_14ydsvtniq.f[5]++;
            cov_14ydsvtniq.s[16]++;

            if ((cov_14ydsvtniq.b[4][0]++, !this.plan) || (cov_14ydsvtniq.b[4][1]++, !this.type)) {
                cov_14ydsvtniq.b[3][0]++;
                cov_14ydsvtniq.s[17]++;

                this.newUser.category = null;
                cov_14ydsvtniq.s[18]++;
                return;
            } else {
                cov_14ydsvtniq.b[3][1]++;
            }
        }
    }, {
        key: '_getCategoryById',
        value: function _getCategoryById(id) {
            cov_14ydsvtniq.f[6]++;

            var finalCategory = (cov_14ydsvtniq.s[19]++, null);
            cov_14ydsvtniq.s[20]++;
            this.categories.forEach(function (category) {
                cov_14ydsvtniq.f[7]++;
                cov_14ydsvtniq.s[21]++;

                if (category.id == id) {
                    cov_14ydsvtniq.b[5][0]++;
                    cov_14ydsvtniq.s[22]++;

                    finalCategory = category;
                } else {
                    cov_14ydsvtniq.b[5][1]++;
                }
            });

            cov_14ydsvtniq.s[23]++;
            return finalCategory;
        }
    }, {
        key: 'saveUser',
        value: function saveUser() {
            var _this2 = this;

            cov_14ydsvtniq.f[8]++;
            cov_14ydsvtniq.s[24]++;

            if (!this.newUser.acceptTerms) {
                cov_14ydsvtniq.b[6][0]++;
                cov_14ydsvtniq.s[25]++;

                this.newUser.$response = {
                    status: 400,
                    data: {
                        acceptTerms: ["Para prosseguir tem que aceitar os termos e condições."]
                    }
                };
                cov_14ydsvtniq.s[26]++;
                return;
            } else {
                cov_14ydsvtniq.b[6][1]++;
            }

            cov_14ydsvtniq.s[27]++;
            if ((cov_14ydsvtniq.b[8][0]++, this.newUser.nif) && (cov_14ydsvtniq.b[8][1]++, this.newUser.nif[0] != '1') && (cov_14ydsvtniq.b[8][2]++, this.newUser.nif[0] != '2')) {
                cov_14ydsvtniq.b[7][0]++;
                cov_14ydsvtniq.s[28]++;

                this.newUser.$response = {
                    status: 400,
                    data: {
                        nif: ["Nº contribuinte inválido. Registo online apenas disponível para pessoas singulares."]
                    }
                };
                cov_14ydsvtniq.s[29]++;
                return;
            } else {
                cov_14ydsvtniq.b[7][1]++;
            }

            cov_14ydsvtniq.s[30]++;
            this.newUser.$save().$then(function (user) {
                cov_14ydsvtniq.f[9]++;
                cov_14ydsvtniq.s[31]++;

                _this2.registered = true;
            }, function () {
                cov_14ydsvtniq.f[10]++;
            });
        }
    }, {
        key: 'login',
        value: function login() {
            var _this3 = this;

            cov_14ydsvtniq.f[11]++;
            cov_14ydsvtniq.s[32]++;

            this.loginRequest = this.AuthService.login(this.login.email, this.login.password);

            cov_14ydsvtniq.s[33]++;
            this.loginRequest.then(function () {
                cov_14ydsvtniq.f[12]++;
                cov_14ydsvtniq.s[34]++;

                _this3.$state.go('amigos.dashboard');
            });
        }
    }]);

    return HomeViewController;
}();

cov_14ydsvtniq.s[35]++;


angular.module('app').component('homeView', {
    templateUrl: 'app/components/homeView/homeView.html',
    controller: HomeViewController,
    bindings: {
        categories: '<'
    }
});
'use strict';

var cov_1ka04zv660 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/memberPaymentsView/memberPaymentsView.js',
        hash = '36104ef20493f76d9170aa1132758ca719399874',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/memberPaymentsView/memberPaymentsView.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 9
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 55
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 46
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 37
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 25
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 10
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MemberPaymentsViewController = function () {
    MemberPaymentsViewController.$inject = ["PaymentDetailsModal"];
    function MemberPaymentsViewController(PaymentDetailsModal) {
        _classCallCheck(this, MemberPaymentsViewController);

        cov_1ka04zv660.f[0]++;
        cov_1ka04zv660.s[0]++;

        this.paymentStates = {
            CREATED: 'Em Rascunho', IN_PAYMENT: 'Pendente', PAID: 'Pago', CANCELED: 'Cancelado', INVALID: 'Inválido'
        };

        cov_1ka04zv660.s[1]++;
        this.PaymentDetailsModal = PaymentDetailsModal;
    }

    _createClass(MemberPaymentsViewController, [{
        key: 'showPayment',
        value: function showPayment(payment) {
            cov_1ka04zv660.f[1]++;
            cov_1ka04zv660.s[2]++;

            this.PaymentDetailsModal.show(payment);
        }
    }]);

    return MemberPaymentsViewController;
}();

cov_1ka04zv660.s[3]++;


angular.module('app').component('memberPaymentsView', {
    templateUrl: 'app/components/memberPaymentsView/memberPaymentsView.html',
    controller: MemberPaymentsViewController,
    bindings: {
        member: '<'
    }
});
'use strict';

var cov_1hutkht3d0 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/generateQuotasInput/generateQuotasInput.js',
        hash = '071d70cf06c6000cedb799c6c594af81ccc8a4b3',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/generateQuotasInput/generateQuotasInput.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 38
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 35
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 38
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 61
                }
            },
            '5': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 35
                }
            },
            '6': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 55
                }
            },
            '7': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 61
                }
            },
            '8': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 9
                }
            },
            '9': {
                start: {
                    line: 18,
                    column: 16
                },
                end: {
                    line: 18,
                    column: 58
                }
            },
            '10': {
                start: {
                    line: 19,
                    column: 16
                },
                end: {
                    line: 19,
                    column: 22
                }
            },
            '11': {
                start: {
                    line: 21,
                    column: 33
                },
                end: {
                    line: 24,
                    column: 17
                }
            },
            '12': {
                start: {
                    line: 25,
                    column: 16
                },
                end: {
                    line: 25,
                    column: 89
                }
            },
            '13': {
                start: {
                    line: 26,
                    column: 16
                },
                end: {
                    line: 26,
                    column: 22
                }
            },
            '14': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 28
                }
            },
            '15': {
                start: {
                    line: 33,
                    column: 24
                },
                end: {
                    line: 33,
                    column: 26
                }
            },
            '16': {
                start: {
                    line: 34,
                    column: 8
                },
                end: {
                    line: 73,
                    column: 10
                }
            },
            '17': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 64,
                    column: 14
                }
            },
            '18': {
                start: {
                    line: 36,
                    column: 31
                },
                end: {
                    line: 41,
                    column: 18
                }
            },
            '19': {
                start: {
                    line: 42,
                    column: 16
                },
                end: {
                    line: 62,
                    column: 18
                }
            },
            '20': {
                start: {
                    line: 42,
                    column: 42
                },
                end: {
                    line: 42,
                    column: 47
                }
            },
            '21': {
                start: {
                    line: 43,
                    column: 33
                },
                end: {
                    line: 47,
                    column: 22
                }
            },
            '22': {
                start: {
                    line: 48,
                    column: 20
                },
                end: {
                    line: 60,
                    column: 22
                }
            },
            '23': {
                start: {
                    line: 49,
                    column: 24
                },
                end: {
                    line: 59,
                    column: 25
                }
            },
            '24': {
                start: {
                    line: 50,
                    column: 43
                },
                end: {
                    line: 50,
                    column: 52
                }
            },
            '25': {
                start: {
                    line: 51,
                    column: 28
                },
                end: {
                    line: 55,
                    column: 29
                }
            },
            '26': {
                start: {
                    line: 52,
                    column: 32
                },
                end: {
                    line: 52,
                    column: 60
                }
            },
            '27': {
                start: {
                    line: 53,
                    column: 32
                },
                end: {
                    line: 53,
                    column: 70
                }
            },
            '28': {
                start: {
                    line: 53,
                    column: 61
                },
                end: {
                    line: 53,
                    column: 69
                }
            },
            '29': {
                start: {
                    line: 54,
                    column: 32
                },
                end: {
                    line: 54,
                    column: 57
                }
            },
            '30': {
                start: {
                    line: 56,
                    column: 28
                },
                end: {
                    line: 56,
                    column: 43
                }
            },
            '31': {
                start: {
                    line: 58,
                    column: 28
                },
                end: {
                    line: 58,
                    column: 40
                }
            },
            '32': {
                start: {
                    line: 61,
                    column: 20
                },
                end: {
                    line: 61,
                    column: 43
                }
            },
            '33': {
                start: {
                    line: 63,
                    column: 16
                },
                end: {
                    line: 63,
                    column: 41
                }
            },
            '34': {
                start: {
                    line: 65,
                    column: 27
                },
                end: {
                    line: 65,
                    column: 65
                }
            },
            '35': {
                start: {
                    line: 65,
                    column: 50
                },
                end: {
                    line: 65,
                    column: 64
                }
            },
            '36': {
                start: {
                    line: 66,
                    column: 12
                },
                end: {
                    line: 72,
                    column: 13
                }
            },
            '37': {
                start: {
                    line: 68,
                    column: 20
                },
                end: {
                    line: 68,
                    column: 58
                }
            },
            '38': {
                start: {
                    line: 69,
                    column: 20
                },
                end: {
                    line: 69,
                    column: 79
                }
            },
            '39': {
                start: {
                    line: 69,
                    column: 48
                },
                end: {
                    line: 69,
                    column: 78
                }
            },
            '40': {
                start: {
                    line: 71,
                    column: 26
                },
                end: {
                    line: 71,
                    column: 56
                }
            },
            '41': {
                start: {
                    line: 77,
                    column: 0
                },
                end: {
                    line: 85,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 76
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 15,
                        column: 4
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 19
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                line: 15
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 30,
                        column: 4
                    },
                    end: {
                        line: 30,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 11
                    },
                    end: {
                        line: 74,
                        column: 5
                    }
                },
                line: 30
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 34,
                        column: 63
                    },
                    end: {
                        line: 34,
                        column: 64
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 74
                    },
                    end: {
                        line: 73,
                        column: 9
                    }
                },
                line: 34
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 35,
                        column: 40
                    },
                    end: {
                        line: 35,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 49
                    },
                    end: {
                        line: 64,
                        column: 13
                    }
                },
                line: 35
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 42,
                        column: 31
                    },
                    end: {
                        line: 42,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 42
                    },
                    end: {
                        line: 42,
                        column: 47
                    }
                },
                line: 42
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 42,
                        column: 49
                    },
                    end: {
                        line: 42,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 55
                    },
                    end: {
                        line: 62,
                        column: 17
                    }
                },
                line: 42
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 48,
                        column: 33
                    },
                    end: {
                        line: 48,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 48,
                        column: 43
                    },
                    end: {
                        line: 60,
                        column: 21
                    }
                },
                line: 48
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 53,
                        column: 55
                    },
                    end: {
                        line: 53,
                        column: 56
                    }
                },
                loc: {
                    start: {
                        line: 53,
                        column: 61
                    },
                    end: {
                        line: 53,
                        column: 69
                    }
                },
                line: 53
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 65,
                        column: 41
                    },
                    end: {
                        line: 65,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 65,
                        column: 50
                    },
                    end: {
                        line: 65,
                        column: 64
                    }
                },
                line: 65
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 67,
                        column: 16
                    },
                    end: {
                        line: 67,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 67,
                        column: 26
                    },
                    end: {
                        line: 70,
                        column: 17
                    }
                },
                line: 67
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 69,
                        column: 42
                    },
                    end: {
                        line: 69,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 48
                    },
                    end: {
                        line: 69,
                        column: 78
                    }
                },
                line: 69
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 71,
                        column: 16
                    },
                    end: {
                        line: 71,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 71,
                        column: 26
                    },
                    end: {
                        line: 71,
                        column: 56
                    }
                },
                line: 71
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 16,
                        column: 8
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 17,
                        column: 12
                    },
                    end: {
                        line: 19,
                        column: 22
                    }
                }, {
                    start: {
                        line: 20,
                        column: 12
                    },
                    end: {
                        line: 26,
                        column: 22
                    }
                }],
                line: 16
            },
            '1': {
                loc: {
                    start: {
                        line: 22,
                        column: 27
                    },
                    end: {
                        line: 22,
                        column: 55
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 22,
                        column: 50
                    },
                    end: {
                        line: 22,
                        column: 51
                    }
                }, {
                    start: {
                        line: 22,
                        column: 54
                    },
                    end: {
                        line: 22,
                        column: 55
                    }
                }],
                line: 22
            },
            '2': {
                loc: {
                    start: {
                        line: 23,
                        column: 25
                    },
                    end: {
                        line: 23,
                        column: 54
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 23,
                        column: 48
                    },
                    end: {
                        line: 23,
                        column: 49
                    }
                }, {
                    start: {
                        line: 23,
                        column: 52
                    },
                    end: {
                        line: 23,
                        column: 54
                    }
                }],
                line: 23
            },
            '3': {
                loc: {
                    start: {
                        line: 49,
                        column: 24
                    },
                    end: {
                        line: 59,
                        column: 25
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 49,
                        column: 24
                    },
                    end: {
                        line: 59,
                        column: 25
                    }
                }, {
                    start: {
                        line: 49,
                        column: 24
                    },
                    end: {
                        line: 59,
                        column: 25
                    }
                }],
                line: 49
            },
            '4': {
                loc: {
                    start: {
                        line: 51,
                        column: 28
                    },
                    end: {
                        line: 55,
                        column: 29
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 51,
                        column: 28
                    },
                    end: {
                        line: 55,
                        column: 29
                    }
                }, {
                    start: {
                        line: 51,
                        column: 28
                    },
                    end: {
                        line: 55,
                        column: 29
                    }
                }],
                line: 51
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GenerateQuotasInputController = function () {
    GenerateQuotasInputController.$inject = ["QuotasTable", "$q", "$mdDialog", "PaymentTypesTable", "OrdersTable"];
    function GenerateQuotasInputController(QuotasTable, $q, $mdDialog, PaymentTypesTable, OrdersTable) {
        _classCallCheck(this, GenerateQuotasInputController);

        cov_1hutkht3d0.f[0]++;
        cov_1hutkht3d0.s[0]++;

        this.QuotasTable = QuotasTable;
        cov_1hutkht3d0.s[1]++;
        this.$mdDialog = $mdDialog;
        cov_1hutkht3d0.s[2]++;
        this.$q = $q;
        cov_1hutkht3d0.s[3]++;
        this.OrdersTable = OrdersTable;

        cov_1hutkht3d0.s[4]++;
        this.generateTypes = ['Anual', 'Semestral', 'Mensal'];
        cov_1hutkht3d0.s[5]++;
        this.generateType = 'Anual';
        cov_1hutkht3d0.s[6]++;
        this.paymentTypes = PaymentTypesTable.$search();

        cov_1hutkht3d0.s[7]++;
        this.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    }

    _createClass(GenerateQuotasInputController, [{
        key: 'selectMonths',
        value: function selectMonths() {
            cov_1hutkht3d0.f[1]++;
            cov_1hutkht3d0.s[8]++;

            switch (this.generateType) {
                case 'Anual':
                    cov_1hutkht3d0.b[0][0]++;
                    cov_1hutkht3d0.s[9]++;

                    this.selectedMonths = this.months.slice(0);
                    cov_1hutkht3d0.s[10]++;
                    break;
                case 'Semestral':
                    cov_1hutkht3d0.b[0][1]++;

                    var slicePoint = (cov_1hutkht3d0.s[11]++, {
                        start: this.semestre == 1 ? (cov_1hutkht3d0.b[1][0]++, 0) : (cov_1hutkht3d0.b[1][1]++, 6),
                        end: this.semestre == 1 ? (cov_1hutkht3d0.b[2][0]++, 6) : (cov_1hutkht3d0.b[2][1]++, 12)
                    });
                    cov_1hutkht3d0.s[12]++;
                    this.selectedMonths = this.months.slice(slicePoint.start, slicePoint.end);
                    cov_1hutkht3d0.s[13]++;
                    break;
            }
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            cov_1hutkht3d0.f[2]++;
            cov_1hutkht3d0.s[14]++;

            this.loading = true;

            var newQuotas = (cov_1hutkht3d0.s[15]++, []);
            cov_1hutkht3d0.s[16]++;
            this.OrdersTable.$create({ user: this.member.id }).$then(function (payment) {
                cov_1hutkht3d0.f[3]++;
                cov_1hutkht3d0.s[17]++;

                _this.selectedMonths.forEach(function (month) {
                    cov_1hutkht3d0.f[4]++;

                    var newQuota = (cov_1hutkht3d0.s[18]++, _this.QuotasTable.$create({
                        user: _this.member.id,
                        year: _this.year,
                        month: month,
                        order: payment.id
                    }));
                    cov_1hutkht3d0.s[19]++;
                    newQuota.$then(function (quota) {
                        cov_1hutkht3d0.f[5]++;
                        cov_1hutkht3d0.s[20]++;
                        return quota;
                    }, function () {
                        cov_1hutkht3d0.f[6]++;

                        var search = (cov_1hutkht3d0.s[21]++, _this.QuotasTable.$search({
                            user: _this.member.id,
                            year: _this.year,
                            month: month
                        }));
                        cov_1hutkht3d0.s[22]++;
                        search.$then(function (quotas) {
                            cov_1hutkht3d0.f[7]++;
                            cov_1hutkht3d0.s[23]++;

                            if (quotas[0]) {
                                cov_1hutkht3d0.b[3][0]++;

                                var oldQuota = (cov_1hutkht3d0.s[24]++, quotas[0]);
                                cov_1hutkht3d0.s[25]++;
                                if (oldQuota.state == 'PENDING') {
                                    cov_1hutkht3d0.b[4][0]++;
                                    cov_1hutkht3d0.s[26]++;

                                    oldQuota.order = payment.id;
                                    cov_1hutkht3d0.s[27]++;
                                    oldQuota.$save().$then(function () {
                                        cov_1hutkht3d0.f[8]++;
                                        cov_1hutkht3d0.s[28]++;
                                        return oldQuota;
                                    });
                                    cov_1hutkht3d0.s[29]++;
                                    return oldQuota.$promise;
                                } else {
                                    cov_1hutkht3d0.b[4][1]++;
                                }
                                cov_1hutkht3d0.s[30]++;
                                return oldQuota;
                            } else {
                                cov_1hutkht3d0.b[3][1]++;
                                cov_1hutkht3d0.s[31]++;

                                return false;
                            }
                        });
                        cov_1hutkht3d0.s[32]++;
                        return search.$promise;
                    });
                    cov_1hutkht3d0.s[33]++;
                    newQuotas.push(newQuota);
                });
                var promises = (cov_1hutkht3d0.s[34]++, newQuotas.map(function (quota) {
                    cov_1hutkht3d0.f[9]++;
                    cov_1hutkht3d0.s[35]++;
                    return quota.$promise;
                }));
                cov_1hutkht3d0.s[36]++;
                _this.creating = _this.$q.all(promises).then(function (quotas) {
                    cov_1hutkht3d0.f[10]++;
                    cov_1hutkht3d0.s[37]++;

                    payment.paymentType = _this.paymentType;
                    cov_1hutkht3d0.s[38]++;
                    payment.$save().$then(function () {
                        cov_1hutkht3d0.f[11]++;
                        cov_1hutkht3d0.s[39]++;
                        return _this.$mdDialog.hide(newQuotas);
                    });
                }, function (quotas) {
                    cov_1hutkht3d0.f[12]++;
                    cov_1hutkht3d0.s[40]++;
                    return _this.$mdDialog.hide(newQuotas);
                });
            });
        }
    }]);

    return GenerateQuotasInputController;
}();

cov_1hutkht3d0.s[41]++;


angular.module('app').component('generateQuotasInput', {
    templateUrl: 'app/components/generateQuotasInput/generateQuotasInput.html',
    controller: GenerateQuotasInputController,
    bindings: {
        member: '<'
    }
});
'use strict';

var cov_6jc18zwst = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/footer/footer.js',
        hash = 'bf28539810c4a929a7fb119d0a1383c2cd6ea95e',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/footer/footer.js',
        statementMap: {
            '0': {
                start: {
                    line: 5,
                    column: 0
                },
                end: {
                    line: 10,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FooterController = function FooterController() {
    _classCallCheck(this, FooterController);
};

cov_6jc18zwst.s[0]++;


angular.module('app').component('footer', {
    templateUrl: 'app/components/footer/footer.html',
    controller: FooterController
});
'use strict';

var cov_1hmflywjfa = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/editQuotaPriceView/editQuotaPriceView.js',
        hash = '71c76bfe70aaa2beacee107bed003bbd240bd35e',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/editQuotaPriceView/editQuotaPriceView.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 55
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 52
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 44
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 43
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 64
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 10
                }
            },
            '6': {
                start: {
                    line: 16,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 41
                }
            },
            '7': {
                start: {
                    line: 17,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 77
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 0
                },
                end: {
                    line: 31,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 53
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 9,
                        column: 4
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 14
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 14,
                        column: 4
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 11
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 14
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 15,
                        column: 36
                    },
                    end: {
                        line: 15,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 47
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 15
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditQuotaPriceViewController = function () {
    EditQuotaPriceViewController.$inject = ["UserTypePricesTable", "UserTypesTable"];
    function EditQuotaPriceViewController(UserTypePricesTable, UserTypesTable) {
        _classCallCheck(this, EditQuotaPriceViewController);

        cov_1hmflywjfa.f[0]++;
        cov_1hmflywjfa.s[0]++;

        this.UserTypePricesTable = UserTypePricesTable;
        cov_1hmflywjfa.s[1]++;
        this.newPrice = UserTypePricesTable.$build();

        cov_1hmflywjfa.s[2]++;
        this.UserTypesTable = UserTypesTable;
    }

    _createClass(EditQuotaPriceViewController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1hmflywjfa.f[1]++;
            cov_1hmflywjfa.s[3]++;

            this.newPrice.userType = this.type;
            cov_1hmflywjfa.s[4]++;
            this.userTypeName = this.UserTypesTable.$find(this.type);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            cov_1hmflywjfa.f[2]++;
            cov_1hmflywjfa.s[5]++;

            this.newPrice.$save().$then(function (price) {
                cov_1hmflywjfa.f[3]++;
                cov_1hmflywjfa.s[6]++;

                _this.onChange({ price: price });
                cov_1hmflywjfa.s[7]++;
                _this.newPrice = UserTypePricesTable.$build({ userType: _this.type });
            });
        }
    }]);

    return EditQuotaPriceViewController;
}();

cov_1hmflywjfa.s[8]++;


angular.module('app').component('editQuotaPriceView', {
    templateUrl: 'app/components/editQuotaPriceView/editQuotaPriceView.html',
    controller: EditQuotaPriceViewController,
    bindings: {
        type: '<',
        onChange: '&'
    }
});
'use strict';

var cov_1wis9g921z = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/dashboard/dashboard.js',
        hash = '020b3f0a214edc37f9198ce6b7d9e2f71cdb9e87',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/dashboard/dashboard.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 11
                }
            },
            '1': {
                start: {
                    line: 6,
                    column: 12
                },
                end: {
                    line: 8,
                    column: 13
                }
            },
            '2': {
                start: {
                    line: 7,
                    column: 16
                },
                end: {
                    line: 7,
                    column: 46
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 11
                }
            },
            '4': {
                start: {
                    line: 28,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 29
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 17
                    },
                    end: {
                        line: 5,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 29
                    },
                    end: {
                        line: 13,
                        column: 9
                    }
                },
                line: 5
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 15,
                        column: 50
                    },
                    end: {
                        line: 15,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 62
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                },
                line: 15
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 23,
                        column: 4
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 14
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 23
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 6,
                        column: 12
                    },
                    end: {
                        line: 8,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 6,
                        column: 12
                    },
                    end: {
                        line: 8,
                        column: 13
                    }
                }, {
                    start: {
                        line: 6,
                        column: 12
                    },
                    end: {
                        line: 8,
                        column: 13
                    }
                }],
                line: 6
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DashboardController = function () {
    DashboardController.$inject = ["OrdersTable"];
    function DashboardController(OrdersTable) {
        var _this = this;

        _classCallCheck(this, DashboardController);

        cov_1wis9g921z.f[0]++;
        cov_1wis9g921z.s[0]++;

        OrdersTable.$search({
            state: 'IN_PAYMENT'
        }).$then(function (orders) {
            cov_1wis9g921z.f[1]++;
            cov_1wis9g921z.s[1]++;

            if (orders.length > 0) {
                cov_1wis9g921z.b[0][0]++;
                cov_1wis9g921z.s[2]++;

                _this.pendingOrder = orders[0];
            } else {
                cov_1wis9g921z.b[0][1]++;
            }
            /*orders.forEach((order) => {
                order.$load('paymentIfthen').$load('items');
                order.$items.$then((items) => items.$load('item'));
            })*/
        });

        cov_1wis9g921z.s[3]++;
        this.orders = OrdersTable.$search().$then(function (orders) {
            /*orders.forEach((order) => {
                order.$load('items');
                order.$items.$then((items) => items.$load('item'));
            });*/

            cov_1wis9g921z.f[2]++;
        });
    }

    _createClass(DashboardController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1wis9g921z.f[3]++;
        }
    }]);

    return DashboardController;
}();

cov_1wis9g921z.s[4]++;


angular.module('app').component('dashboard', {
    templateUrl: 'app/components/dashboard/dashboard.html',
    controller: DashboardController,
    bindings: {
        user: '<'
    }
});
'use strict';

var cov_njsmiiuci = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.set.password.controller.js',
        hash = '66ccdb2cabdd85e2af62301d8c8eca0e56950f1c',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.set.password.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 50,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 76
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 30
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 37
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 19,
                    column: 12
                },
                end: {
                    line: 21,
                    column: 13
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 35
                }
            },
            '8': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 47,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 34,
                    column: 16
                },
                end: {
                    line: 38,
                    column: 18
                }
            },
            '10': {
                start: {
                    line: 39,
                    column: 16
                },
                end: {
                    line: 39,
                    column: 35
                }
            },
            '11': {
                start: {
                    line: 41,
                    column: 16
                },
                end: {
                    line: 45,
                    column: 18
                }
            },
            '12': {
                start: {
                    line: 46,
                    column: 16
                },
                end: {
                    line: 46,
                    column: 42
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 50,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthSetPasswordController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 91
                    },
                    end: {
                        line: 49,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 18,
                        column: 17
                    },
                    end: {
                        line: 18,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 28
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                },
                line: 18
            },
            '3': {
                name: 'setPassword',
                decl: {
                    start: {
                        line: 24,
                        column: 17
                    },
                    end: {
                        line: 24,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 31
                    },
                    end: {
                        line: 48,
                        column: 9
                    }
                },
                line: 24
            },
            '4': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 33,
                        column: 29
                    },
                    end: {
                        line: 33,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 47
                    },
                    end: {
                        line: 40,
                        column: 13
                    }
                },
                line: 33
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 40,
                        column: 15
                    },
                    end: {
                        line: 40,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 27
                    },
                    end: {
                        line: 47,
                        column: 13
                    }
                },
                line: 40
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                }, {
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                }],
                line: 19
            },
            '1': {
                loc: {
                    start: {
                        line: 19,
                        column: 16
                    },
                    end: {
                        line: 19,
                        column: 58
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 19,
                        column: 16
                    },
                    end: {
                        line: 19,
                        column: 35
                    }
                }, {
                    start: {
                        line: 19,
                        column: 39
                    },
                    end: {
                        line: 19,
                        column: 58
                    }
                }],
                line: 19
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_njsmiiuci.s[0]++;
(function () {
    'use strict';

    AuthSetPasswordController.$inject = ["$state", "$http", "AppSettings", "$stateParams", "$mdToast"];
    cov_njsmiiuci.f[0]++;
    cov_njsmiiuci.s[1]++;
    angular.module('app').controller('AuthSetPasswordController', AuthSetPasswordController);

    /* @ngInject */
    function AuthSetPasswordController($state, $http, AppSettings, $stateParams, $mdToast) {
        cov_njsmiiuci.f[1]++;

        var vm = (cov_njsmiiuci.s[2]++, this);

        cov_njsmiiuci.s[3]++;
        vm.requestStatus = {};

        cov_njsmiiuci.s[4]++;
        vm.setPassword = setPassword;

        cov_njsmiiuci.s[5]++;
        activate();

        function activate() {
            cov_njsmiiuci.f[2]++;
            cov_njsmiiuci.s[6]++;

            if ((cov_njsmiiuci.b[1][0]++, !$stateParams.email) || (cov_njsmiiuci.b[1][1]++, !$stateParams.token)) {
                cov_njsmiiuci.b[0][0]++;
                cov_njsmiiuci.s[7]++;

                $state.go('login');
            } else {
                cov_njsmiiuci.b[0][1]++;
            }
        }

        function setPassword() {
            cov_njsmiiuci.f[3]++;
            cov_njsmiiuci.s[8]++;

            vm.requestStatus = $http({
                method: 'POST',
                url: AppSettings.apiUrl + '/users/set_password/',
                data: {
                    email: $stateParams.email,
                    token: $stateParams.token,
                    password: vm.password
                }
            }).then(function successCallback() {
                cov_njsmiiuci.f[4]++;
                cov_njsmiiuci.s[9]++;

                $mdToast.show($mdToast.simple().textContent('Your password has been changed!').hideDelay(3000));
                cov_njsmiiuci.s[10]++;
                $state.go('login');
            }, function () {
                cov_njsmiiuci.f[5]++;
                cov_njsmiiuci.s[11]++;

                $mdToast.show($mdToast.simple().textContent('An error has ocurred!').hideDelay(3000));
                cov_njsmiiuci.s[12]++;
                $state.go('projectsList');
            });
        }
    }
})();
'use strict';

var cov_2ixc6wy3ed = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.service.js',
        hash = '2d438aa52358e796fc5e4eb8d062a5a443cb84bb',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.service.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 46,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 26
                },
                end: {
                    line: 10,
                    column: 30
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 31
                },
                end: {
                    line: 12,
                    column: 78
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '6': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 14,
                    column: 62
                }
            },
            '7': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 29
                }
            },
            '8': {
                start: {
                    line: 19,
                    column: 12
                },
                end: {
                    line: 19,
                    column: 32
                }
            },
            '9': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 10
                }
            },
            '10': {
                start: {
                    line: 23,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 24,
                    column: 16
                },
                end: {
                    line: 24,
                    column: 62
                }
            },
            '12': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 35,
                    column: 10
                }
            },
            '13': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 15
                }
            },
            '14': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 53
                }
            },
            '15': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 37
                }
            },
            '16': {
                start: {
                    line: 34,
                    column: 12
                },
                end: {
                    line: 34,
                    column: 42
                }
            },
            '17': {
                start: {
                    line: 37,
                    column: 8
                },
                end: {
                    line: 44,
                    column: 10
                }
            },
            '18': {
                start: {
                    line: 38,
                    column: 32
                },
                end: {
                    line: 38,
                    column: 46
                }
            },
            '19': {
                start: {
                    line: 39,
                    column: 12
                },
                end: {
                    line: 42,
                    column: 15
                }
            },
            '20': {
                start: {
                    line: 40,
                    column: 16
                },
                end: {
                    line: 40,
                    column: 38
                }
            },
            '21': {
                start: {
                    line: 41,
                    column: 16
                },
                end: {
                    line: 41,
                    column: 40
                }
            },
            '22': {
                start: {
                    line: 43,
                    column: 12
                },
                end: {
                    line: 43,
                    column: 33
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 46,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'service',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 60
                    },
                    end: {
                        line: 45,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 21
                    },
                    end: {
                        line: 11,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 48
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 13,
                        column: 30
                    },
                    end: {
                        line: 13,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 42
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                },
                line: 13
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 15,
                        column: 15
                    },
                    end: {
                        line: 15,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 32
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                },
                line: 15
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 22,
                        column: 29
                    },
                    end: {
                        line: 22,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 41
                    },
                    end: {
                        line: 26,
                        column: 9
                    }
                },
                line: 22
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 23,
                        column: 55
                    },
                    end: {
                        line: 23,
                        column: 56
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 67
                    },
                    end: {
                        line: 25,
                        column: 13
                    }
                },
                line: 23
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 28,
                        column: 40
                    },
                    end: {
                        line: 28,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 52
                    },
                    end: {
                        line: 35,
                        column: 9
                    }
                },
                line: 28
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 29,
                        column: 57
                    },
                    end: {
                        line: 29,
                        column: 58
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 69
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 29
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 37,
                        column: 22
                    },
                    end: {
                        line: 37,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 34
                    },
                    end: {
                        line: 44,
                        column: 9
                    }
                },
                line: 37
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 39,
                        column: 31
                    },
                    end: {
                        line: 39,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 39,
                        column: 43
                    },
                    end: {
                        line: 42,
                        column: 13
                    }
                },
                line: 39
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2ixc6wy3ed.s[0]++;
(function () {
    'use strict';

    service.$inject = ["$auth", "$rootScope", "$state", "UsersTable"];
    cov_2ixc6wy3ed.f[0]++;
    cov_2ixc6wy3ed.s[1]++;
    angular.module('app').service('AuthService', service);

    /* @ngInject */
    function service($auth, $rootScope, $state, UsersTable) {
        cov_2ixc6wy3ed.f[1]++;

        var AuthService = (cov_2ixc6wy3ed.s[2]++, this);
        cov_2ixc6wy3ed.s[3]++;
        this.login = function (email, password) {
            cov_2ixc6wy3ed.f[2]++;

            var loginPromise = (cov_2ixc6wy3ed.s[4]++, $auth.login({ email: email, password: password }));
            cov_2ixc6wy3ed.s[5]++;
            loginPromise.then(function () {
                cov_2ixc6wy3ed.f[3]++;
                cov_2ixc6wy3ed.s[6]++;

                return AuthService.refreshAuthenticatedInfo();
            }, function (error) {
                cov_2ixc6wy3ed.f[4]++;
                cov_2ixc6wy3ed.s[7]++;

                return error;
            });

            cov_2ixc6wy3ed.s[8]++;
            return loginPromise;
        };

        cov_2ixc6wy3ed.s[9]++;
        this.loginFacebook = function () {
            cov_2ixc6wy3ed.f[5]++;
            cov_2ixc6wy3ed.s[10]++;

            return $auth.authenticate('facebook').then(function () {
                cov_2ixc6wy3ed.f[6]++;
                cov_2ixc6wy3ed.s[11]++;

                return AuthService.refreshAuthenticatedInfo();
            });
        };

        cov_2ixc6wy3ed.s[12]++;
        this.refreshAuthenticatedInfo = function () {
            cov_2ixc6wy3ed.f[7]++;
            cov_2ixc6wy3ed.s[13]++;

            $rootScope.me = UsersTable.$find('me').$then(function () {
                cov_2ixc6wy3ed.f[8]++;
                cov_2ixc6wy3ed.s[14]++;

                $rootScope.me.$pk = $rootScope.me.id;
                cov_2ixc6wy3ed.s[15]++;
                return $rootScope.me;
            });

            cov_2ixc6wy3ed.s[16]++;
            return $rootScope.me.$promise;
        };

        cov_2ixc6wy3ed.s[17]++;
        this.logout = function () {
            cov_2ixc6wy3ed.f[9]++;

            var logoutPromise = (cov_2ixc6wy3ed.s[18]++, $auth.logout());
            cov_2ixc6wy3ed.s[19]++;
            logoutPromise.then(function () {
                cov_2ixc6wy3ed.f[10]++;
                cov_2ixc6wy3ed.s[20]++;

                $rootScope.me = false;
                cov_2ixc6wy3ed.s[21]++;
                $rootScope.cart = false;
            });
            cov_2ixc6wy3ed.s[22]++;
            return logoutPromise;
        };
    }
})();
'use strict';

var cov_2hrtdhcd0r = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.run.js',
        hash = '3b673b252c3fdad0d09fa89a719f21e532f03376',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.run.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 32,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 19
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 9
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 16
                },
                end: {
                    line: 13,
                    column: 62
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 11
                }
            },
            '6': {
                start: {
                    line: 18,
                    column: 12
                },
                end: {
                    line: 20,
                    column: 13
                }
            },
            '7': {
                start: {
                    line: 19,
                    column: 16
                },
                end: {
                    line: 19,
                    column: 35
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 12
                },
                end: {
                    line: 28,
                    column: 13
                }
            },
            '9': {
                start: {
                    line: 23,
                    column: 16
                },
                end: {
                    line: 27,
                    column: 19
                }
            },
            '10': {
                start: {
                    line: 24,
                    column: 20
                },
                end: {
                    line: 26,
                    column: 21
                }
            },
            '11': {
                start: {
                    line: 25,
                    column: 24
                },
                end: {
                    line: 25,
                    column: 48
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 32,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 77
                    },
                    end: {
                        line: 30,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 56
                    },
                    end: {
                        line: 11,
                        column: 57
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 68
                    },
                    end: {
                        line: 12,
                        column: 13
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 12,
                        column: 15
                    },
                    end: {
                        line: 12,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 27
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                },
                line: 12
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 17,
                        column: 33
                    },
                    end: {
                        line: 17,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 50
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                },
                line: 17
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 23,
                        column: 36
                    },
                    end: {
                        line: 23,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 42
                    },
                    end: {
                        line: 27,
                        column: 17
                    }
                },
                line: 23
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 10,
                        column: 8
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 10,
                        column: 8
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                }, {
                    start: {
                        line: 10,
                        column: 8
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                }],
                line: 10
            },
            '1': {
                loc: {
                    start: {
                        line: 18,
                        column: 12
                    },
                    end: {
                        line: 20,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 18,
                        column: 12
                    },
                    end: {
                        line: 20,
                        column: 13
                    }
                }, {
                    start: {
                        line: 18,
                        column: 12
                    },
                    end: {
                        line: 20,
                        column: 13
                    }
                }],
                line: 18
            },
            '2': {
                loc: {
                    start: {
                        line: 18,
                        column: 16
                    },
                    end: {
                        line: 18,
                        column: 56
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 18,
                        column: 16
                    },
                    end: {
                        line: 18,
                        column: 29
                    }
                }, {
                    start: {
                        line: 18,
                        column: 33
                    },
                    end: {
                        line: 18,
                        column: 56
                    }
                }],
                line: 18
            },
            '3': {
                loc: {
                    start: {
                        line: 22,
                        column: 12
                    },
                    end: {
                        line: 28,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 22,
                        column: 12
                    },
                    end: {
                        line: 28,
                        column: 13
                    }
                }, {
                    start: {
                        line: 22,
                        column: 12
                    },
                    end: {
                        line: 28,
                        column: 13
                    }
                }],
                line: 22
            },
            '4': {
                loc: {
                    start: {
                        line: 22,
                        column: 16
                    },
                    end: {
                        line: 22,
                        column: 56
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 22,
                        column: 16
                    },
                    end: {
                        line: 22,
                        column: 29
                    }
                }, {
                    start: {
                        line: 22,
                        column: 33
                    },
                    end: {
                        line: 22,
                        column: 56
                    }
                }],
                line: 22
            },
            '5': {
                loc: {
                    start: {
                        line: 24,
                        column: 20
                    },
                    end: {
                        line: 26,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 24,
                        column: 20
                    },
                    end: {
                        line: 26,
                        column: 21
                    }
                }, {
                    start: {
                        line: 24,
                        column: 20
                    },
                    end: {
                        line: 26,
                        column: 21
                    }
                }],
                line: 24
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2hrtdhcd0r.s[0]++;
(function () {
    'use strict';

    runBlock.$inject = ["$rootScope", "$state", "$auth", "AuthService", "$transitions"];
    cov_2hrtdhcd0r.f[0]++;
    cov_2hrtdhcd0r.s[1]++;
    angular.module('app').run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state, $auth, AuthService, $transitions) {
        cov_2hrtdhcd0r.f[1]++;
        cov_2hrtdhcd0r.s[2]++;

        if ($auth.isAuthenticated()) {
            cov_2hrtdhcd0r.b[0][0]++;
            cov_2hrtdhcd0r.s[3]++;

            AuthService.refreshAuthenticatedInfo().then(function () {
                cov_2hrtdhcd0r.f[2]++;
            }, function () {
                cov_2hrtdhcd0r.f[3]++;
                cov_2hrtdhcd0r.s[4]++;

                AuthService.logout().then($state.go('login'));
            });
        } else {
            cov_2hrtdhcd0r.b[0][1]++;
        }

        cov_2hrtdhcd0r.s[5]++;
        $transitions.onStart({}, function (trans) {
            cov_2hrtdhcd0r.f[4]++;
            cov_2hrtdhcd0r.s[6]++;

            if ((cov_2hrtdhcd0r.b[2][0]++, $rootScope.me) && (cov_2hrtdhcd0r.b[2][1]++, trans.to().requireLogin)) {
                cov_2hrtdhcd0r.b[1][0]++;
                cov_2hrtdhcd0r.s[7]++;

                $state.go("login");
            } else {
                cov_2hrtdhcd0r.b[1][1]++;
            }

            cov_2hrtdhcd0r.s[8]++;
            if ((cov_2hrtdhcd0r.b[4][0]++, $rootScope.me) && (cov_2hrtdhcd0r.b[4][1]++, trans.to().requireAmigo)) {
                cov_2hrtdhcd0r.b[3][0]++;
                cov_2hrtdhcd0r.s[9]++;

                $rootScope.me.$then(function () {
                    cov_2hrtdhcd0r.f[5]++;
                    cov_2hrtdhcd0r.s[10]++;

                    if ($rootScope.me.associationState != 'REGULAR') {
                        cov_2hrtdhcd0r.b[5][0]++;
                        cov_2hrtdhcd0r.s[11]++;

                        $state.go('amigos.pay');
                    } else {
                        cov_2hrtdhcd0r.b[5][1]++;
                    }
                });
            } else {
                cov_2hrtdhcd0r.b[3][1]++;
            }
        });
    }
})();
'use strict';

var cov_8zz4ogum5 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.register.controller.js',
        hash = 'f4e8eb377efdbf82ddcd1020f1df05d34bf5c78c',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.register.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 51,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 66
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 30
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 38
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 32
                }
            },
            '6': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 26
                }
            },
            '7': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 27
                }
            },
            '9': {
                start: {
                    line: 20,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 19
                }
            },
            '10': {
                start: {
                    line: 27,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 28,
                    column: 16
                },
                end: {
                    line: 28,
                    column: 39
                }
            },
            '12': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 100
                }
            },
            '13': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 48,
                    column: 15
                }
            },
            '14': {
                start: {
                    line: 42,
                    column: 16
                },
                end: {
                    line: 42,
                    column: 33
                }
            },
            '15': {
                start: {
                    line: 43,
                    column: 16
                },
                end: {
                    line: 43,
                    column: 98
                }
            },
            '16': {
                start: {
                    line: 44,
                    column: 16
                },
                end: {
                    line: 44,
                    column: 32
                }
            },
            '17': {
                start: {
                    line: 46,
                    column: 16
                },
                end: {
                    line: 46,
                    column: 99
                }
            },
            '18': {
                start: {
                    line: 47,
                    column: 16
                },
                end: {
                    line: 47,
                    column: 32
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 51,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthRegisterController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 78
                    },
                    end: {
                        line: 50,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 22,
                        column: 17
                    },
                    end: {
                        line: 22,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 28
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                },
                line: 22
            },
            '3': {
                name: 'register',
                decl: {
                    start: {
                        line: 26,
                        column: 17
                    },
                    end: {
                        line: 26,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 28
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 26
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 27,
                        column: 34
                    },
                    end: {
                        line: 27,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 46
                    },
                    end: {
                        line: 29,
                        column: 13
                    }
                },
                line: 27
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 29,
                        column: 15
                    },
                    end: {
                        line: 29,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 27
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                },
                line: 29
            },
            '6': {
                name: 'resend',
                decl: {
                    start: {
                        line: 34,
                        column: 17
                    },
                    end: {
                        line: 34,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 26
                    },
                    end: {
                        line: 49,
                        column: 9
                    }
                },
                line: 34
            },
            '7': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 41,
                        column: 29
                    },
                    end: {
                        line: 41,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 41,
                        column: 55
                    },
                    end: {
                        line: 45,
                        column: 13
                    }
                },
                line: 41
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 45,
                        column: 15
                    },
                    end: {
                        line: 45,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 35
                    },
                    end: {
                        line: 48,
                        column: 13
                    }
                },
                line: 45
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_8zz4ogum5.s[0]++;
(function () {
    'use strict';

    AuthRegisterController.$inject = ["UsersTable", "$mdToast", "$http", "AppSettings"];
    cov_8zz4ogum5.f[0]++;
    cov_8zz4ogum5.s[1]++;
    angular.module('app').controller('AuthRegisterController', AuthRegisterController);

    /* @ngInject */
    function AuthRegisterController(UsersTable, $mdToast, $http, AppSettings) {
        cov_8zz4ogum5.f[1]++;

        var vm = (cov_8zz4ogum5.s[2]++, this);

        cov_8zz4ogum5.s[3]++;
        vm.registering = true;
        cov_8zz4ogum5.s[4]++;
        vm.user = UsersTable.$build();
        cov_8zz4ogum5.s[5]++;
        vm.resendStatus = false;
        cov_8zz4ogum5.s[6]++;
        vm.resent = false;

        cov_8zz4ogum5.s[7]++;
        vm.register = register;
        cov_8zz4ogum5.s[8]++;
        vm.resend = resend;

        cov_8zz4ogum5.s[9]++;
        activate();

        function activate() {
            cov_8zz4ogum5.f[2]++;
        }

        function register() {
            cov_8zz4ogum5.f[3]++;
            cov_8zz4ogum5.s[10]++;

            vm.user.$save().$then(function () {
                cov_8zz4ogum5.f[4]++;
                cov_8zz4ogum5.s[11]++;

                vm.registering = false;
            }, function () {
                cov_8zz4ogum5.f[5]++;
                cov_8zz4ogum5.s[12]++;

                $mdToast.show($mdToast.simple().textContent('Please fill in all required fields!'));
            });
        }

        function resend() {
            cov_8zz4ogum5.f[6]++;
            cov_8zz4ogum5.s[13]++;

            vm.resendStatus = $http({
                method: 'POST',
                url: AppSettings.apiUrl + '/users/resend_verification_email/',
                data: {
                    email: vm.user.email
                }
            }).then(function successCallback(response) {
                cov_8zz4ogum5.f[7]++;
                cov_8zz4ogum5.s[14]++;

                vm.resent = true;
                cov_8zz4ogum5.s[15]++;
                $mdToast.show($mdToast.simple().textContent('We sent an email to your account!'));
                cov_8zz4ogum5.s[16]++;
                return response;
            }, function (response) {
                cov_8zz4ogum5.f[8]++;
                cov_8zz4ogum5.s[17]++;

                $mdToast.show($mdToast.simple().textContent(response.data['non_field_errors'][0]));
                cov_8zz4ogum5.s[18]++;
                return response;
            });
        }
    }
})();
'use strict';

var cov_1fglegte09 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.logout.controller.js',
        hash = '745c594f1ee3698a167e61208bf09f132a9c258f',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.logout.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 52
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 28
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 27
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 24
                }
            },
            '7': {
                start: {
                    line: 21,
                    column: 12
                },
                end: {
                    line: 24,
                    column: 15
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 57
                }
            },
            '9': {
                start: {
                    line: 23,
                    column: 16
                },
                end: {
                    line: 23,
                    column: 50
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Controller',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 58
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 16,
                        column: 17
                    },
                    end: {
                        line: 16,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 29
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 16
            },
            '3': {
                name: 'logout',
                decl: {
                    start: {
                        line: 20,
                        column: 17
                    },
                    end: {
                        line: 20,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 27
                    },
                    end: {
                        line: 25,
                        column: 9
                    }
                },
                line: 20
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 21,
                        column: 38
                    },
                    end: {
                        line: 21,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 50
                    },
                    end: {
                        line: 24,
                        column: 13
                    }
                },
                line: 21
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1fglegte09.s[0]++;
(function () {
    'use strict';

    Controller.$inject = ["$rootScope", "$state", "AuthService"];
    cov_1fglegte09.f[0]++;
    cov_1fglegte09.s[1]++;
    angular.module('app').controller('AuthLogoutController', Controller);

    /* @ngInject */
    function Controller($rootScope, $state, AuthService) {
        cov_1fglegte09.f[1]++;

        var vm = (cov_1fglegte09.s[2]++, this);
        cov_1fglegte09.s[3]++;
        vm.title = 'Logout';
        cov_1fglegte09.s[4]++;
        vm.logout = logout;

        cov_1fglegte09.s[5]++;
        activate();

        function activate() {
            cov_1fglegte09.f[2]++;
            cov_1fglegte09.s[6]++;

            vm.logout();
        }

        function logout() {
            cov_1fglegte09.f[3]++;
            cov_1fglegte09.s[7]++;

            AuthService.logout().then(function () {
                cov_1fglegte09.f[4]++;
                cov_1fglegte09.s[8]++;

                $rootScope.profileMenuPageActive = false;
                cov_1fglegte09.s[9]++;
                $state.go('home', { '#': 'login' });
            });
        }
    }
})();
'use strict';

var cov_1nkczhpwc9 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.login.controller.js',
        hash = 'cf1f559106f856e9b373c2b1e2f801a1d6307952',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.login.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 59,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 25
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 30
                }
            },
            '6': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 19,
                    column: 12
                },
                end: {
                    line: 21,
                    column: 13
                }
            },
            '8': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 60
                }
            },
            '9': {
                start: {
                    line: 20,
                    column: 46
                },
                end: {
                    line: 20,
                    column: 58
                }
            },
            '10': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 29,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 26,
                    column: 16
                },
                end: {
                    line: 26,
                    column: 29
                }
            },
            '12': {
                start: {
                    line: 28,
                    column: 16
                },
                end: {
                    line: 28,
                    column: 34
                }
            },
            '13': {
                start: {
                    line: 33,
                    column: 12
                },
                end: {
                    line: 37,
                    column: 15
                }
            },
            '14': {
                start: {
                    line: 34,
                    column: 16
                },
                end: {
                    line: 34,
                    column: 29
                }
            },
            '15': {
                start: {
                    line: 36,
                    column: 16
                },
                end: {
                    line: 36,
                    column: 34
                }
            },
            '16': {
                start: {
                    line: 41,
                    column: 12
                },
                end: {
                    line: 41,
                    column: 33
                }
            },
            '17': {
                start: {
                    line: 46,
                    column: 12
                },
                end: {
                    line: 55,
                    column: 15
                }
            },
            '18': {
                start: {
                    line: 47,
                    column: 16
                },
                end: {
                    line: 47,
                    column: 39
                }
            },
            '19': {
                start: {
                    line: 48,
                    column: 16
                },
                end: {
                    line: 54,
                    column: 17
                }
            },
            '20': {
                start: {
                    line: 49,
                    column: 20
                },
                end: {
                    line: 49,
                    column: 56
                }
            },
            '21': {
                start: {
                    line: 50,
                    column: 23
                },
                end: {
                    line: 54,
                    column: 17
                }
            },
            '22': {
                start: {
                    line: 51,
                    column: 20
                },
                end: {
                    line: 51,
                    column: 57
                }
            },
            '23': {
                start: {
                    line: 53,
                    column: 20
                },
                end: {
                    line: 53,
                    column: 50
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 59,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Controller',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 72
                    },
                    end: {
                        line: 58,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 18,
                        column: 17
                    },
                    end: {
                        line: 18,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 29
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                },
                line: 18
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 20,
                        column: 36
                    },
                    end: {
                        line: 20,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 46
                    },
                    end: {
                        line: 20,
                        column: 58
                    }
                },
                line: 20
            },
            '4': {
                name: 'login',
                decl: {
                    start: {
                        line: 24,
                        column: 17
                    },
                    end: {
                        line: 24,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 26
                    },
                    end: {
                        line: 30,
                        column: 9
                    }
                },
                line: 24
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 25,
                        column: 58
                    },
                    end: {
                        line: 25,
                        column: 59
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 76
                    },
                    end: {
                        line: 27,
                        column: 13
                    }
                },
                line: 25
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 27,
                        column: 15
                    },
                    end: {
                        line: 27,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 32
                    },
                    end: {
                        line: 29,
                        column: 13
                    }
                },
                line: 27
            },
            '7': {
                name: 'loginFacebook',
                decl: {
                    start: {
                        line: 32,
                        column: 17
                    },
                    end: {
                        line: 32,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 34
                    },
                    end: {
                        line: 38,
                        column: 9
                    }
                },
                line: 32
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 33,
                        column: 45
                    },
                    end: {
                        line: 33,
                        column: 46
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 57
                    },
                    end: {
                        line: 35,
                        column: 13
                    }
                },
                line: 33
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 35,
                        column: 15
                    },
                    end: {
                        line: 35,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 32
                    },
                    end: {
                        line: 37,
                        column: 13
                    }
                },
                line: 35
            },
            '10': {
                name: 'logout',
                decl: {
                    start: {
                        line: 40,
                        column: 17
                    },
                    end: {
                        line: 40,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 27
                    },
                    end: {
                        line: 42,
                        column: 9
                    }
                },
                line: 40
            },
            '11': {
                name: 'afterLogin',
                decl: {
                    start: {
                        line: 44,
                        column: 17
                    },
                    end: {
                        line: 44,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 44,
                        column: 31
                    },
                    end: {
                        line: 56,
                        column: 9
                    }
                },
                line: 44
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 46,
                        column: 32
                    },
                    end: {
                        line: 46,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 48
                    },
                    end: {
                        line: 55,
                        column: 13
                    }
                },
                line: 46
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                }, {
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                }],
                line: 19
            },
            '1': {
                loc: {
                    start: {
                        line: 48,
                        column: 16
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 48,
                        column: 16
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                }, {
                    start: {
                        line: 48,
                        column: 16
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                }],
                line: 48
            },
            '2': {
                loc: {
                    start: {
                        line: 50,
                        column: 23
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 50,
                        column: 23
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                }, {
                    start: {
                        line: 50,
                        column: 23
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                }],
                line: 50
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1nkczhpwc9.s[0]++;
(function () {
    'use strict';

    Controller.$inject = ["$state", "AuthService", "$rootScope", "$stateParams"];
    cov_1nkczhpwc9.f[0]++;
    cov_1nkczhpwc9.s[1]++;
    angular.module('app').controller('AuthLoginController', Controller);

    /* @ngInject */
    function Controller($state, AuthService, $rootScope, $stateParams) {
        cov_1nkczhpwc9.f[1]++;

        var vm = (cov_1nkczhpwc9.s[2]++, this);
        cov_1nkczhpwc9.s[3]++;
        vm.login = login;
        cov_1nkczhpwc9.s[4]++;
        vm.loginFacebook = loginFacebook;

        cov_1nkczhpwc9.s[5]++;
        vm.authenticated = {};

        cov_1nkczhpwc9.s[6]++;
        activate();

        function activate() {
            cov_1nkczhpwc9.f[2]++;
            cov_1nkczhpwc9.s[7]++;

            if ($rootScope.me) {
                cov_1nkczhpwc9.b[0][0]++;
                cov_1nkczhpwc9.s[8]++;

                $rootScope.me.$then(function (user) {
                    cov_1nkczhpwc9.f[3]++;
                    cov_1nkczhpwc9.s[9]++;
                    return afterLogin();
                });
            } else {
                cov_1nkczhpwc9.b[0][1]++;
            }
        }

        function login() {
            cov_1nkczhpwc9.f[4]++;
            cov_1nkczhpwc9.s[10]++;

            AuthService.login(vm.email, vm.password).then(function (result) {
                cov_1nkczhpwc9.f[5]++;
                cov_1nkczhpwc9.s[11]++;

                afterLogin();
            }, function (error) {
                cov_1nkczhpwc9.f[6]++;
                cov_1nkczhpwc9.s[12]++;

                vm.member = error;
            });
        }

        function loginFacebook() {
            cov_1nkczhpwc9.f[7]++;
            cov_1nkczhpwc9.s[13]++;

            AuthService.loginFacebook().then(function () {
                cov_1nkczhpwc9.f[8]++;
                cov_1nkczhpwc9.s[14]++;

                afterLogin();
            }, function (error) {
                cov_1nkczhpwc9.f[9]++;
                cov_1nkczhpwc9.s[15]++;

                vm.member = error;
            });
        }

        function logout() {
            cov_1nkczhpwc9.f[10]++;
            cov_1nkczhpwc9.s[16]++;

            AuthService.logout();
        }

        function afterLogin() {
            cov_1nkczhpwc9.f[11]++;
            cov_1nkczhpwc9.s[17]++;


            $rootScope.me.$then(function (user) {
                cov_1nkczhpwc9.f[12]++;
                cov_1nkczhpwc9.s[18]++;

                console.log(user.type);
                cov_1nkczhpwc9.s[19]++;
                if (user.type == 'MARKETEER') {
                    cov_1nkczhpwc9.b[1][0]++;
                    cov_1nkczhpwc9.s[20]++;

                    $state.go('marketeers.membersList');
                } else {
                        cov_1nkczhpwc9.b[1][1]++;
                        cov_1nkczhpwc9.s[21]++;
                        if (user.type == 'ACCOUNTANT') {
                            cov_1nkczhpwc9.b[2][0]++;
                            cov_1nkczhpwc9.s[22]++;

                            $state.go('accountants.membersList');
                        } else {
                            cov_1nkczhpwc9.b[2][1]++;
                            cov_1nkczhpwc9.s[23]++;

                            $state.go('amigos.dashboard');
                        }
                    }
            });
        }
    }
})();
'use strict';

var cov_1zjxi2esb4 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.forgot.controller.js',
        hash = 'b9d8adb39eb0cf792fe69d5aa11d8981373320e3',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.forgot.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 35,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 66
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 30
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 22,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 15
                }
            },
            '7': {
                start: {
                    line: 29,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 32
                }
            },
            '8': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 32
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthForgotController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 54
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 18,
                        column: 17
                    },
                    end: {
                        line: 18,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 28
                    },
                    end: {
                        line: 19,
                        column: 9
                    }
                },
                line: 18
            },
            '3': {
                name: 'requestChange',
                decl: {
                    start: {
                        line: 21,
                        column: 17
                    },
                    end: {
                        line: 21,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 33
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 21
            },
            '4': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 28,
                        column: 29
                    },
                    end: {
                        line: 28,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 55
                    },
                    end: {
                        line: 30,
                        column: 13
                    }
                },
                line: 28
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 15
                    },
                    end: {
                        line: 30,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 35
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1zjxi2esb4.s[0]++;
(function () {
    'use strict';

    AuthForgotController.$inject = ["$http", "AppSettings"];
    cov_1zjxi2esb4.f[0]++;
    cov_1zjxi2esb4.s[1]++;
    angular.module('app').controller('AuthForgotController', AuthForgotController);

    /* @ngInject */
    function AuthForgotController($http, AppSettings) {
        cov_1zjxi2esb4.f[1]++;

        var vm = (cov_1zjxi2esb4.s[2]++, this);

        cov_1zjxi2esb4.s[3]++;
        vm.requestStatus = {};

        cov_1zjxi2esb4.s[4]++;
        vm.requestChange = requestChange;

        cov_1zjxi2esb4.s[5]++;
        activate();

        function activate() {
            cov_1zjxi2esb4.f[2]++;
        }

        function requestChange() {
            cov_1zjxi2esb4.f[3]++;
            cov_1zjxi2esb4.s[6]++;

            vm.requestStatus = $http({
                method: 'POST',
                url: AppSettings.apiUrl + '/users/reset_password/',
                data: {
                    email: vm.email
                }
            }).then(function successCallback(response) {
                cov_1zjxi2esb4.f[4]++;
                cov_1zjxi2esb4.s[7]++;

                return response;
            }, function (response) {
                cov_1zjxi2esb4.f[5]++;
                cov_1zjxi2esb4.s[8]++;

                return response;
            });
        }
    }
})();
'use strict';

var cov_1ligzu23jg = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.config.js',
        hash = '4a58601d71a2390848afdf6078285fcd62057274',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.config.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 19,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 24
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 51
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 52
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 19,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Config',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 48
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1ligzu23jg.s[0]++;
(function () {
    'use strict';

    Config.$inject = ["$authProvider", "AppSettings"];
    cov_1ligzu23jg.f[0]++;
    cov_1ligzu23jg.s[1]++;
    angular.module('app').config(Config);

    /* @ngInject */
    function Config($authProvider, AppSettings) {
        cov_1ligzu23jg.f[1]++;
        cov_1ligzu23jg.s[2]++;

        $authProvider.baseUrl = AppSettings.apiUrl;

        cov_1ligzu23jg.s[3]++;
        $authProvider.loginUrl = '/api-token-auth/';

        cov_1ligzu23jg.s[4]++;
        $authProvider.facebook({
            clientId: AppSettings.facebookAppId,
            url: '/auth/facebook/'
        });
    }
})();
'use strict';

var cov_1li5297not = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.activate.controller.js',
        hash = 'e4bb64a24a11e5eaf4b1df173db5a8cc70ffebf4',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/auth/auth.activate.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 40,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 66
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 19
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 13
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 31
                }
            },
            '6': {
                start: {
                    line: 18,
                    column: 12
                },
                end: {
                    line: 37,
                    column: 15
                }
            },
            '7': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 26,
                    column: 18
                }
            },
            '8': {
                start: {
                    line: 27,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 19
                }
            },
            '9': {
                start: {
                    line: 28,
                    column: 20
                },
                end: {
                    line: 28,
                    column: 65
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 35,
                    column: 18
                }
            },
            '11': {
                start: {
                    line: 36,
                    column: 16
                },
                end: {
                    line: 36,
                    column: 35
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 40,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthActivateController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 100
                    },
                    end: {
                        line: 39,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 14,
                        column: 17
                    },
                    end: {
                        line: 14,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 28
                    },
                    end: {
                        line: 38,
                        column: 9
                    }
                },
                line: 14
            },
            '3': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 21,
                        column: 29
                    },
                    end: {
                        line: 21,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 47
                    },
                    end: {
                        line: 30,
                        column: 13
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 27,
                        column: 40
                    },
                    end: {
                        line: 27,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 52
                    },
                    end: {
                        line: 29,
                        column: 17
                    }
                },
                line: 27
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 15
                    },
                    end: {
                        line: 30,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 27
                    },
                    end: {
                        line: 37,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                }, {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                }],
                line: 15
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1li5297not.s[0]++;
(function () {
    'use strict';

    AuthActivateController.$inject = ["$http", "$state", "$stateParams", "AppSettings", "$mdToast", "$rootScope"];
    cov_1li5297not.f[0]++;
    cov_1li5297not.s[1]++;
    angular.module('app').controller('AuthActivateController', AuthActivateController);

    /* @ngInject */
    function AuthActivateController($http, $state, $stateParams, AppSettings, $mdToast, $rootScope) {
        cov_1li5297not.f[1]++;

        var vm = (cov_1li5297not.s[2]++, this);

        cov_1li5297not.s[3]++;
        activate();

        function activate() {
            cov_1li5297not.f[2]++;
            cov_1li5297not.s[4]++;

            if (!$stateParams.token) {
                cov_1li5297not.b[0][0]++;
                cov_1li5297not.s[5]++;

                $state.go('/');
            } else {
                cov_1li5297not.b[0][1]++;
            }
            cov_1li5297not.s[6]++;
            vm.requestStatus = $http({
                method: 'GET',
                url: AppSettings.apiUrl + '/users/activate/?token=' + $stateParams.token
            }).then(function successCallback() {
                cov_1li5297not.f[3]++;
                cov_1li5297not.s[7]++;

                $mdToast.show($mdToast.simple().textContent('Your account has been activated!').hideDelay(3000));
                cov_1li5297not.s[8]++;
                $state.go('login').then(function () {
                    cov_1li5297not.f[4]++;
                    cov_1li5297not.s[9]++;

                    $rootScope.openHeaderPage('loginPageActive');
                });
            }, function () {
                cov_1li5297not.f[5]++;
                cov_1li5297not.s[10]++;

                $mdToast.show($mdToast.simple().textContent('Activation error!').hideDelay(3000));
                cov_1li5297not.s[11]++;
                $state.go('login');
            });
        }
    }
})();
'use strict';

var cov_1wj6w31788 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/associationStateView/associationStateView.js',
        hash = 'ee70cc5b0b18b2919bad2a9ca6b8aadb5409d0cd',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/associationStateView/associationStateView.js',
        statementMap: {
            '0': {
                start: {
                    line: 6,
                    column: 0
                },
                end: {
                    line: 11,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 19
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                line: 2
            }
        },
        branchMap: {},
        s: {
            '0': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AssociationStateViewController = function AssociationStateViewController() {
    _classCallCheck(this, AssociationStateViewController);

    cov_1wj6w31788.f[0]++;
};

cov_1wj6w31788.s[0]++;


angular.module('app').component('associationStateView', {
    templateUrl: 'app/components/associationStateView/associationStateView.html',
    controller: AssociationStateViewController
});
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/admin/layout.accountants.html","<md-sidenav id=\"sidebar\" md-component-id=\"menu\" class=\"md-sidenav-left\" md-is-locked-open=\"$mdMedia(\'gt-md\')\">\n    <md-content flex>\n\n        <div class=\"logo-area\">\n            <span>Coliseu</span>\n            <div ng-if=\"me.type == \'MARKETEER\'\" class=\"user-type\" layout=\"column\" flex>\n                Marketing\n            </div>\n            <div ng-if=\"me.type == \'ACCOUNTANT\'\" class=\"user-type\" layout=\"column\" flex>\n                Contabilidade\n            </div>\n        </div>\n\n        <section>\n            <span>Menu</span>\n        </section>\n        <div ui-sref=\"accountants.membersList\" ui-sref-active=\"active\" class=\"menu-item\">\n            <md-icon>person</md-icon>\n            <span>Associados</span>\n        </div>\n        <div ui-sref=\"accountants.adminsList\" ui-sref-active=\"active\" class=\"menu-item\">\n            <md-icon>supervisor_account</md-icon>\n            <span>Administradores</span>\n        </div>\n	<div ui-sref=\"accountants.reportsList\" ui-sref-active=\"active\" class=\"menu-item\" ng-if=\"$root.ENABLE_REPORTS_VIEW.value === \'1\'\">\n            <md-icon>description</md-icon>\n            <span>Relatórios</span>\n        </div>\n        <div ui-sref=\"accountants.settings.quotas\" ui-sref-active=\"active\" class=\"menu-item\">\n            <md-icon>settings</md-icon>\n            <span>Configurações</span>\n        </div>\n    </md-content>\n    <div layout=\"row\" layout-align=\"center center\" layout-margin class=\"footer\">\n        <img ng-src=\"{{me.avatar | mediaUrl}}\" class=\"avatar\">\n        <div layout=\"column\" flex>\n            <span>{{me.name}}</span> <a ui-sref=\"profile\">Editar perfil</a>\n        </div>\n        <md-button class=\"md-icon-button\" ui-sref=\"logout\">\n            <md-icon>exit_to_app</md-icon>\n        </md-button>\n    </div>\n</md-sidenav>\n<div layout=\"column\" flex>\n    <div layout=\"row\" layout-align=\"start center\" hide-gt-md>\n        <md-button class=\"md-accent\" ng-click=\"openSidebar();\">\n            <md-icon>menu</md-icon>\n            <span class=\"text-accent\">COLISEU</span>\n        </md-button>\n    </div>\n    <ui-view id=\"viewport\" flex layout=\"column\"></ui-view>\n</div>\n\n<style>\n    .principal, .principal {\n        display: none;\n    }\n\n    #viewport {\n        margin-top: 0px !important;\n    }\n</style>\n");
$templateCache.put("app/components/admin/layout.marketeers.html","<div flex layout=\"row\">\n\n    <md-sidenav id=\"sidebar\" md-component-id=\"menu\" class=\"md-sidenav-left\" md-is-locked-open=\"$mdMedia(\'gt-md\')\">\n        <md-content flex>\n\n            <div class=\"logo-area\">\n                <span>Coliseu</span>\n                <div ng-if=\"me.type == \'MARKETEER\'\" class=\"user-type\" layout=\"column\" flex>\n                    Marketing\n                </div>\n                <div ng-if=\"me.type == \'ACCOUNTANT\'\" class=\"user-type\" layout=\"column\" flex>\n                    Contabilidade\n                </div>\n            </div>\n\n            <section>\n                <span>Menu</span>\n            </section>\n            <div ui-sref=\"marketeers.membersList\" ui-sref-active=\"active\" class=\"menu-item\">\n                <md-icon>person</md-icon>\n                <span>Associados</span>\n            </div>\n            <div ui-sref=\"marketeers.adminsList\" ui-sref-active=\"active\" class=\"menu-item\">\n                <md-icon>supervisor_account</md-icon>\n                <span>Administradores</span>\n            </div>\n        </md-content>\n        <div layout=\"row\" layout-align=\"center center\" layout-margin class=\"footer\">\n            <img ng-src=\"{{me.avatar | mediaUrl}}\" class=\"avatar\">\n            <div layout=\"column\" flex>\n                <span>{{me.name}}</span> <a ui-sref=\"profile\">Editar perfil</a>\n            </div>\n            <md-button class=\"md-icon-button\" ui-sref=\"logout\">\n                <md-icon>exit_to_app</md-icon>\n            </md-button>\n        </div>\n    </md-sidenav>\n    <div layout=\"column\" flex>\n        <div layout=\"row\" layout-align=\"start center\">\n            <md-button class=\"md-accent\" ng-click=\"openSidebar();\" hide-gt-md>\n                <md-icon>menu</md-icon>\n                <span class=\"text-accent\">COLISEU</span>\n            </md-button>\n        </div>\n        <ui-view id=\"viewport\" flex layout=\"column\"></ui-view>\n    </div>\n\n</div>\n\n<style>\n    .principal, .principal {\n        display: none;\n    }\n\n    #viewport {\n        margin-top: 0px !important;\n    }\n</style>\n");
$templateCache.put("app/components/associationStateView/associationStateView.html","Heelo\n");
$templateCache.put("app/components/amigos/layout.amigos.html","<div flex layout=\"column\">\n\n    <md-content flex layout=\"column\" ui-view></md-content>\n    <div class=\"sub-toolbar\" layout=\"row\" layout-align=\"start center\" md-whiteframe=\"1\">\n        <div layout=\"row\" hide show-gt-xs flex-order=\"3\" flex-order-gt-xs=\"1\">\n            <md-button ui-sref=\"accountants.membersList\" ng-if=\"$root.me.type==\'ACCOUNTANT\'\">\n                Admin\n            </md-button>\n            <md-button ui-sref=\"marketeers.membersList\" ng-if=\"$root.me.type==\'MARKETEER\'\">\n                Admin\n            </md-button>\n            <md-button ui-sref=\"amigos.dashboard\">\n                Quotas\n            </md-button>\n            <md-button ui-sref=\"amigos.hello\" disabled=\"disabled\">\n                <md-tooltip>Brevemente</md-tooltip>\n                Comunicações\n            </md-button>\n            <md-button ui-sref=\"amigos.hello\" disabled=\"disabled\">\n                <md-tooltip>Brevemente</md-tooltip>\n                Ofertas\n            </md-button>\n        </div>\n        <span flex flex-order=\"2\"></span>\n        <md-button hide-gt-xs class=\"md-icon-button\" flex-order=\"4\" ui-sref=\"amigos.dashboard\" ui-sref-active=\"active\">\n            <md-icon>payment</md-icon>\n        </md-button>\n        <md-menu flex-order=\"1\" flex-order-gt-xs=\"3\">\n            <md-button ng-click=\"$mdMenu.open($event)\" aria-label=\"Menu amigo\" class=\"amigo-btn\">\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex-order=\"2\" flex-order-gt-xs=\"1\">{{::me.name}}</div>\n                    <img flex-order=\"1\" flex-order-gt-xs=\"2\" class=\"avatar-sm\" ng-src=\"{{me.avatar | mediaUrl}}\">\n                </div>\n            </md-button>\n            <md-menu-content width=\"4\">\n                <md-menu-item hide-gt-xs>\n                    <md-button ui-sref=\"amigos.dashboard\">\n                        Quotas\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item hide-gt-xs>\n                    <md-button ui-sref=\"amigos.hello\" disabled=\"disabled\">\n                        <md-tooltip>Coming soon</md-tooltip>\n                        Comunicações\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item hide-gt-xs>\n                    <md-button ui-sref=\"amigos.hello\" disabled=\"disabled\">\n                        <md-tooltip>Coming soon</md-tooltip>\n                        Ofertas\n                    </md-button>\n                </md-menu-item>\n                <md-divider hide-gt-xs></md-divider>\n                <md-menu-item>\n                    <md-button ui-sref=\"amigos.profile\">\n                        <div layout=\"row\" layout-align=\"space-between center\">\n                            <span>Dados pessoais</span>\n                            <md-icon>person</md-icon>\n                        </div>\n                    </md-button>\n                </md-menu-item>\n                <md-divider></md-divider>\n                <md-menu-item>\n                    <md-button ui-sref=\"logout\">\n                        <div layout=\"row\" layout-align=\"space-between center\">\n                            <span>Sair</span>\n                            <md-icon>exit_to_app</md-icon>\n                        </div>\n                    </md-button>\n                </md-menu-item>\n            </md-menu-content>\n        </md-menu>\n    </div>\n</div>\n");
$templateCache.put("app/components/dashboard/dashboard.html","<div id=\"one-more-step\" layout=\"column\" layout-align=\"center center\" ng-if=\"$root.me.quotasState == \'PENDING\'\" class=\"full-page\">\n    <md-content flex>\n        <br> <br>\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-card>\n                <md-card-content>\n                    <h4 class=\"text-center\" style=\"margin-top: 0\">Pagamento multibanco</h4>\n                    <table cellpadding=\"5\">\n                        <tr>\n                            <td>Entidade</td>\n                            <td>{{::$ctrl.pendingOrder.$_(\'paymentIfthen\').entity}}</td>\n                        </tr>\n                        <tr>\n                            <td>Referência</td>\n                            <td>{{::$ctrl.pendingOrder.$_(\'paymentIfthen\').reference}}</td>\n                        </tr>\n                        <tr>\n                            <td>Total</td>\n                            <td>{{::$ctrl.pendingOrder.$_(\'paymentIfthen\').value}}€</td>\n                        </tr>\n                    </table>\n                    <hr>\n                    <div>\n                        <table width=\"100%\" cellpadding=\"5\" cellspacing=\"0\">\n                            <tr ng-repeat=\"gem in $ctrl.pendingOrder.$_(\'gems\')\">\n                                <td align=\"left\" class=\"text-fade\">\n                                    <small>Joia de inscrição</small>\n                                </td>\n                                <td align=\"right\" class=\"text-fade\">\n                                    <small>{{::gem.price}}€</small>\n                                </td>\n                            </tr>\n                            <tr>\n                                <td align=\"left\" class=\"text-fade\">\n                                    <small>Quota anual</small>\n                                </td>\n                                <td align=\"right\" class=\"text-fade\">\n                                    <small>{{$ctrl.pendingOrder.$_(\'quotas\') | map: \'price\' | sum}}€</small>\n                                </td>\n                            </tr>\n                        </table>\n                    </div>\n                </md-card-content>\n            </md-card>\n        </div>\n        <h3>Deve efetuar o pagamento dentro de 48h <br>para ter acesso às vantagens Amigo Coliseu Porto</h3>\n    </md-content>\n</div>\n\n<div>\n    <div layout=\"column\" style=\"flex-wrap: wrap\" ng-if=\"$root.me.quotasState == \'REGULAR\'\">\n        <p style=\"padding: 20px\" class=\"text-fade\">\n            <md-icon>history</md-icon>\n            Histórico de pagamentos\n        </p>\n        <div layout=\"row\">\n\n            <md-card flex=\"100\" flex-gt-xs=\"50\" ng-repeat=\"order in $ctrl.orders\" class=\"order-history\">\n                <md-card-content layout=\"column\">\n                    <div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"space-around center\">\n                        <h1>{{::order.total}}€</h1>\n                        <p layout=\"column\">\n                            <small class=\"text-fade\">{{::order.created | amCalendar}}</small>\n                            <span>{{::order.name}}</span>\n                        </p>\n                    </div>\n                    <div>\n                        <table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\">\n                            <tr ng-repeat=\"gem in order.$_(\'gems\')\">\n                                <td align=\"left\" class=\"text-fade\">\n                                    <small>Joia de inscrição</small>\n                                </td>\n                                <td align=\"right\" class=\"text-fade\">\n                                    <small>{{::gem.price}}€</small>\n                                </td>\n                            </tr>\n                            <tr ng-init=\"quotas = order.$_(\'quotas\')\">\n                                <td align=\"left\" class=\"text-fade\">\n                                    <small>Quota anual</small>\n                                </td>\n                                <td align=\"right\" class=\"text-fade\">\n                                    <small>{{quotas | map: \'price\' | sum}}€</small>\n                                </td>\n                            </tr>\n                        </table>\n                    </div>\n                </md-card-content>\n            </md-card>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/components/editQuotaPriceView/editQuotaPriceView.html","<div class=\"padding\">\n    <h3 class=\"text-fade text-center\">Novo período de vigência {{$ctrl.userTypeName.name}}</h3>\n    <table width=\"100%\">\n        <tr>\n            <th>Quota</th>\n            <th>Joia</th>\n        </tr>\n        <tr>\n            <td align=\"center\">\n                <md-input-container>\n                    <label>Novo valor</label>\n                    <input type=\"text\" class=\"text-center\" ng-model=\"$ctrl.newPrice.quotaAmount\">\n                </md-input-container>\n            </td>\n            <td align=\"center\">\n                <md-input-container>\n                    <label>Novo valor</label>\n                    <input type=\"text\" class=\"text-center\" ng-model=\"$ctrl.newPrice.gemAmount\">\n                </md-input-container>\n            </td>\n        </tr>\n        <tr>\n            <td colspan=\"2\" align=\"center\">\n                <md-input-container>\n                    <label>Data de início</label>\n                    <input required type=\"date\" ng-model=\"$ctrl.newPrice.effectiveDate\">\n                </md-input-container>\n            </td>\n        </tr>\n    </table>\n    <div layout=\"row\" layout-align=\"end center\" layout-margin>\n        <md-button>Cancelar</md-button>\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.save()\" ng-disabled=\"!$ctrl.newPrice.effectiveDate\">\n            Guardar\n        </md-button>\n    </div>\n</div>\n");
$templateCache.put("app/components/footer/footer.html","<div id=\"footer\">\n    <nav class=\"rodape\">\n        <div layout=\"column\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-around center\">\n            <div layout=\"row\" layout-align=\"center center\">\n                <a target=\"_blank\" href=\"https://www.facebook.com/ColiseuPorto/\" class=\"icon icon-facebook-with-circle\" style=\"font-size:200%; display:inline\"> </a>\n                <a target=\"_blank\" href=\"https://twitter.com/ColiseuPorto\" style=\"font-size:200%; display:inline\" class=\"icon icon-twitter-with-circle\"></a>\n            </div>\n            <div layout=\"row\" layout-align=\"center center\" hide>\n                <a href=\"#\">Newsletter <input class=\"nwsltr\" placeholder=\"email\"></a>\n            </div>\n        </div>\n    </nav>\n</div>\n");
$templateCache.put("app/components/generateQuotasInput/generateQuotasInput.html","<div layout=\"column\" layout-align=\"center center\" class=\"padding\" cg-busy=\"$ctrl.creating\">\n    <div layout=\"row\" layout-align=\"start end\" ng-if-start=\"!$ctrl.loading\">\n        <span>Gerar quotas</span>\n        <md-select ng-model=\"$ctrl.generateType\" class=\"no-margin\" style=\"margin-left: 3px; margin-bottom: -2px\" ng-change=\"$ctrl.selectedMonths = []; $ctrl.semestre = null\">\n            <md-option value=\"{{::type}}\" ng-repeat=\"type in ::$ctrl.generateTypes track by type\">{{::type}}</md-option>\n        </md-select>\n    </div>\n\n    <year-filter-select on-change=\"$ctrl.year = year; $ctrl.selectMonths()\" placeholder=\"Selecione o ano\"></year-filter-select>\n    <md-select ng-model=\"$ctrl.semestre\" ng-if=\"$ctrl.generateType == \'Semestral\' && $ctrl.year\" placeholder=\"Selecione o semestre\" ng-change=\"$ctrl.selectMonths()\">\n        <md-option value=\"1\">1º Semestre</md-option>\n        <md-option value=\"2\">2º Semestre</md-option>\n    </md-select>\n    <month-selector ng-if=\"$ctrl.generateType == \'Mensal\' && $ctrl.year\" placeholder=\"Selecione o mês\" selected-months=\"$ctrl.selectedMonths\"></month-selector>\n\n\n    <md-select ng-model=\"$ctrl.paymentType\" placeholder=\"Tipo de pagamento\">\n        <md-option ng-repeat=\"type in $ctrl.paymentTypes\" ng-value=\"::type.id\">{{::type.name}}</md-option>\n    </md-select>\n\n    <div layout=\"row\" style=\"margin-top: 30px\" ng-if-end>\n        <span flex></span>\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.save()\" ng-disabled=\"!$ctrl.selectedMonths || $ctrl.selectedMonths.length <= 0 || !$ctrl.paymentType\">\n            Criar quotas\n        </md-button>\n    </div>\n    <md-progress-circular indeterminate ng-if=\"$ctrl.loading\"></md-progress-circular>\n</div>\n");
$templateCache.put("app/components/homeView/homeView.html","<nav class=\"secundario\" layout=\"row\" layout-align=\"center center\" hide show-gt-xs>\n    <div du-scroll-container=\"homeviewcontent\"><a href=\"#subscription-form\" du-smooth-scroll>Aderir</a></div>\n    <div du-scroll-container=\"homeviewcontent\"><a href=\"#vantagens\" du-smooth-scroll>Vantagens</a></div>\n    <div><a href=\"{{$root.AppSettings.siteUrl}}/estatutos/\">Estatutos</a></div>\n    <div du-scroll-container=\"homeviewcontent\"><a href=\"#login\" du-smooth-scroll>Entrar</a></div>\n</nav>\n\n<md-content id=\"homeviewcontent\" flex du-scroll-container>\n\n    <section id=\"amigos\" class=\"centrar\">\n        <div id=\"copyamigos\">\n            <h1>Há sempre lugar para<br>mais um Amigo</h1>\n            <h4>\n                Aderir à Associação Amigos do Coliseu Porto tem vários benefícios, como a oferta de um bilhete para um\n                espetáculo.\n            </h4>\n            <nav id=\"amigo\">\n                <ul>\n                    <a href=\"#subscription-form\" du-smooth-scroll>\n                        <li class=\"login\">Aderir</li>\n                    </a> <a href=\"#vantagens\" du-smooth-scroll>\n                    <li class=\"login\">Saber mais</li>\n                </a></ul>\n            </nav>\n        </div>\n    </section>\n\n    <section id=\"vantagens\" class=\"centrar\">\n        <div class=\"vantagem dois\"><h1>Oferta de 1 bilhete</h1>\n            <h4>Oferta de um bilhete para um único espetáculo, sujeita à disponibilidade de lugares para o efeito.</h4>\n        </div>\n        <div class=\"vantagem tres\">\n            <h1>Desconto de 20%</h1>\n            <h4>Em todos os espetáculos de produção própria ou coproduções Coliseu Porto.</h4>\n        </div>\n        <div class=\"vantagem quatro\">\n            <h1>Oferta de um convite para o Circo Coliseu Porto</h1>\n            <h4>Oferta de um convite duplo anual para a sessão de estreia do Circo Coliseu Porto, sujeita à\n                disponibilidade da sala.</h4>\n        </div>\n        <div class=\"vantagem cinco\">\n            <h1>Condições especiais nas atividades do Balleteatro</h1>\n            <h4>O Balleteatro é a Estrutura Artística Residente do Coliseu. Os Amigos Coliseu Porto beneficiam de\n                condições especiais nos cursos e atividades do Balleteatro.</h4>\n        </div>\n        <div class=\"vantagem seis\"><h1>Prioridade de reserva</h1>\n            <h4>Prioridade de reserva de lugares para os Amigos Coliseu Porto nos espetáculos de programação própria,\n                até 48 horas antes.</h4>\n        </div>\n        <div class=\"vantagem sete\">\n            <h1>Acesso antecipado à programação</h1>\n            <h4>Todas as novidades da programação são reveladas em primeira mão aos Amigos Coliseu Porto.</h4>\n        </div>\n        <div class=\"vantagem oito\"><h1>Campanhas Especiais\n        </h1>\n            <h4>Acesso a campanhas especiais reservadas aos Amigos Coliseu Porto, com vantagens, descontos e\n                experiências exclusivas.</h4>\n        </div>\n\n        <div class=\"vantagem nove\">\n            <h4>A Quota Anual Amigo Coliseu Porto tem o valor de 24€.</h4>\n            <h4>A Jóia de Inscrição tem o valor de 50€.</h4>\n            <h4>\n                As condições do Cartão Amigo Coliseu Porto aplicam-se para o ano civil em curso no momento da inscrição.\n            </h4>\n        </div>\n\n    </section>\n\n    <form id=\"subscription-form\" ng-if=\"!$ctrl.registered\" ng-submit=\"$ctrl.saveUser()\">\n        <div layout=\"column\" layout-align=\"center center\">\n            <h1>Seja Amigo</h1>\n            <div layout=\"column\">\n                <div layout=\"row\" layout-align=\"center center\">\n                    <input placeholder=\"Nome\" type=\"text\" class=\"nwsltr log comprido\" ng-model=\"$ctrl.newUser.name\" ng-class=\"{\'error\': $ctrl.newUser.$response.data.name}\" required>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <input placeholder=\"Morada\" type=\"text\" class=\"nwsltr log comprido\" ng-model=\"$ctrl.newUser.address\" ng-class=\"{\'error\': $ctrl.newUser.$response.data.address}\" required>\n                </div>\n                <div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"space-between center\">\n                    <input placeholder=\"Código Postal\" type=\"text\" required class=\"nwsltr log curto\" ng-model=\"$ctrl.newUser.zipCode\" ng-class=\"{\'error\': $ctrl.newUser.$response.data.zipCode}\" required>\n                    <input placeholder=\"Localidade\" type=\"text\" class=\"nwsltr log medio\" ng-model=\"$ctrl.newUser.location\" ng-class=\"{\'error\': $ctrl.newUser.$response.data.location}\" required>\n                </div>\n                <div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"space-between center\">\n                    <input placeholder=\"Telemóvel\" type=\"text\" class=\"nwsltr log curto\" ng-model=\"$ctrl.newUser.cellphone\" ng-class=\"{\'error\': $ctrl.newUser.$response.data.cellphone}\">\n                    <input placeholder=\"Email\" type=\"email\" class=\"nwsltr log medio\" ng-model=\"$ctrl.newUser.email\" ng-class=\"{\'error\': $ctrl.newUser.$response.data.email}\" required>\n                </div>\n                <div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"space-between center\">\n                    <input placeholder=\"Cartão do Cidadão\" type=\"text\" class=\"nwsltr log curto\" ng-model=\"$ctrl.newUser.cc\" ng-class=\"{\'error\': $ctrl.newUser.$response.data.cc}\" required>\n                    <input placeholder=\"Nº Contribuinte\" type=\"text\" class=\"nwsltr log medio\" ng-model=\"$ctrl.newUser.nif\" ng-class=\"{\'error\': $ctrl.newUser.$response.data.nif || ($ctrl.newUser.nif && $ctrl.newUser.nif[0] != \'1\' && $ctrl.newUser.nif[0] != \'2\')}\">\n\n                </div>\n\n                <h4>Escolha uma password</h4>\n\n                <div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"space-between center\">\n                    <input placeholder=\"Password\" type=\"password\" class=\"nwsltr log\" ng-model=\"$ctrl.newUser.password\" ng-class=\"{\'error\': $ctrl.newUser.$response.data.password}\" flex=\"50\">\n                    <input placeholder=\"Confirmar password\" type=\"password\" class=\"nwsltr log\" ng-model=\"$ctrl.newUser.confirmPassword\" ng-class=\"{\'error\': $ctrl.newUser.$response.data.confirmPassword}\" flex=\"50\">\n\n                </div>\n\n                <h5>Preencher campo <b>Nº Contribuinte</b> caso pretenda fatura com essa informação.</h5>\n\n\n                <h5>\n                    <md-checkbox ng-required=\"true\" ng-model=\"$ctrl.newUser.acceptTerms\" aria-label=\"Aceitação dos Termos e Condições\"></md-checkbox>\n                    Autorizo o tratamento dos meus dados pessoais para envio de mensagens<br> de divulgação dos eventos, notícias e atividades.\n                </h5>\n\n                <div class=\"submit-area\" layout=\"row\" layout-align=\"center center\">\n                    <button type=\"submit\" class=\"botoa\">Enviar inscrição</button>\n                </div>\n\n                <div layout=\"row\" layout-align=\"center\">\n                    <div class=\"text-danger\" ng-if=\"$ctrl.newUser.$response.status == 400\">\n                        Por favor, preencha o formulário corretamente\n\n                        <div ng-repeat=\"field in $ctrl.newUser.$response.data\">\n                            <p style=\"font-size: 12px; color: inherit\" ng-repeat=\"msg in field\">\n                                {{msg}}\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n    <section id=\"formulario\" ng-if=\"$ctrl.registered\">\n        <br> <br> <br>\n        <h1 class=\"text-center\" style=\"color: white\">Obrigado {{$ctrl.newUser.name}}</h1>\n        <h3 class=\"text-center\" style=\"color: white\">Enviamos-lhe um email com instruções de como finalizar o processo e\n            tornar-se um Amigo!</h3>\n        <br> <br> <br>\n    </section>\n\n\n    <section id=\"login\" class=\"centrar\">\n        <div>\n            <nav class=\"rodape\">\n                <ul class=\"centrar\">\n                    <li><input placeholder=\"Email\" type=\"email\" class=\"nwsltr log\" ng-model=\"$ctrl.login.email\"></li>\n                    <li><input placeholder=\"Senha\" type=\"password\" class=\"nwsltr log\" ng-model=\"$ctrl.login.password\">\n                    </li>\n                    <li>\n                        <button type=\"submit\" ng-disabled=\"!$ctrl.login.email || !$ctrl.login.password\" ng-click=\"$ctrl.login()\" class=\"botoa\">\n                            Entrar\n                        </button>\n                    </li>\n                </ul>\n            </nav>\n            <h3 style=\"text-align: center\" class=\"text-danger\">\n                <div ng-repeat=\"field in $ctrl.loginRequest.$$state.value.data\">\n                    <div ng-repeat=\"msg in field\">\n                        <span ng-if=\"msg == \'Unable to login with provided credentials.\'\">\n                            Email ou Senha incorreta.\n                        </span>\n                        <span ng-if=\"msg != \'Unable to login with provided credentials.\'\">{{::msg}}</span>\n                    </div>\n                </div>\n            </h3>\n            <nav class=\"rodape\">\n                <ul class=\"centrar\">\n                    <li><a ui-sref=\"forgot\">Esqueceu a senha de acesso?</a></li>\n                </ul>\n            </nav>\n        </div>\n    </section>\n\n    <section class=\"topo apoios\" style=\"background-color:#000; margin-top:0\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"center center\">\n        <img src=\"assets/images/rep_port.png\" alt=\"\" width=\"218\" height=\"90\"><img src=\"assets/images/portopontoamp.png\" alt=\"\" width=\"205\" height=\"90\">\n    </section>\n\n\n    <footer></footer>\n\n</md-content>\n");
$templateCache.put("app/components/memberPaymentsView/memberPaymentsView.html","<md-card flex style=\"overflow: auto\">\n    <md-card-content>\n        <div layout=\"row\" layout-align=\"start center\" layout-margin>\n            <md-select ng-model=\"$ctrl.member.$_(\'orders\').$params.state\" ng-change=\"$ctrl.member.$_(\'orders\').$refresh()\" placeholder=\"Filtrar por estado\">\n                <md-option value=\"\">Qualquer</md-option>\n                <md-option ng-value=\"::state\" ng-repeat=\"(state, stateName) in ::$ctrl.paymentStates track by state\">\n                    {{::stateName}}\n                </md-option>\n            </md-select>\n        </div>\n        <table width=\"100%\" id=\"payments-table\" ng-if-start=\"$ctrl.member.$_(\'orders\').length\">\n            <tr>\n                <th></th>\n                <th>Gerado em</th>\n                <th>Data de pagamento</th>\n                <th>Método de pagamento</th>\n                <th>Total</th>\n            </tr>\n            <tr ng-repeat=\"payment in $ctrl.member.$_(\'orders\') track by payment.id\" ng-click=\"$ctrl.showPayment(payment)\">\n                <td>\n                    #{{::payment.id}}\n                    <small>\n                        {{$ctrl.paymentStates[payment.state]}}\n                    </small>\n                </td>\n                <td>{{::payment.created | amCalendar}}</td>\n                <td>{{(payment.paymentDate | amCalendar) || \'- - -\'}}</td>\n                <td>{{payment.$_(\'paymentType\').name || \'- - -\'}}</td>\n                <td>{{::payment.total}}€</td>\n            </tr>\n        </table>\n        <paginator collection=\"$ctrl.member.$_(\'orders\')\" ng-if-end></paginator>\n        <div layout=\"column\" layout-align=\"center center\" ng-if=\"!$ctrl.member.$_(\'orders\').length\">\n            <h1 class=\"text-fade text-center\">\n                Nenhum pagamento encontrado\n            </h1>\n        </div>\n\n    </md-card-content>\n</md-card>\n");
$templateCache.put("app/components/memberView/memberView.html","<div flex layout=\"column\">\n    <div layout=\"row\" layout-align=\"space-between stretch\" style=\"border-bottom: solid 1px #ddd; min-height: 72px\">\n        <div layout=\"row\" layout-align=\"start end\" style=\"padding-left: 20px\">\n            <md-button class=\"tab-btn\" ui-sref=\".details\" ui-sref-active=\"active\">Detalhes</md-button>\n            <md-button class=\"tab-btn\" ui-sref=\".quotas\" ui-sref-active=\"active\">Quotas</md-button>\n            <md-button class=\"tab-btn\" ui-sref=\".payments\" ui-sref-active=\"active\">Pagamentos</md-button>\n        </div>\n\n        <div layout=\"row\" layout-margin layout-align=\"center center\">\n            <h3 class=\"text-center text-fade\">\n                <small class=\"text-fade\" ng-if=\"$ctrl.member.memberId\">#{{$ctrl.member.memberId}}</small>\n                {{$ctrl.member.name}}\n            </h3>\n            <img class=\"avatar-big\" ng-src=\"{{::$ctrl.member.avatar | mediaUrl}}\" style=\"width: 40px\">\n        </div>\n    </div>\n    <ui-view flex layout=\"column\"></ui-view>\n</div>\n\n");
$templateCache.put("app/components/memberQuotas/memberQuotas.html","<md-card flex layout=\"column\">\n    <md-toolbar layout=\"row\" ng-if=\"($ctrl.selectedQuotas = ($ctrl.member.$_(\'quotas\') | filter: {isSelected: true})).length > 0\">\n        <div class=\"md-toolbar-tools\">\n            <span>{{$ctrl.selectedQuotas.length}} quotas selecionadas</span>\n            <span flex></span>\n\n            <md-menu md-position-mode=\"target-right target\">\n                <md-button class=\"md-raised md-accent\" ng-click=\"$mdMenu.open($event)\">Gerar pagamento</md-button>\n                <md-menu-content width=\"4\">\n                    <md-menu-item ng-repeat=\"type in ::$ctrl.paymentTypes\">\n                        <md-button ng-click=\"$ctrl.generatePayment(type.id)\">\n                            <p>{{::type.name}}</p>\n                        </md-button>\n                    </md-menu-item>\n                </md-menu-content>\n            </md-menu>\n        </div>\n    </md-toolbar>\n    <md-card-content flex style=\"overflow: auto\">\n        <div layout=\"row\" layout-align=\"start start\" style=\"margin-top: 0\" layout-margin>\n            <year-filter-select initial-year=\"$ctrl.member.$_(\'quotas\').$params.year || $ctrl.currentYear\" on-change=\"$ctrl.member.$_(\'quotas\').$params.year = year; $ctrl.member.$_(\'quotas\').$refresh()\"></year-filter-select>\n\n            <md-select ng-model=\"$ctrl.member.$_(\'quotas\').$params.state\" placeholder=\"Filtrar por Estado\" style=\"padding: 0\" ng-change=\"$ctrl.member.$_(\'quotas\').$refresh()\">\n                <md-option value=\"\">Qualquer</md-option>\n                <md-option value=\"PENDING\">Pendente</md-option>\n                <md-option value=\"PAID\">Pago</md-option>\n            </md-select>\n        </div>\n        <table class=\"quotas-table\" cg-busy=\"$ctrl.member.$_(\'quotas\').$promise\" ng-if-start=\"$ctrl.member.$_(\'quotas\').length\">\n            <tr>\n                <th>Ano</th>\n                <th>Mês</th>\n                <th>Estado</th>\n                <th>Valor</th>\n                <th>\n                    Pagamento\n                    <a href=\"#\" style=\"font-size: 10px; display: block\" ng-click=\"$ctrl.selectAll()\" ng-if=\"($ctrl.pendingQuotas = ($ctrl.member.$_(\'quotas\') | filter: {state: \'PENDING\'})).length\">\n                        Selecionar todas\n                    </a>\n                </th>\n            </tr>\n            <tr ng-repeat=\"quota in $ctrl.member.$_(\'quotas\') | orderBy: [\'-year\', \'-month\']\">\n                <td class=\"minimum\">{{::quota.year}}</td>\n                <td>\n                    <month-name month=\"quota.month\">\n                </td>\n                <td>\n                    <span ng-if=\"::quota.state == \'PENDING\'\" class=\"badge badge-warning\">Pendente</span>\n                    <span ng-if=\"::quota.state == \'PAID\'\" class=\"badge badge-success\">Pago</span>\n                </td>\n                <td>\n                    {{::quota.price}}€\n                </td>\n                <td align=\"center\">\n                    <span ng-if=\"quota.state == \'PENDING\' && quota.$_(\'order\').state != \'IN_PAYMENT\' && quota.$_(\'order\').state != \'CREATED\'\">\n                        <md-checkbox class=\"no-margin\" ng-model=\"quota.isSelected\" style=\"margin-right: 20px\">\n                            <small class=\"text-fade\">Gerar pagamento</small>\n                        </md-checkbox>\n                    </span>\n                    <span ng-if=\"quota.$_(\'order\').id\" ng-class=\"{\'text-strike text-fade\': quota.$_(\'order\').state != \'IN_PAYMENT\' && quota.$_(\'order\').state != \'CREATED\' && quota.$_(\'order\').state != \'PAID\'}\">\n                        <a ng-click=\"$ctrl.showPayment(quota.$_(\'order\'))\" href=\"#\">(#{{::quota.$_(\'order\').id}})</a>\n                        <span ng-if=\"quota.$_(\'order\').$_(\'paymentType\').id\">{{quota.$_(\'order\').$_(\'paymentType\').name}}</span>\n                    </span>\n                </td>\n            </tr>\n        </table>\n        <paginator collection=\"$ctrl.member.$_(\'quotas\')\" ng-if-end></paginator>\n\n        <div layout=\"column\" layout-align=\"center center\" ng-if=\"!$ctrl.member.$_(\'quotas\').length\">\n            <h1 class=\"text-center text-fade\">Não existem quotas para esse período</h1>\n        </div>\n\n    </md-card-content>\n</md-card>\n\n\n<md-fab-speed-dial md-direction=\"up\" class=\"md-fling md-fab-bottom-right\" md-open=\"isOpen\" ng-init=\"isOpen=false\">\n    <md-fab-trigger>\n        <md-button aria-label=\"Add...\" class=\"md-fab\" ng-click=\"$ctrl.generateQuotas()\">\n            <md-tooltip md-direction=\"left\">Gerar quotas</md-tooltip>\n            <md-icon>add</md-icon>\n        </md-button>\n    </md-fab-trigger>\n</md-fab-speed-dial>\n");
$templateCache.put("app/components/monthName/monthName.html","{{::$ctrl.name}}\n");
$templateCache.put("app/components/monthSelector/monthSelector.html","<md-select ng-model=\"$ctrl.selectedMonths\" placeholder=\"{{::$ctrl.placeholder}}\" ng-change=\"$ctrl.onChange({selected: $ctrl.selectedMonths})\" multiple=\"multiple\">\n\n    <md-option ng-value=\"::month\" ng-repeat=\"month in ::$ctrl.months track by month\">\n        <month-name month=\"month\"></month-name>\n    </md-option>\n</md-select>\n");
$templateCache.put("app/components/newMemberView/newMemberView.html","<md-card style=\"overflow: auto\">\n    <md-card-content style=\"border-bottom: solid 1px #ddd\">\n        <div layout=\"row\" layout-align=\"space-between center\">\n            <h3 class=\"no-margin\">Novo membro</h3>\n            <md-button class=\"md-raised md-accent no-margin\" ng-click=\"$ctrl.save()\">Criar</md-button>\n        </div>\n    </md-card-content>\n    <md-card-content cg-busy=\"$ctrl.newMember.$promise\">\n\n        <form ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\">\n            <br> <br>\n\n            <div layout=\"column\" layout-gt-xs=\"row\" layout-margin>\n                <div flex-gt-xs=\"50\">\n\n                    <md-input-container class=\"md-block\">\n                        <label>ID associado</label>\n                        <input type=\"text\" ng-model=\"$ctrl.newMember.memberId\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'memberId\')\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.newMember.$response.data.member_id\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                    <md-input-container>\n                        <label>Tipo de associado</label>\n                        <md-select ng-model=\"$ctrl.newMember.type\">\n                            <md-option ng-value=\"group.id\" ng-repeat=\"group in $ctrl.userTypes\" ng-if=\"group.id != \'ACCOUNTANT\' && group.id != \'MARKETEER\'\">\n                                {{::group.name}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n\n                    <md-input-container class=\"md-block\">\n                        <label>Nº CC</label>\n                        <input type=\"text\" ng-model=\"$ctrl.newMember.cc\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'cc\')\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.newMember.$response.data.cc\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                    <md-input-container class=\"md-block\" flex>\n                        <label>Nº Contribuinte</label>\n                        <input type=\"text\" ng-model=\"$ctrl.newMember.nif\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'nif\')\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.newMember.$response.data.nif\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n\n                    <md-input-container>\n                        <label>Data de admissão</label>\n                        <input type=\"date\" ng-model=\"$ctrl.newMember.admissionDate\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.newMember.$response.data.admissionDate\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n\n                    <md-input-container class=\"md-block\">\n                        <label>Observações</label>\n                        <textarea ng-model=\"$ctrl.newMember.notes\" rows=\"3\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'notes\')\"></textarea>\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.newMember.$response.notes\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div flex-gt-xs=\"50\">\n\n\n                    <div layout=\"row\" class=\"md-block dual-input\">\n                        <md-input-container class=\"md-block\">\n                            <label>Email Contacto</label> <input type=\"email\" ng-model=\"$ctrl.newMember.contactEmail\" ng-change=\"$ctrl.changeInfo(\'contactEmail\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newMember.$response.data.contactEmail\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\">\n                            <label>Email Login</label> <input type=\"email\" ng-model=\"$ctrl.newMember.email\" ng-change=\"$ctrl.changeInfo(\'email\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newMember.$response.data.email\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n\n                    <div layout=\"row\">\n                        <md-input-container class=\"md-block\" flex=\"20\">\n                            <label>Tit.</label>\n                            <input type=\"text\" ng-model=\"$ctrl.newMember.title\" ng-model-options=\"{\'*\': \'$inherit\'}\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newMember.$response.data.title\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Nome</label>\n                            <input type=\"text\" ng-model=\"$ctrl.newMember.name\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'name\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newMember.$response.data.name\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <md-input-container class=\"md-block\">\n                        <label>Morada</label>\n                        <textarea type=\"text\" ng-model=\"$ctrl.newMember.address\" rows=\"2\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'address\')\"></textarea>\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.newMember.$response.data.address\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                    <div layout=\"row\" class=\"md-block dual-input\">\n                        <md-input-container class=\"md-block\">\n                            <label>Código Postal</label>\n                            <input type=\"text\" ng-model=\"$ctrl.newMember.zipCode\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'zipCode\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newMember.$response.data.zip_code\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Localidade</label>\n                            <input type=\"text\" ng-model=\"$ctrl.newMember.location\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'location\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newMember.$response.data.location\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" class=\"md-block dual-input\">\n                        <md-input-container class=\"md-block\">\n                            <label>Pessoa a contactar</label>\n                            <input type=\"text\" ng-model=\"$ctrl.newMember.groupContactPerson\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newMember.$response.data.group_contact_person\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Telemóvel</label>\n                            <input type=\"text\" ng-model=\"$ctrl.newMember.cellphone\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'cellphone\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newMember.$response.data.cellphone\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n\n                    <md-input-container class=\"md-block\">\n                        <label>Data de nascimento</label>\n                        <input type=\"date\" ng-model=\"$ctrl.newMember.birthday\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'birthday\')\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.newMember.$response.data.birthday\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n                </div>\n\n            </div>\n\n        </form>\n\n\n        <div ng-messages>\n            <div ng-repeat=\"message in $ctrl.newMember.$response.data.non_field_errors\">\n                {{message}}\n            </div>\n        </div>\n\n    </md-card-content>\n</md-card>\n");
$templateCache.put("app/components/newReportModal/newReportModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newReport.$promise\">\n	<form ng-submit=\"createReport()\" autocomplete=\"off\">\n            <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n		<h1 style=\"margin: 0\">Novo Relatório</h1>\n		<span flex></span>\n		<md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                    <md-icon>close</md-icon>\n		</md-button>\n            </div>\n\n	    <md-input-container class=\"md-block\">\n		<label>Tipo Relatório</label>\n		<md-select ng-model=\"newReport.type\" required>\n		    <md-option value=\"NEW_MEMBERS\">Novos Associados</md-option>\n		    <md-option value=\"EXCLUDED_MEMBERS\">Associados Excluídos</md-option>\n		</md-select>\n		<div ng-messages>\n                    <div ng-repeat=\"message in newReport.$response.data.type\">\n                        {{message}}\n                    </div>\n                </div>\n	    </md-input-container>\n\n	    <md-input-container>\n                <label>Data Início</label>\n                <input type=\"date\" ng-model=\"newReport.start\" required>\n                <div ng-messages>\n                    <div ng-repeat=\"message in newReport.$response.data.start\">\n                        {{message}}\n                    </div>\n                </div>\n            </md-input-container>\n\n	    <md-input-container>\n                <label>Data Fim</label>\n                <input type=\"date\" ng-model=\"newReport.end\" required>\n                <div ng-messages>\n                    <div ng-repeat=\"message in newReport.$response.data.end\">\n                        {{message}}\n                    </div>\n                </div>\n            </md-input-container>\n\n	    <md-input-container class=\"md-block\">\n		<label>Formato Ficheiro</label>\n		<md-select ng-model=\"newReport.extension\" required>\n		    <md-option value=\"PDF\">PDF</md-option>\n		    <md-option value=\"CSV\">CSV</md-option>\n		</md-select>\n		<div ng-messages>\n		    <div ng-repeat=\"message in newReport.$response.data.extension\">\n                        {{message}}\n                    </div>\n		</div>\n	    </md-input-container>\n\n            <div layout=\"row\" layout-align=\"center center\">\n		<md-button type=\"submit\" class=\"md-raised md-accent\">Criar Relatório</md-button>\n            </div>\n	</form>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/offline/offline.html","<div id=\"offline-msg\" md-whiteframe=\"4\" ng-class=\"{\'active\': $ctrl.isOffline}\">\n    <md-icon>warning</md-icon>\n    Falha de conexão\n</div>\n");
$templateCache.put("app/components/paginator/paginator.html","<div layout=\"row\" layout-align=\"center center\">\n    <md-button class=\"md-icon-button md-accent\" ng-click=\"$ctrl.goToPreviousPage()\" ng-disabled=\"$ctrl.collection.$page == 1\">\n        <md-icon>chevron_left</md-icon>\n    </md-button>\n    <div class=\"text-fade text-center\">\n        <span style=\"font-size: 14px; text-transform: uppercase\">Página</span>\n        <span>{{$ctrl.collection.$page}}</span>\n    </div>\n    <md-button class=\"md-icon-button md-accent\" ng-click=\"$ctrl.goToNextPage()\" ng-disabled=\"($ctrl.collection.$page * 25) >= $ctrl.collection.$totalCount\">\n        <md-icon>chevron_right</md-icon>\n    </md-button>\n</div>\n");
$templateCache.put("app/components/paymentDetailsView/paymentDetailsView.html","<md-content layout=\"column\">\n    <div layout=\"row\" layout-align=\"start center\" class=\"padding\">\n        <h3 style=\"margin: 0; margin-right: 5px\">\n            #{{::$ctrl.payment.id}}\n        </h3>\n        <payment-state-badge state=\"$ctrl.payment.state\"></payment-state-badge>\n        <span flex></span>\n        <div layout=\"column\" layout-align=\"center center\" style=\"margin-right: 10px\">\n            <small class=\"text-fade\">Metodo de pagamento</small>\n            <h3 class=\"no-margin\">{{$ctrl.payment.$_(\'paymentType\').name}}</h3>\n        </div>\n        <div layout=\"column\" layout-align=\"center center\">\n            <small class=\"text-fade\">Valor total</small>\n            <h3 class=\"no-margin\">{{::$ctrl.payment.total}}€</h3>\n        </div>\n        <md-button ng-click=\"$ctrl.onClose()\" class=\"md-icon-button\" style=\"margin-right: 0; padding-right: 0\">\n            <md-icon>close</md-icon>\n        </md-button>\n    </div>\n\n    <div class=\"padding\">\n        <div layout=\"column\" layout-align=\"center center\">\n            <table class=\"payment-table\">\n                <tr>\n                    <th>Gerado em</th>\n                    <td>{{::$ctrl.payment.created | amCalendar}}</td>\n                </tr>\n                <tr ng-if=\"::$ctrl.payment.paymentDate\">\n                    <th>Pago em</th>\n                    <td>{{::$ctrl.payment.paymentDate | amCalendar}}</td>\n                </tr>\n                <tr ng-if-start=\"$ctrl.payment.paymentType == \'IFTHEN\' && $ctrl.payment.$_(\'paymentIfthen\').id\">\n                    <th>Entidade</th>\n                    <td>{{$ctrl.payment.$_(\'paymentIfthen\').entity}}</td>\n                </tr>\n                <tr>\n                    <th>Referência</th>\n                    <td>{{$ctrl.payment.$_(\'paymentIfthen\').reference}}</td>\n                </tr>\n                <tr ng-if-end>\n                    <th>Valor</th>\n                    <td>{{$ctrl.payment.$_(\'paymentIfthen\').value}}€</td>\n                </tr>\n            </table>\n            <table class=\"payment-items-table\">\n                <tr ng-repeat=\"gem in $ctrl.payment.$_(\'gems\')\">\n                    <th>Joia de inscriçao</th>\n                    <td>{{gem.price}}€</td>\n                </tr>\n                <tr ng-repeat=\"quota in $ctrl.payment.$_(\'quotas\')\">\n                    <th>Quota de\n                        <month-name month=\"quota.month\"></month-name>\n                        de {{quota.year}}\n                    </th>\n                    <td>{{quota.price}}€</td>\n                </tr>\n                <tr ng-repeat=\"donation in $ctrl.payment.$_(\'donations\')\">\n                    <th>Doação</th>\n                    <td>{{donation.price}}€</td>\n                </tr>\n            </table>\n        </div>\n    </div>\n\n    <div layout=\"row\">\n        <md-button ng-click=\"$ctrl.markAsPaid()\" ng-if=\"$ctrl.payment.state == \'CREATED\' || $ctrl.payment.state == \'IN_PAYMENT\' && $ctrl.payment.paymentType == \'CASH\'\">\n            Marcar como pago\n        </md-button>\n        <span flex></span>\n        <md-button class=\"md-warn\" ng-if=\"$ctrl.payment.state == \'CREATED\' || $ctrl.payment.state == \'IN_PAYMENT\'\" ng-click=\"$ctrl.cancelPayment()\">\n            Cancelar pagamento\n        </md-button>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/paymentStateBadge/paymentStateBadge.html","<span class=\"badge\" ng-class=\"{\'badge-success\': $ctrl.state == \'PAID\', \'badge-warning\': $ctrl.state != \'PAID\'}\">\n    {{::$ctrl.paymentStates[$ctrl.state]}}\n</span>\n");
$templateCache.put("app/components/quotaSettingsView/quotaSettingsView.html","<md-content flex layout=\"column\" layout-align=\"start center\" layout-margin>\n    <div>\n        <h3 class=\"text-center\">Categorias actuais</h3>\n        <md-card cg-busy=\"$ctrl.userTypes.$promise\">\n            <md-card-content>\n                <table width=\"100%\">\n                    <tr>\n                        <th align=\"left\">Tipo de associado</th>\n                        <th>Tipo por defeito</th>\n                        <th>Pode fazer login</th>\n                        <th>Aceita novos registos</th>\n                        <th>Data de início</th>\n                        <th>Data de fim</th>\n                        <th>Joia</th>\n                        <th>Quota</th>\n                        <th></th>\n                    </tr>\n                    <tr ng-repeat=\"type in $ctrl.userTypes | filter: {isAcceptingUsers: true} track by type.id\" ng-if=\"type.id != \'ACCOUNTANT\' && type.id != \'MARKETEER\'\">\n                        <td>\n                            {{type.name}}\n                        </td>\n                        <td align=\"center\">\n                            <md-checkbox disabled=\"disabled\" ng-model=\"type.defaultUserType\"></md-checkbox>\n                        </td>\n                        <td align=\"center\">\n                            <md-checkbox disabled=\"disabled\" ng-model=\"type.isAbleToLogin\"></md-checkbox>\n                        </td>\n                        <td align=\"center\">\n                            <md-checkbox disabled=\"disabled\" ng-model=\"type.isAcceptingUsers\"></md-checkbox>\n                        </td>\n                        <td align=\"center\">{{type.$_(\'currentPrice\').startDate | amDateFormat: \'DD MMMM YYYY\'}}</td>\n                        <td align=\"center\">{{type.$_(\'currentPrice\').endDate | amDateFormat: \'DD MMMM YYYY\'}}</td>\n                        <td align=\"center\">\n                            <input type=\"text\" placeholder=\"0.00\" ng-model=\"type.$_(\'currentPrice\').gemAmount\" ng-disabled=\"!type.editing\">€\n                        </td>\n                        <td align=\"center\">\n                            <input type=\"text\" placeholder=\"0.00\" ng-model=\"type.$_(\'currentPrice\').quotaAmount\" ng-disabled=\"!type.editing\">€\n                        </td>\n                        <td style=\"width: 1%\">\n                            <md-button class=\"md-icon-button edit-btn\" ng-click=\"type.editing = true\" ng-if=\"!type.editing\">\n                                <md-icon>edit</md-icon>\n                            </md-button>\n                            <md-button class=\"md-icon-button md-accent md-raised\" ng-click=\"$ctrl.changePrice(type, type.$_(\'currentPrice\').gemAmount, type.$_(\'currentPrice\').quotaAmount)\" ng-if=\"type.editing\">\n                                <md-icon>save</md-icon>\n                            </md-button>\n                        </td>\n                    </tr>\n                </table>\n            </md-card-content>\n        </md-card>\n\n\n        <br>\n        <br>\n        <h3 class=\"text-center\">Categorias históricas</h3>\n\n        <md-card cg-busy=\"$ctrl.userTypes.$promise\">\n            <md-card-content>\n                <table width=\"100%\">\n                    <tr>\n                        <th align=\"left\">Tipo de associado</th>\n                        <th>Tipo por defeito</th>\n                        <th>Pode fazer login</th>\n                        <th>Aceita novos registos</th>\n                        <th>Data de início</th>\n                        <th>Data de fim</th>\n                        <th>Joia</th>\n                        <th>Quota</th>\n                        <th></th>\n                    </tr>\n                    <tr ng-repeat=\"type in $ctrl.userTypes | filter: {isAcceptingUsers: false} track by type.id\" ng-if=\"type.id != \'ACCOUNTANT\' && type.id != \'MARKETEER\'\">\n                        <td>\n                            {{type.name}}\n                        </td>\n                        <td align=\"center\">\n                            <md-checkbox disabled=\"disabled\" ng-model=\"type.defaultUserType\"></md-checkbox>\n                        </td>\n                        <td align=\"center\">\n                            <md-checkbox disabled=\"disabled\" ng-model=\"type.isAbleToLogin\"></md-checkbox>\n                        </td>\n                        <td align=\"center\">\n                            <md-checkbox disabled=\"disabled\" ng-model=\"type.isAcceptingUsers\"></md-checkbox>\n                        </td>\n                        <td align=\"center\">{{type.$_(\'currentPrice\').startDate | amDateFormat: \'DD MMMM YYYY\'}}</td>\n                        <td align=\"center\">{{type.$_(\'currentPrice\').endDate | amDateFormat: \'DD MMMM YYYY\'}}</td>\n                        <td align=\"center\">\n                            <input type=\"text\" placeholder=\"0.00\" ng-model=\"type.$_(\'currentPrice\').gemAmount\" disabled=\"disabled\">€\n                        </td>\n                        <td align=\"center\">\n                            <input type=\"text\" placeholder=\"0.00\" ng-model=\"type.$_(\'currentPrice\').quotaAmount\" disabled=\"disabled\">€\n                        </td>\n                        <td style=\"width: 1%\">\n                            <md-button class=\"md-icon-button edit-btn\" style=\"visibility: hidden\">\n                                <md-icon>edit</md-icon>\n                            </md-button>\n                        </td>\n                    </tr>\n                </table>\n            </md-card-content>\n        </md-card>\n    </div>\n\n    <div style=\"width: 100%\">\n        <br>\n        <h3 class=\"text-center\">Histórico de alterações</h3>\n        <md-card>\n            <md-card-content>\n                <table width=\"100%\">\n                    <tr>\n                        <th align=\"left\">Alteração</th>\n                        <th>Dia de início</th>\n                        <th>Dia de fim</th>\n                        <th>Joia</th>\n                        <th>Quota</th>\n                    </tr>\n                    <tr ng-repeat=\"typePrice in $ctrl.userTypePrices | orderBy: \'-startDate\' track by typePrice.id\" ng-class=\"{\'highlight\': typePrice.$highlight}\">\n                        <td>\n                            {{typePrice.$_(\'userType\').name}}\n                        </td>\n                        <td align=\"center\">{{typePrice.startDate | amDateFormat: \'DD MMMM YYYY\'}}</td>\n                        <td align=\"center\">{{typePrice.endDate | amDateFormat: \'DD MMMM YYYY\'}}</td>\n                        <td align=\"center\">\n                            {{typePrice.gemAmount}}€\n                        </td>\n                        <td align=\"center\">\n                            {{typePrice.quotaAmount}}€\n                        </td>\n                    </tr>\n                </table>\n            </md-card-content>\n        </md-card>\n    </div>\n\n</md-content>\n");
$templateCache.put("app/components/reportsList/reportsList.html","<md-content flex ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 300, \'blur\': 0}, updateOnDefault: true}\">\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Relatórios</h1>\n            <span flex></span>\n        </div>\n\n        <div layout=\"column\" layout-align=\"start stretch\" class=\"filters-bar\">\n            <div layout=\"row\">\n		<div class=\"filter-item\" layout=\"column\" layout-align=\"center start\">\n                    <md-select ng-model=\"$ctrl.type\" placeholder=\"Tipo Relatório\" class=\"md-no-underline\" ng-change=\"$ctrl.changeFilters(\'type\', $ctrl.type)\">\n                        <md-option value=\"\">Tipo Relatório</md-option>\n			<md-option value=\"NEW_MEMBERS\">Novos Associados</md-option>\n			<md-option value=\"EXCLUDED_MEMBERS\">Associados Excluídos</md-option>\n			<md-option value=\"DONATIONS\">Donativos</md-option>\n                    </md-select>\n                </div>\n		<div class=\"filter-item\" layout=\"column\" layout-align=\"center start\">\n                    <md-select ng-model=\"$ctrl.extension\" placeholder=\"Formato Ficheiro\" class=\"md-no-underline\" ng-change=\"$ctrl.changeFilters(\'extension\', $ctrl.extension)\">\n                        <md-option value=\"\">Formato Ficheiro</md-option>\n			<md-option value=\"PDF\">PDF</md-option>\n			<md-option value=\"CSV\">CSV</md-option>\n                    </md-select>\n                </div>\n            </div>\n        </div>\n\n        <table style=\"width: 100%\">\n            <tr>\n                <th width=\"5%\" align=\"left\">ID</th>\n                <th align=\"left\">Tipo Relatório</th>\n                <th align=\"left\">Data Início</th>\n		<th align=\"left\">Data Fim</th>\n		<th align=\"center\">Formato Ficheiro</th>\n                <th align=\"center\">Ações</th>\n            </tr>\n\n            <tr ng-repeat=\"report in $ctrl.reports\" style=\"color: #868686\">\n                <td align=\"left\">\n                    {{::report.id}}\n                </td>\n		<td align=\"left\">\n                    Relatório {{::report.type | reportNames}}\n                </td>\n		<td align=\"left\">\n                    {{::report.start | amDateFormat: \'DD/MM/YYYY\'}}\n                </td>\n		<td align=\"left\">\n                    {{::report.end | amDateFormat: \'DD/MM/YYYY\'}}\n                </td>\n		<td align=\"center\">\n		    {{::report.extension}}\n		</td>\n		<td align=\"center\">\n		    <md-button href=\"{{report.file | mediaUrl}}\" target=\"_blank\" class=\"md-button md-icon-button\">\n			<md-icon color=\"primary\">cloud_download</md-icon>\n			<md-tooltip>descarregar relatório</md-tooltip>\n                    </md-button>\n		    <md-button ng-click=\"$ctrl.destroyReport(report)\" target=\"_blank\" class=\"md-button md-icon-button\">\n			<md-icon color=\"primary\">delete</md-icon>\n			<md-tooltip>eliminar relatório</md-tooltip>\n                    </md-button>\n		</td>\n\n            </tr>\n        </table>\n\n        <h1 class=\"text-center text-fade\" ng-if=\"$ctrl.reports.length == 0\">Nenhum relatório encontrado</h1>\n\n        <br><br>\n        <div layout=\"column\">\n            <div layout=\"row\" layout-align=\"center center\">\n                <small class=\"text-fade\">\n                    A mostrar {{$ctrl.reports.length}} de {{$ctrl.reports.$totalCount}}\n                </small>\n            </div>\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-button ng-click=\"$ctrl.loadMore()\" ng-if=\"$ctrl.reports.$totalCount > $ctrl.reports.length\" class=\"md-raised\">\n                    Carregar mais\n                </md-button>\n            </div>\n        </div>\n\n    </div>\n</md-content>\n\n\n<md-fab-speed-dial md-direction=\"up\" class=\"md-fling md-fab-bottom-right\" md-open=\"isOpen\" ng-init=\"isOpen=false\">\n    <md-fab-trigger>\n        <md-button aria-label=\"Add...\" class=\"md-fab\" ng-click=\"$ctrl.newReport()\">\n            <md-icon>add</md-icon>\n        </md-button>\n    </md-fab-trigger>\n</md-fab-speed-dial>\n");
$templateCache.put("app/components/sendEmail/sendEmail.html","<md-content>\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Enviar e-mail</h1>\n            <span flex></span>\n        </div>\n        <md-content layout-xs=\"column\" layout=\"row\" layout-margin>\n            <div flex-xs=\"\" flex-gt-xs=\"70\" layout=\"column\">\n                <md-input-container class=\"md-block\">\n                    <label>Assunto do email</label> <input type=\"text\" ng-model=\"$ctrl.email.subject\">\n                </md-input-container>\n\n\n                <textarea ui-tinymce=\"{plugins: \'link image code\', toolbar: \'undo redo | bold italic | alignleft aligncenter alignright | code\'}\" ng-model=\"$ctrl.email.message\"></textarea>\n\n                <br><br>\n\n                <div layout=\"row\" layout-align=\"center center\">\n                    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.send();\">\n                        <md-icon>mail</md-icon>\n                        Enviar\n                    </md-button>\n                </div>\n            </div>\n\n            <div flex-xs=\"\" flex-gt-xs=\"30\" layout=\"column\" cg-busy=\"$ctrl.contacts.$promise\">\n                <md-card id=\"members\" style=\"padding: 20px 0\">\n                    <md-list>\n                        <md-list-item ng-repeat=\"member in $ctrl.contacts | orderBy: \'name\'\">\n                            <div layout=\"row\" style=\"width: 100%\" layout-align=\"center center\">\n                                <img ng-src=\"{{member.avatar | mediaUrl}}\" style=\"max-width: 40px; max-height: 40px\" class=\"avatar\">\n                                <div style=\"padding-left: 10px\" layout=\"column\" flex>\n                                    <h3 flex style=\"margin: 0\">{{::member.name}}</h3>\n                                    <small>{{::member.email}}</small>\n                                </div>\n                            </div>\n                            <md-button class=\"md-button md-icon-button\" ng-click=\"$ctrl.contacts.$remove(member)\">\n                                <md-icon>delete</md-icon>\n                            </md-button>\n                        </md-list-item>\n                    </md-list>\n                </md-card>\n            </div>\n        </md-content>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/settingsView/settingsView.html","<div flex layout=\"column\">\n    <div layout=\"row\" layout-align=\"space-between stretch\" style=\"border-bottom: solid 1px #ddd; padding-top: 20px\">\n        <div layout=\"row\" layout-align=\"start end\" style=\"padding-left: 20px\">\n            <md-button class=\"tab-btn\" ui-sref=\".quotas\" ui-sref-active=\"active\">Quotas e Jóias</md-button>\n        </div>\n\n        <h3 style=\"margin-top: 0; padding-bottom:10px; margin-right: 20px\" class=\"text-fade\">Configurações</h3>\n    </div>\n    <ui-view flex layout=\"column\"></ui-view>\n</div>\n");
$templateCache.put("app/components/yearFilterSelect/yearFilterSelect.html","<md-select ng-model=\"$ctrl.filterByYear\" ng-change=\"$ctrl.onChange({year: $ctrl.filterByYear})\" placeholder=\"{{::$ctrl.placeholder}}\" class=\"no-margin\">\n    <md-option value=\"\">Qualquer</md-option>\n    <md-option ng-repeat=\"year in ::$ctrl.years track by year\" value=\"{{::year}}\">{{::year}}</md-option>\n</md-select>\n");
$templateCache.put("app/shared/html/cgbusy/cgbusy.template.html","<div class=\"cg-busy-processing-wrapper\" layout=\"row\" layout-align=\"center center\">\n    <span>{{$message}}</span>\n    <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div>\n\n\n<style>\n    .cg-busy-processing-wrapper {\n        position: relative;\n        width: 100%;\n        height: 100%;\n    }\n</style>\n");
$templateCache.put("app/shared/html/menuBtn/menuBtn.html","<md-button class=\"md-icon-button\" ng-click=\"$ctrl.openMenu()\">\n    <md-icon>menu</md-icon>\n</md-button>\n");
$templateCache.put("app/components/auth/views/auth.forgot.html","<md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\">\n\n    <div class=\"full-page\" layout=\"column\" layout-align=\"center center\">\n        <div class=\"full-page-background coliseu-background\"></div>\n        <div class=\"full-page-content\" layout=\"column\" layout-align=\"center center\">\n\n            <md-card>\n                <md-card-content class=\"auth-wrapper\">\n                    <md-input-container class=\"general-login-error\" ng-if=\"vm.member.data.non_field_errors\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in vm.member.data.non_field_errors\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                    <p class=\"text-fade\">\n                        <small>Insira o endereço de email para receber instruções.</small>\n                    </p>\n                    <form ng-submit=\"vm.requestChange();\" cg-busy=\"vm.requestStatus\" ng-hide=\"vm.requestStatus.$$state.value.status==200\">\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Email</label> <input ng-model=\"vm.email\" type=\"email\">\n                            <div ng-messages>\n                                <div ng-if=\"vm.requestStatus.$$state.value.data.detail\">\n                                    {{vm.requestStatus.$$state.value.data.detail}}\n                                </div>\n                                <div ng-repeat=\"message in vm.requestStatus.$$state.value.data.email\" ng-if=\"vm.requestStatus.$$state.value.data.email\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <div layout=\"row\" layout-align=\"end center\">\n                            <md-button class=\"no-margin md-accent\" type=\"submit\" ng-disabled=\"!vm.email\"><span>Recuperar password</span>\n                            </md-button>\n                        </div>\n                        <p class=\"text-justify text-xs text-second text-fade\">\n                            <small>\n                                Se não receber um email em dois minutos, por favor verifique o spam\n                            </small>\n                        </p>\n\n                    </form>\n\n                    <div ng-if=\"vm.requestStatus.$$state.value.status==200\" layout=\"column\" layout-padding=\"\" layout-align=\"center center\" style=\"border: solid rgba(150, 255, 150, 0.6) 2px; background-color: rgba(150, 255, 150, 0.2)\">\n                        <md-icon>email_outline</md-icon>\n                        <p style=\"text-align: center\">\n                            Enviamos um link para o seu email para alterar a sua password<br>\n                        </p>\n                    </div>\n                </md-card-content>\n            </md-card>\n\n            <div style=\"font-size: 11px\" class=\"text-center\">\n                <span>Ainda não é sócio?</span>&nbsp<a ui-sref=\"home\">Registe-se</a>\n            </div>\n\n        </div>\n    </div>\n\n\n</md-content>\n");
$templateCache.put("app/components/auth/views/auth.login.view.html","<md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\">\n\n    <div class=\"full-page\" layout=\"column\" layout-align=\"center center\" flex>\n        <div class=\"full-page-background coliseu-background\"></div>\n        <div class=\"full-page-content\" layout=\"column\" layout-align=\"center center\">\n\n            <md-card>\n                <md-card-content class=\"auth-wrapper\">\n                    <br>\n                    <form ng-submit=\"vm.login();\" style=\"min-width: 400px\">\n                        <md-input-container class=\"general-login-error no-margin\" ng-if=\"vm.member.data.non_field_errors\">\n                            <div ng-messages class=\"text-center\">\n                                <small ng-repeat=\"message in vm.member.data.non_field_errors\">\n                                    {{message}}\n                                </small>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Email</label> <input type=\"email\" ng-model=\"vm.email\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.member.data.email\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Password</label> <input type=\"password\" ng-model=\"vm.password\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.member.data.password\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <div layout=\"column\" layout-align=\"center center\">\n                            <input type=\"submit\" value=\"Entrar\" class=\"md-button md-accent\">\n                            <a ui-sref=\"forgot\">\n                                <small>Esqueceu a password?</small>\n                            </a>\n                        </div>\n                    </form>\n                </md-card-content>\n            </md-card>\n\n            <div style=\"font-size: 11px\" class=\"text-center\">\n                <span>Ainda não é sócio?</span>&nbsp<a ui-sref=\"home\">Registe-se</a>\n            </div>\n\n        </div>\n    </div>\n\n\n</md-content>\n\n");
$templateCache.put("app/components/auth/views/auth.register.view.html","<div layout=\"column\" flex>\n    <md-toolbar>\n            <div class=\"md-toolbar-tools\">\n                <md-button class=\"md-icon-button\" ui-sref=\"login\">\n                    <md-icon>arrow_back</md-icon>\n                </md-button>\n                <span>Create account</span>\n            </div>\n    </md-toolbar>\n\n    <md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\" layout-align=\"center center\">\n        <md-card>\n            <md-card-content class=\"auth-wrapper\" style=\"min-width: 500px\">\n                <h1 align=\"center\">Create account</h1>\n                <br>\n                <div ng-if=\"vm.registering\">\n                    <form ng-submit=\"vm.register();\">\n                        <md-input-container class=\"general-login-error\" ng-if=\"vm.user.$response.data.non_field_errors\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.user.data.non_field_errors\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Name</label>\n                            <input type=\"text\" ng-model=\"vm.user.name\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.user.$response.data.name\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Email</label>\n                            <input ng-model=\"vm.user.email\" type=\"email\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.user.$response.data.email\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Password</label>\n                            <input type=\"password\" ng-model=\"vm.user.password\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.user.$response.data.password\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Confirm password</label>\n                            <input type=\"password\" ng-model=\"vm.user.confirmPassword\">\n                        </md-input-container>\n\n\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <md-button type=\"submit\" class=\"md-button md-raised md-accent\"><span>Create account</span></md-button>\n                        </div>\n\n                    </form>\n                </div>\n                <div ng-if=\"!vm.registering\" cg-busy=\"vm.resendStatus.promise\">\n                    <br>\n                    <p class=\"text-sm\">\n                        <span ng-if=\"!vm.resent\">We sent an email</span>\n                        <span ng-if=\"vm.resent\">We resend the email</span>\n                        <span>to <b>{{vm.user.email}}</b>, with instructions to activate your account.</span>\n                    </p>\n\n                    <p class=\"text-sm\" ng-if=\"!vm.resent\">\n                        This check protects your account.\n                    </p>\n\n                    <p class=\"text-sm\">\n                        If you don\'t receive an email within the next two minutes, please check your spam.\n                    </p>\n\n                    <div layout=\"row\" layout-align=\"end\" ng-if=\"!vm.resent\">\n                        <md-button class=\"md-button md-raised md-accent\" ng-click=\"vm.resend();\">\n                            <span>Resend email</span>\n                        </md-button>\n                    </div>\n                </div>\n            </md-card-content>\n        </md-card>\n    </md-content>\n</div>\n\n\n");
$templateCache.put("app/components/auth/views/auth.set.password.html","<md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\">\n\n    <div class=\"full-page\" layout=\"column\" layout-align=\"center center\">\n        <div class=\"full-page-background coliseu-background\"></div>\n        <div class=\"full-page-content\" layout=\"column\" layout-align=\"center center\">\n            <h1 align=\"center\">Recuperar password</h1>\n\n            <md-card>\n                <md-card-content class=\"auth-wrapper\" style=\"min-width: 500px\">\n                    <br>\n                    <form ng-submit=\"vm.setPassword();\" cg-busy=\"vm.requestStatus\">\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Nova password</label> <input type=\"password\" ng-model=\"vm.password\">\n                            <div ng-messages>\n                                <div>\n                                    {{vm.requestStatus.$$state.value.data.detail}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Confirme a password</label> <input type=\"password\" ng-model=\"vm.confirmPassword\">\n                            <div ng-messages>\n                                <div>\n                                    {{vm.requestStatus.$$state.value.data.detail}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <div layout=\"row\" layout-align=\"end end\">\n                            <md-tooltip ng-if=\"vm.password != vm.confirmPassword\">\n                                <span>Por favor verifique que as duas passwords coincidem</span>\n                            </md-tooltip>\n                            <md-button class=\"no-margin md-button md-accent\" type=\"submit\" ng-disabled=\"(vm.password != vm.confirmPassword) || !vm.password\">\n                                <span class=\"\">Alterar password</span>\n                            </md-button>\n                        </div>\n                    </form>\n                </md-card-content>\n            </md-card>\n\n            <div style=\"font-size: 11px\" class=\"text-center\">\n                <span>Ainda não é sócio?</span>&nbsp<a ui-sref=\"home\">Registe-se</a>\n            </div>\n\n        </div>\n    </div>\n\n\n</md-content>\n");
$templateCache.put("app/components/notfound/views/notfound.html","<div layout=\"column\" layout-align=\"center center\" flex>\n    <h1 class=\"text-fade text-center\" style=\"font-size: 60px\">404</h1>\n    <h1 class=\"text-fade text-center\" style=\"font-weight: 300\">Page Not found</h1>\n</div>\n");
$templateCache.put("app/components/users/adminsList/adminsList.html","<md-content>\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Administradores</h1>\n            <span flex></span>\n        </div>\n\n        <md-content layout-xs=\"column\" layout=\"row\">\n            <div flex-xs=\"\" flex-gt-xs=\"50\" layout=\"column\">\n                <h2 class=\"text-fade\" style=\"padding-left: 43%\">Marketing</h2>\n                <md-card id=\"marketeer\">\n                    <md-button ng-if=\"!$ctrl.creatingMarketeer\" class=\"md-raised md-accent\" ng-click=\"$ctrl.creatingMarketeer = true\">\n                        <md-icon>add</md-icon>\n                        Adicionar\n                    </md-button>\n                    <md-list ng-if=\"!$ctrl.creatingMarketeer\">\n                        <md-list-item ng-repeat=\"marketeer in $ctrl.marketeers | orderBy: \'name\'\">\n                            <div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n                                <img ng-src=\"{{marketeer.avatar | mediaUrl}}\" class=\"avatar\">\n                                <div style=\"padding-left: 10px\" layout=\"column\" flex>\n                                    <h3 flex>{{marketeer.name}}</h3>\n                                </div>\n                            </div>\n                            <!--<md-button class=\"md-button md-icon-button\" ng-click=\"$ctrl.removeUser(marketeer)\">\n                                <md-icon>delete</md-icon>\n                            </md-button>-->\n                        </md-list-item>\n                        <p class=\"text-fade text-center\" ng-if=\"!$ctrl.marketeers.length\">Nenhum administrador</p>\n                    </md-list>\n                    <md-card-content ng-if=\"$ctrl.creatingMarketeer\" cg-busy=\"$ctrl.newMarketeer.$promise\">\n                        <h3 class=\"text-center text-fade\">Novo administrador</h3>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Nome</label>\n                            <input type=\"text\" ng-model=\"$ctrl.newMarketeer.name\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newMarketeer.$response.data.name\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Email</label>\n                            <input type=\"email\" ng-model=\"$ctrl.newMarketeer.email\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newMarketeer.$response.data.email\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Password</label>\n                            <input type=\"password\" ng-model=\"$ctrl.newMarketeer.password\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newMarketeer.$response.data.password\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Repetir a password</label>\n                            <input type=\"password\" ng-model=\"$ctrl.newMarketeer.confirm_password\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newMarketeer.$response.data.non_field_errors\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <br><br>\n\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <md-button class=\"md-accent md-raised\" ng-click=\"$event.stopPropagation(); $ctrl.saveMarketeer();\">Criar\n                            </md-button>\n                            <md-button class=\"md-raised\" ng-click=\"$ctrl.creatingMarketeer = false\">Cancelar</md-button>\n                        </div>\n                    </md-card-content>\n                </md-card>\n            </div>\n\n            <div flex-xs=\"\" flex-gt-xs=\"50\" layout=\"column\">\n                <h2 class=\"text-fade\" style=\"padding-left: 40%\">Contabilidade</h2>\n                <md-card id=\"accountant\">\n                    <md-button ng-if=\"!$ctrl.creatingAccountant\" class=\"md-raised md-accent\" ng-click=\"$ctrl.creatingAccountant = true\">\n                        <md-icon>add</md-icon>\n                        Adicionar\n                    </md-button>\n                    <md-list ng-if=\"!$ctrl.creatingAccountant\">\n                        <md-list-item ng-repeat=\"accountant in $ctrl.accountants | orderBy: \'name\'\">\n                            <div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n                                <img ng-src=\"{{accountant.avatar | mediaUrl}}\" class=\"avatar\">\n                                <div style=\"padding-left: 10px\" layout=\"column\" flex>\n                                    <h3 flex>{{accountant.name}}</h3>\n                                </div>\n                            </div>\n                            <!--<md-button class=\"md-button md-icon-button\" ng-click=\"$ctrl.removeUser(accountant)\">\n                                <md-icon>delete</md-icon>\n                            </md-button>-->\n                        </md-list-item>\n                        <p class=\"text-fade text-center\" ng-if=\"!$ctrl.accountants.length\">Nenhum administrador</p>\n                    </md-list>\n                    <md-card-content ng-if=\"$ctrl.creatingAccountant\" cg-busy=\"$ctrl.newAccountant.$promise\">\n                        <h3 class=\"text-center text-fade\">Novo administrador</h3>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Nome</label>\n                            <input type=\"text\" ng-model=\"$ctrl.newAccountant.name\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newAccountant.$response.data.name\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Email</label>\n                            <input type=\"email\" ng-model=\"$ctrl.newAccountant.email\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newAccountant.$response.data.email\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Password</label>\n                            <input type=\"password\" ng-model=\"$ctrl.newAccountant.password\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newAccountant.$response.data.password\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Repetir a password</label>\n                            <input type=\"password\" ng-model=\"$ctrl.newAccountant.confirm_password\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.newAccountant.$response.data.non_field_errors\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <br><br>\n\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <md-button class=\"md-accent md-raised\" ng-click=\"$event.stopPropagation(); $ctrl.saveAccountant();\">Criar\n                            </md-button>\n                            <md-button class=\"md-raised\" ng-click=\"$ctrl.creatingAccountant = false\">Cancelar\n                            </md-button>\n                        </div>\n                    </md-card-content>\n                </md-card>\n            </div>\n        </md-content>\n\n    </div>\n</md-content>\n");
$templateCache.put("app/components/users/editProfile/editProfile.html","<md-content>\n    <div class=\"\" layout=\"column\" layout-gt-xs=\"row\" layout-margin>\n\n        <md-card flex=\"50\">\n            <md-card-content cg-busy=\"$ctrl.user.$promise\">\n                <form ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\">\n                    <h1 class=\"text-center text-fade\">Informação Pessoal</h1>\n                    <br> <br>\n\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div id=\"change-avatar-area\" layout=\"row\" layout-align=\"center center\" style=\"background-image: url(\'{{$ctrl.user.avatar | mediaUrl}}\')\">\n                            <div class=\"change-avatar-btn\" layout=\"row\" layout-align=\"center center\" ngf-select media-auto-upload ng-model=\"$ctrl.user.avatar\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\" ngf-resize=\"{ratio: \'1:1\', centerCrop: true}\" ngf-max-size=\"2MB\" accept=\"image/*\">\n                                <span>Alterar foto</span>\n                            </div>\n                        </div>\n                    </div>\n\n                    <md-input-container class=\"md-block\">\n                        <label>Name</label>\n                        <input type=\"text\" ng-model=\"$ctrl.user.name\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo()\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.user.$response.data.name\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                        <label>Email</label> <input type=\"email\" ng-model=\"$ctrl.user.email\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.user.$response.data.email\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                        <label>Morada</label>\n                        <input type=\"text\" ng-model=\"$ctrl.user.address\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo()\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.user.$response.data.address\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n                    <div layout=\"row\" class=\"md-block dual-input\">\n                        <md-input-container class=\"md-block\">\n                            <label>Código Postal</label>\n                            <input type=\"text\" ng-model=\"$ctrl.user.zipCode\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo()\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.user.$response.data.zip_code\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Localidade</label>\n                            <input type=\"text\" ng-model=\"$ctrl.user.location\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo()\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.user.$response.data.location\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n                    <div layout=\"row\" class=\"md-block dual-input\">\n                        <md-input-container class=\"md-block\">\n                            <label>Telemóvel</label>\n                            <input type=\"text\" ng-model=\"$ctrl.user.cellphone\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo()\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.user.$response.data.cellphone\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n                    <div layout=\"row\" class=\"md-block dual-input\">\n                        <md-input-container class=\"md-block\">\n                            <label>Nº CC</label>\n                            <input type=\"text\" ng-model=\"$ctrl.user.cc\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo()\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.user.$response.data.cc\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Nº Contribuinte</label>\n                            <input type=\"text\" ng-model=\"$ctrl.user.nif\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo()\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.user.$response.data.nif\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n                    <md-input-container class=\"md-block\">\n                        <label>Data de nascimento</label>\n                        <input type=\"date\" ng-model=\"$ctrl.user.birthday\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo()\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.user.$response.data.birthday\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n                </form>\n            </md-card-content>\n        </md-card>\n        <br> <br>\n        <div flex=\"50\">\n            <md-card>\n                <md-card-content>\n                    <form ng-submit=\"$ctrl.changePass()\">\n                        <h1 class=\"text-center text-fade\">Interesses Pessoais</h1>\n                        <br> <br>\n                        <div ng-repeat=\"cat in $ctrl.eventCategories\">\n                            <md-checkbox ng-model=\"cat.isChecked\" ng-change=\"$ctrl.changeUserCategory(cat)\" cg-busy=\"cat.$userInterests[0].$promise\">\n                                {{::cat.name}}\n                            </md-checkbox>\n                        </div>\n                    </form>\n                </md-card-content>\n            </md-card>\n            <md-card>\n                <md-card-content>\n                    <form ng-submit=\"$ctrl.changePass()\">\n                        <h1 class=\"text-center text-fade\">Alterar palavra-passe</h1>\n                        <br> <br>\n                        <md-input-container class=\"md-block\">\n                            <label>Palavra-passe</label>\n                            <input type=\"password\" ng-model=\"$ctrl.user.password\" minlength=\"3\">\n                        </md-input-container>\n                        <md-input-container class=\"md-block\">\n                            <label>Confirmar palavra-passe</label>\n                            <input type=\"password\" ng-model=\"$ctrl.user.confirm_password\">\n                        </md-input-container>\n\n                        <div layout=\"row\" layout-align=\"center\">\n                            <input type=\"submit\" class=\"md-button md-raised md-accent\" value=\"Alterar\">\n                        </div>\n                    </form>\n                </md-card-content>\n            </md-card>\n        </div>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/users/memberDetails/memberDetails.html","<md-card style=\"overflow: auto\">\n    <md-card-content cg-busy=\"$ctrl.member.$promise\">\n\n        <form ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 100, \'blur\': 0}, updateOnDefault: true}\">\n\n\n            <div layout=\"row\" layout-align=\"end center\">\n                <md-button class=\"md-raised md-accent\" ng-disabled=\"!$ctrl.member.$dirty().length\" ng-click=\"$ctrl.save()\">Guardar\n                </md-button>\n            </div>\n            <br>\n            <div layout=\"column\" layout-gt-xs=\"row\" layout-margin>\n                <div flex-gt-xs=\"50\">\n\n                    <md-input-container class=\"md-block\">\n                        <label>ID associado</label>\n                        <input type=\"text\" ng-model=\"$ctrl.member.memberId\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'memberId\')\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.member.$response.data.member_id\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                    <div layout=\"row\">\n                        <md-input-container flex>\n                            <label>Tipo de associado</label>\n                            <md-select disabled=\"disabled\" ng-model=\"$ctrl.member.type\">\n                                <md-option ng-value=\"type.id\" ng-repeat=\"type in $ctrl.userTypes\">\n                                    {{::type.name}}\n                                </md-option>\n                            </md-select>\n                        </md-input-container>\n                        <md-input-container flex>\n                            <label>Estado</label>\n                            <md-select ng-model=\"$ctrl.member.state\" ng-change=\"$ctrl.changeInfo(\'state\')\">\n                                <md-option value=\"ACTIVE\">Activo</md-option>\n                                <md-option value=\"NO_CARD\">Cartão Anulado</md-option>\n                                <md-option value=\"NO_ADDRESS\">Sem Morada</md-option>\n                                <md-option value=\"EXCLUDED\">Excluído</md-option>\n                                <md-option value=\"DECEASED\">Falecido</md-option>\n                            </md-select>\n                        </md-input-container>\n                    </div>\n\n                    <div layout=\"row\">\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Capital</label>\n                            <input type=\"text\" ng-model=\"$ctrl.member.initialContribution\" disabled=\"disabled\">\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Joia</label>\n                            <input type=\"text\" value=\"{{$ctrl.member.$_(\'gems\') | map: \'price\' | first}}\" disabled=\"disabled\">\n                        </md-input-container>\n                    </div>\n\n\n                    <md-input-container class=\"md-block\">\n                        <label>Último Período</label>\n                        <input type=\"text\" ng-model=\"$ctrl.member.lastPaidPeriod\" disabled=\"disabled\">\n                    </md-input-container>\n\n\n                    <md-input-container class=\"md-block\">\n                        <label>Nº CC</label>\n                        <input type=\"text\" ng-model=\"$ctrl.member.cc\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'cc\')\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.member.$response.data.cc\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                    <md-input-container class=\"md-block\" flex>\n                        <label>Nº Contribuinte</label>\n                        <input type=\"text\" ng-model=\"$ctrl.member.nif\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'nif\')\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.member.$response.data.nif\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n\n                    <div layout=\"row\">\n                        <div flex=\"50\" layout=\"row\" layout-align=\"start start\">\n                            <md-input-container>\n                                <label>Data de admissão</label>\n                                <input type=\"date\" ng-disabled=\"!$ctrl.isUnlocked\" ng-model=\"$ctrl.member.admissionDate\">\n                                <md-icon ng-if=\"!$ctrl.isUnlocked && $root.me.type == \'ACCOUNTANT\'\" ng-click=\"$ctrl.unlockEditing()\" style=\"cursor: pointer\">lock\n                                </md-icon>\n                                <md-icon ng-if=\"$ctrl.isUnlocked\">lock_open</md-icon>\n                            </md-input-container>\n                        </div>\n                        <div flex=\"50\">\n                            <md-input-container>\n                                <label>Data de demissão</label>\n                                <input type=\"date\" ng-model=\"$ctrl.member.demissionDate\">\n                            </md-input-container>\n                        </div>\n                    </div>\n\n                </div>\n                <div flex-gt-xs=\"50\">\n\n                    <div layout=\"row\" class=\"md-block dual-input\">\n                        <md-input-container class=\"md-block\">\n                            <label>Email Contacto</label> <input type=\"email\" ng-model=\"$ctrl.member.contactEmail\" ng-change=\"$ctrl.changeInfo(\'contactEmail\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.member.$response.data.contactEmail\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\">\n                            <label>Email Login</label> <input type=\"email\" ng-model=\"$ctrl.member.email\" ng-change=\"$ctrl.changeInfo(\'email\')\" disabled=\"disabled\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.member.$response.data.email\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n\n                    <div layout=\"row\">\n                        <md-input-container class=\"md-block\" flex=\"20\">\n                            <label>Tit.</label>\n                            <input type=\"text\" ng-model=\"$ctrl.member.title\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'title\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.member.$response.data.title\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Nome</label>\n                            <input type=\"text\" ng-model=\"$ctrl.member.name\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'name\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.member.$response.data.name\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <md-input-container class=\"md-block\">\n                        <label>Morada</label>\n                        <textarea type=\"text\" ng-model=\"$ctrl.member.address\" rows=\"2\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'address\')\"></textarea>\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.member.$response.data.address\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                    <div layout=\"row\" class=\"md-block dual-input\">\n                        <md-input-container class=\"md-block\">\n                            <label>Código Postal</label>\n                            <input type=\"text\" ng-model=\"$ctrl.member.zipCode\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'zipCode\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.member.$response.data.zip_code\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Localidade</label>\n                            <input type=\"text\" ng-model=\"$ctrl.member.location\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'location\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.member.$response.data.location\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" class=\"md-block dual-input\">\n\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Telefone</label>\n                            <input type=\"text\" ng-model=\"$ctrl.member.phone\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'phone\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.member.$response.data.phone\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>Telemóvel</label>\n                            <input type=\"text\" ng-model=\"$ctrl.member.cellphone\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'cellphone\')\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in $ctrl.member.$response.data.cellphone\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                    </div>\n\n\n                    <!-- <md-input-container class=\"md-block\" >\n                         <label>Pessoa a contactar</label>\n                         <input type=\"text\" ng-model=\"$ctrl.member.groupContactPerson\" minlength=\"3\"\n                         ng-model-options=\"{\'*\': \'$inherit\'}\"\n                         ng-change=\"$ctrl.changeInfo(\'groupContactPerson\')\"/>\n                         <div ng-messages>\n                         <div ng-repeat=\"message in $ctrl.member.$response.data.group_contact_person\">\n                         {{message}}\n                         </div>\n                         </div>\n                         </md-input-container>\n\n\n                         <md-input-container class=\"md-block\" >\n                         <label>Data de nascimento</label>\n                         <input type=\"date\" ng-model=\"$ctrl.member.birthday\" minlength=\"3\"\n                         ng-model-options=\"{\'*\': \'$inherit\'}\"\n                         ng-change=\"$ctrl.changeInfo(\'birthday\')\"/>\n                         <div ng-messages>\n                         <div ng-repeat=\"message in $ctrl.member.$response.data.birthday\">\n                         {{message}}\n                         </div>\n                         </div>\n                         </md-input-container> -->\n\n                    <md-input-container class=\"md-block\">\n                        <label>Observações</label>\n                        <textarea ng-model=\"$ctrl.member.notes\" rows=\"3\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo(\'notes\')\"></textarea>\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.member.$response.notes\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                </div>\n\n            </div>\n        </form>\n\n\n    </md-card-content>\n</md-card>\n");
$templateCache.put("app/components/users/membersList/membersList.html","<md-content flex ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\">\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Associados</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\" ui-sref=\"marketeers.sendEmail({members: $ctrl.getUserIds()})\" ng-if=\"$root.me.type==\'MARKETEER\'\">\n                <md-icon>mail</md-icon>\n                Email {{$ctrl.members.length}} membros\n            </md-button>\n        </div>\n\n        <div layout=\"column\" layout-align=\"start stretch\" class=\"filters-bar\">\n            <div layout=\"row\">\n                <div layout=\"column\" layout-align=\"center center\">\n                    <md-icon>search</md-icon>\n                </div>\n                <input type=\"text\" flex placeholder=\"Filtrar por nome ou id de sócio\" ng-model=\"$ctrl.memberName\" ng-change=\"$ctrl.updateMembers()\">\n                <!--<div class=\"filter-item\" layout=\"column\" layout-align=\"center start\">\n                    <md-menu md-position-mode=\"target-right target\">\n                        <div class=\"\" layout=\"row\" layout-align=\"start center\">\n                            <md-button aria-label=\"Open menu\" class=\"\" ng-click=\"$mdMenu.open($event)\">\n                                <md-icon>today</md-icon>\n                                Data de nascimento\n                            </md-button>\n                        </div>\n                        <md-menu-content width=\"6\" id=\"members-data-menu-content\">\n                            <md-menu-item>\n                                <h2 class=\"text-center\" flex>Introduze um intervalo</h2>\n                            </md-menu-item>\n                            <md-menu-item>\n                                <div layout=\"row\" style=\"padding-top: 20px;\">\n                                    <div layout=\"column\" layout-align=\"center center\" flex=\"50\">\n                                        <h3 style=\"text-align: center\">De</h3>\n                                        <md-input-container>\n                                            <input type=\"datetime\" placeholder=\"aaaa-mm-dd\" md-menu-align-target\n                                                   ng-model=\"$ctrl.deBirthday\"/>\n                                        </md-input-container>\n                                    </div>\n                                    <div layout=\"column\" layout-align=\"center center\" flex=\"50\">\n                                        <h3 style=\"text-align: center\">Até</h3>\n                                        <md-input-container>\n                                            <input type=\"datetime\" placeholder=\"aaaa-mm-dd\" md-menu-align-target\n                                                   ng-model=\"$ctrl.ateBirthday\"/>\n                                        </md-input-container>\n                                    </div>\n                                </div>\n                            </md-menu-item>\n                            <div layout=\"row\" layout-align=\"center center\" cg-busy=\"$ctrl.members.$promise\">\n                                <md-button class=\"md-button md-raised md-accent\" ng-click=\"$ctrl.updateMembers()\">\n                                    Aplicar\n                                </md-button>\n                            </div>\n                        </md-menu-content>\n                    </md-menu>\n                </div>\n                <div class=\"filter-item\" layout=\"column\" layout-align=\"center start\">\n                    <md-menu md-position-mode=\"target-right target\">\n                        <div class=\"\" layout=\"row\" layout-align=\"start center\">\n                            <md-button aria-label=\"Open menu\" class=\"\" ng-click=\"$mdMenu.open($event)\">\n                                <md-icon>today</md-icon>\n                                Data de admissao\n                            </md-button>\n                        </div>\n                        <md-menu-content width=\"6\" id=\"members-data-menu-content\">\n                            <md-menu-item>\n                                <h2 class=\"text-center\" flex>Introduze um intervalo</h2>\n                            </md-menu-item>\n                            <md-menu-item>\n                                <div layout=\"row\" style=\"padding-top: 20px;\">\n                                    <div layout=\"column\" layout-align=\"center center\" flex=\"50\">\n                                        <h3>De</h3>\n                                        <md-input-container>\n                                            <input type=\"datetime\" placeholder=\"aaaa-mm-dd\" md-menu-align-target\n                                                   ng-model=\"$ctrl.deAdmission\"/>\n                                        </md-input-container>\n                                    </div>\n                                    <div layout=\"column\" layout-align=\"center center\" flex=\"50\">\n                                        <h3>Até</h3>\n                                        <md-input-container>\n                                            <input type=\"datetime\" placeholder=\"aaaa-mm-dd\" md-menu-align-target\n                                                   ng-model=\"$ctrl.ateAdmission\"/>\n                                        </md-input-container>\n                                    </div>\n                                </div>\n                            </md-menu-item>\n                            <div layout=\"row\" layout-align=\"center center\" cg-busy=\"$ctrl.members.$promise\">\n                                <md-button class=\"md-button md-raised md-accent\" ng-click=\"$ctrl.updateMembers()\">\n                                    Aplicar\n                                </md-button>\n                            </div>\n                        </md-menu-content>\n                    </md-menu>\n                </div>\n                -->\n            </div>\n            <div layout=\"row\">\n                <!--<div class=\"filter-item\" layout=\"column\" layout-align=\"center start\">\n                    <md-select ng-model=\"$ctrl.memberGender\" placeholder=\"Genero\" class=\"md-no-underline\"\n                               ng-change=\"$ctrl.updateMembers()\">\n                        <md-option value=\"\">Genero</md-option>\n                        <md-option value=\"FEMALE\">Femininio</md-option>\n                        <md-option value=\"MALE\">Masculino</md-option>\n                    </md-select>\n                </div>-->\n\n                <div class=\"filter-item\" layout=\"column\" layout-align=\"center start\">\n                    <md-select ng-model=\"$ctrl.associationStateFilter\" placeholder=\"Estado quotas\" class=\"md-no-underline\" ng-change=\"$ctrl.updateMembers()\">\n                        <md-option value=\"\">Estado quotas</md-option>\n                        <md-option value=\"REGULAR\">Pago</md-option>\n                        <md-option value=\"PENDING\">Pendente</md-option>\n                        <md-option value=\"UNKNOWN\">Desconhecido</md-option>\n                    </md-select>\n                </div>\n\n                <div class=\"filter-item\">\n                    <md-switch ng-model=\"$ctrl.showOnlyMembersWithNotes\" ng-change=\"$ctrl.updateMembers();\">\n                        Membros com observações\n                    </md-switch>\n                </div>\n\n                <div class=\"filter-item\">\n                    <md-switch ng-model=\"$ctrl.showOnlyMembersWithoutMemberId\" ng-change=\"$ctrl.updateMembers();\">\n                        Membros sem Id de sócio\n                    </md-switch>\n                </div>\n            </div>\n        </div>\n\n\n        <table style=\"width: 100%\">\n            <tr>\n                <th width=\"1%\">&nbsp;</th>\n                <th align=\"left\">Associado</th>\n                <!-- <th align=\"center\">Quotas</th> -->\n                <th>&nbsp;</th>\n            </tr>\n            <tr ng-repeat=\"member in $ctrl.members\">\n                <td align=\"right\" style=\"padding-right: 10px\">\n                    <span ng-if=\"member.memberId\">#{{::member.memberId}}</span>\n                </td>\n                <td>\n                    <a ui-sref=\"^.member.details({id: member.id})\">{{::member.name}}</a>\n                </td>\n                <td align=\"center\" class=\"text-fade\">\n                    <span ng-if=\"member.quotasState == \'PENDING\'\" class=\"badge badge-warning\">Pendente</span>\n                    <span ng-if=\"member.quotasState == \'UNKNOWN\'\" class=\"badge\">Desconhecido</span>\n                    <span ng-if=\"member.quotasState == \'REGULAR\'\" class=\"badge badge-success\">Pago</span>\n                </td>\n                <td width=\"1%\" class=\"notes-td\" ng-class=\"{\'active\': notesActive}\" click-outside=\"notesActive = false\">\n                    <md-button class=\"md-icon-button text-fade\" ng-click=\"notesActive = !notesActive\">\n                        <md-icon ng-class=\"{\'text-accent\': member.notes}\">speaker_notes</md-icon>\n                    </md-button>\n                    <textarea ng-model=\"member.notes\" ng-change=\"member.$save([\'notes\'])\" ng-model-options=\"{\'*\': \'$inherit\'}\" class=\"notes-area\" ng-class=\"{\'active\': notesActive}\" md-whiteframe=\"4\" placeholder=\"Observações\"></textarea>\n                </td>\n            </tr>\n        </table>\n\n        <h1 class=\"text-center text-fade\" ng-if=\"$ctrl.members.length == 0\">Nenhum associado encontrado</h1>\n\n        <br><br>\n        <div layout=\"column\">\n            <div layout=\"row\" layout-align=\"center center\">\n                <small class=\"text-fade\">\n                    A mostrar {{$ctrl.members.length}} de {{$ctrl.members.$totalCount}}\n                </small>\n            </div>\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-button ng-click=\"$ctrl.loadMore()\" ng-if=\"$ctrl.members.$totalCount > $ctrl.members.length\" class=\"md-raised\">\n                    Carregar mais\n                </md-button>\n            </div>\n        </div>\n\n    </div>\n</md-content>\n\n\n<md-fab-speed-dial md-direction=\"up\" class=\"md-fling md-fab-bottom-right\" md-open=\"isOpen\" ng-init=\"isOpen=false\">\n    <md-fab-trigger>\n        <md-button aria-label=\"Add...\" class=\"md-fab\" ui-sref=\"^.newMember()\">\n            <md-icon>add</md-icon>\n        </md-button>\n    </md-fab-trigger>\n</md-fab-speed-dial>\n");}]);
'use strict';

var cov_k9zmydl7u = function () {
    var path = '/home/lobo/repos/coliseu-app/src/routes.js',
        hash = 'a53d9841f1050caa6362a96f545960fc7b5bb029',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/routes.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 3,
                    column: 26
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 4
                },
                end: {
                    line: 7,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 4
                },
                end: {
                    line: 8,
                    column: 38
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 4
                },
                end: {
                    line: 187,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 35,
                    column: 50
                },
                end: {
                    line: 37,
                    column: 27
                }
            },
            '5': {
                start: {
                    line: 36,
                    column: 20
                },
                end: {
                    line: 36,
                    column: 93
                }
            },
            '6': {
                start: {
                    line: 36,
                    column: 78
                },
                end: {
                    line: 36,
                    column: 82
                }
            },
            '7': {
                start: {
                    line: 44,
                    column: 50
                },
                end: {
                    line: 46,
                    column: 27
                }
            },
            '8': {
                start: {
                    line: 45,
                    column: 20
                },
                end: {
                    line: 45,
                    column: 93
                }
            },
            '9': {
                start: {
                    line: 45,
                    column: 78
                },
                end: {
                    line: 45,
                    column: 82
                }
            },
            '10': {
                start: {
                    line: 77,
                    column: 41
                },
                end: {
                    line: 80,
                    column: 55
                }
            },
            '11': {
                start: {
                    line: 80,
                    column: 38
                },
                end: {
                    line: 80,
                    column: 45
                }
            },
            '12': {
                start: {
                    line: 87,
                    column: 41
                },
                end: {
                    line: 89,
                    column: 55
                }
            },
            '13': {
                start: {
                    line: 89,
                    column: 38
                },
                end: {
                    line: 89,
                    column: 45
                }
            },
            '14': {
                start: {
                    line: 101,
                    column: 54
                },
                end: {
                    line: 101,
                    column: 122
                }
            },
            '15': {
                start: {
                    line: 101,
                    column: 106
                },
                end: {
                    line: 101,
                    column: 112
                }
            },
            '16': {
                start: {
                    line: 108,
                    column: 62
                },
                end: {
                    line: 111,
                    column: 26
                }
            },
            '17': {
                start: {
                    line: 109,
                    column: 32
                },
                end: {
                    line: 109,
                    column: 38
                }
            },
            '18': {
                start: {
                    line: 110,
                    column: 32
                },
                end: {
                    line: 110,
                    column: 53
                }
            },
            '19': {
                start: {
                    line: 140,
                    column: 44
                },
                end: {
                    line: 143,
                    column: 61
                }
            },
            '20': {
                start: {
                    line: 143,
                    column: 41
                },
                end: {
                    line: 143,
                    column: 51
                }
            },
            '21': {
                start: {
                    line: 144,
                    column: 45
                },
                end: {
                    line: 147,
                    column: 63
                }
            },
            '22': {
                start: {
                    line: 147,
                    column: 42
                },
                end: {
                    line: 147,
                    column: 53
                }
            },
            '23': {
                start: {
                    line: 154,
                    column: 41
                },
                end: {
                    line: 154,
                    column: 65
                }
            },
            '24': {
                start: {
                    line: 161,
                    column: 43
                },
                end: {
                    line: 161,
                    column: 63
                }
            },
            '25': {
                start: {
                    line: 178,
                    column: 38
                },
                end: {
                    line: 178,
                    column: 82
                }
            },
            '26': {
                start: {
                    line: 178,
                    column: 68
                },
                end: {
                    line: 178,
                    column: 72
                }
            },
            '27': {
                start: {
                    line: 185,
                    column: 38
                },
                end: {
                    line: 185,
                    column: 82
                }
            },
            '28': {
                start: {
                    line: 185,
                    column: 68
                },
                end: {
                    line: 185,
                    column: 72
                }
            }
        },
        fnMap: {
            '0': {
                name: 'routesConfig',
                decl: {
                    start: {
                        line: 6,
                        column: 9
                    },
                    end: {
                        line: 6,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 77
                    },
                    end: {
                        line: 188,
                        column: 1
                    }
                },
                line: 6
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 35,
                        column: 22
                    },
                    end: {
                        line: 35,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 50
                    },
                    end: {
                        line: 37,
                        column: 27
                    }
                },
                line: 35
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 35,
                        column: 70
                    },
                    end: {
                        line: 35,
                        column: 71
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 76
                    },
                    end: {
                        line: 37,
                        column: 17
                    }
                },
                line: 35
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 36,
                        column: 68
                    },
                    end: {
                        line: 36,
                        column: 69
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 78
                    },
                    end: {
                        line: 36,
                        column: 82
                    }
                },
                line: 36
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 44,
                        column: 22
                    },
                    end: {
                        line: 44,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 44,
                        column: 50
                    },
                    end: {
                        line: 46,
                        column: 27
                    }
                },
                line: 44
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 44,
                        column: 70
                    },
                    end: {
                        line: 44,
                        column: 71
                    }
                },
                loc: {
                    start: {
                        line: 44,
                        column: 76
                    },
                    end: {
                        line: 46,
                        column: 17
                    }
                },
                line: 44
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 45,
                        column: 68
                    },
                    end: {
                        line: 45,
                        column: 69
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 78
                    },
                    end: {
                        line: 45,
                        column: 82
                    }
                },
                line: 45
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 77,
                        column: 25
                    },
                    end: {
                        line: 77,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 77,
                        column: 41
                    },
                    end: {
                        line: 80,
                        column: 55
                    }
                },
                line: 77
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 80,
                        column: 25
                    },
                    end: {
                        line: 80,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 80,
                        column: 38
                    },
                    end: {
                        line: 80,
                        column: 45
                    }
                },
                line: 80
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 87,
                        column: 25
                    },
                    end: {
                        line: 87,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 87,
                        column: 41
                    },
                    end: {
                        line: 89,
                        column: 55
                    }
                },
                line: 87
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 89,
                        column: 25
                    },
                    end: {
                        line: 89,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 89,
                        column: 38
                    },
                    end: {
                        line: 89,
                        column: 45
                    }
                },
                line: 89
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 101,
                        column: 24
                    },
                    end: {
                        line: 101,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 101,
                        column: 54
                    },
                    end: {
                        line: 101,
                        column: 122
                    }
                },
                line: 101
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 101,
                        column: 94
                    },
                    end: {
                        line: 101,
                        column: 95
                    }
                },
                loc: {
                    start: {
                        line: 101,
                        column: 106
                    },
                    end: {
                        line: 101,
                        column: 112
                    }
                },
                line: 101
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 108,
                        column: 24
                    },
                    end: {
                        line: 108,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 108,
                        column: 62
                    },
                    end: {
                        line: 111,
                        column: 26
                    }
                },
                line: 108
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 109,
                        column: 20
                    },
                    end: {
                        line: 109,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 109,
                        column: 32
                    },
                    end: {
                        line: 109,
                        column: 38
                    }
                },
                line: 109
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 110,
                        column: 20
                    },
                    end: {
                        line: 110,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 110,
                        column: 32
                    },
                    end: {
                        line: 110,
                        column: 53
                    }
                },
                line: 110
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 140,
                        column: 28
                    },
                    end: {
                        line: 140,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 140,
                        column: 44
                    },
                    end: {
                        line: 143,
                        column: 61
                    }
                },
                line: 140
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 143,
                        column: 25
                    },
                    end: {
                        line: 143,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 143,
                        column: 41
                    },
                    end: {
                        line: 143,
                        column: 51
                    }
                },
                line: 143
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 144,
                        column: 29
                    },
                    end: {
                        line: 144,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 144,
                        column: 45
                    },
                    end: {
                        line: 147,
                        column: 63
                    }
                },
                line: 144
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 147,
                        column: 25
                    },
                    end: {
                        line: 147,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 147,
                        column: 42
                    },
                    end: {
                        line: 147,
                        column: 53
                    }
                },
                line: 147
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 154,
                        column: 25
                    },
                    end: {
                        line: 154,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 154,
                        column: 41
                    },
                    end: {
                        line: 154,
                        column: 65
                    }
                },
                line: 154
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 161,
                        column: 25
                    },
                    end: {
                        line: 161,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 161,
                        column: 43
                    },
                    end: {
                        line: 161,
                        column: 63
                    }
                },
                line: 161
            },
            '22': {
                name: '(anonymous_22)',
                decl: {
                    start: {
                        line: 178,
                        column: 22
                    },
                    end: {
                        line: 178,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 178,
                        column: 38
                    },
                    end: {
                        line: 178,
                        column: 82
                    }
                },
                line: 178
            },
            '23': {
                name: '(anonymous_23)',
                decl: {
                    start: {
                        line: 178,
                        column: 58
                    },
                    end: {
                        line: 178,
                        column: 59
                    }
                },
                loc: {
                    start: {
                        line: 178,
                        column: 68
                    },
                    end: {
                        line: 178,
                        column: 72
                    }
                },
                line: 178
            },
            '24': {
                name: '(anonymous_24)',
                decl: {
                    start: {
                        line: 185,
                        column: 22
                    },
                    end: {
                        line: 185,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 185,
                        column: 38
                    },
                    end: {
                        line: 185,
                        column: 82
                    }
                },
                line: 185
            },
            '25': {
                name: '(anonymous_25)',
                decl: {
                    start: {
                        line: 185,
                        column: 58
                    },
                    end: {
                        line: 185,
                        column: 59
                    }
                },
                loc: {
                    start: {
                        line: 185,
                        column: 68
                    },
                    end: {
                        line: 185,
                        column: 72
                    }
                },
                line: 185
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_k9zmydl7u.s[0]++;
angular.module('app').config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    cov_k9zmydl7u.f[0]++;
    cov_k9zmydl7u.s[1]++;

    $locationProvider.html5Mode(true).hashPrefix('!');
    cov_k9zmydl7u.s[2]++;
    $urlRouterProvider.otherwise('/');

    cov_k9zmydl7u.s[3]++;
    $stateProvider.state('marketeers', {
        url: '/marketing',
        templateUrl: 'app/components/admin/layout.marketeers.html'
    }).state('accountants', {
        url: '/contabilidade',
        templateUrl: 'app/components/admin/layout.accountants.html'
    }).state('login', {
        url: '/login',
        templateUrl: 'app/components/auth/views/auth.login.view.html',
        controller: 'AuthLoginController',
        controllerAs: 'vm'
    }).state('logout', {
        url: '/logout',
        template: '<div></div>',
        controller: 'AuthLogoutController',
        controllerAs: 'vm'
    }).state('profile', {
        url: '/perfil',
        template: '<edit-profile user="$resolve.user" flex layout="column"/>',
        resolve: {
            user: ["$rootScope", "UsersTable", function user($rootScope, UsersTable) {
                cov_k9zmydl7u.f[1]++;
                cov_k9zmydl7u.s[4]++;
                return $rootScope.me.$then(function () {
                    cov_k9zmydl7u.f[2]++;
                    cov_k9zmydl7u.s[5]++;

                    return UsersTable.$find($rootScope.me.id).$then(function (user) {
                        cov_k9zmydl7u.f[3]++;
                        cov_k9zmydl7u.s[6]++;
                        return user;
                    }).$promise;
                }).$promise;
            }]
        }
    }).state('amigos.profile', {
        url: '/perfil',
        template: '<edit-profile user="$resolve.user" flex layout="column"/>',
        resolve: {
            user: ["$rootScope", "UsersTable", function user($rootScope, UsersTable) {
                cov_k9zmydl7u.f[4]++;
                cov_k9zmydl7u.s[7]++;
                return $rootScope.me.$then(function () {
                    cov_k9zmydl7u.f[5]++;
                    cov_k9zmydl7u.s[8]++;

                    return UsersTable.$find($rootScope.me.id).$then(function (user) {
                        cov_k9zmydl7u.f[6]++;
                        cov_k9zmydl7u.s[9]++;
                        return user;
                    }).$promise;
                }).$promise;
            }]
        }
    }).state('forgot', {
        url: '/recuperar_password',
        templateUrl: 'app/components/auth/views/auth.forgot.html',
        controller: 'AuthForgotController',
        controllerAs: 'vm'
    }).state('set_password', {
        url: '/reset_password?token=&email=',
        templateUrl: 'app/components/auth/views/auth.set.password.html',
        controller: 'AuthSetPasswordController',
        controllerAs: 'vm'
    }).state('register', {
        url: '/criar_conta',
        templateUrl: 'app/components/auth/views/auth.register.view.html',
        controller: 'AuthRegisterController',
        controllerAs: 'vm'
    }).state('activate', {
        url: '/activate?token=',
        template: '<div></div>',
        controller: 'AuthActivateController',
        controllerAs: 'vm'
    }).state('marketeers.membersList', {
        url: '/associados',
        template: '<members-list members="$resolve.members" flex layout="column"/>',
        resolve: {
            members: ["UsersTable", function members(UsersTable) {
                cov_k9zmydl7u.f[7]++;
                cov_k9zmydl7u.s[10]++;
                return UsersTable.$search({
                    type__in: 'GROUP,MEMBER',
                    ordering: 'member_id'
                }).$then(function (members) {
                    cov_k9zmydl7u.f[8]++;
                    cov_k9zmydl7u.s[11]++;
                    return members;
                }).$promise;
            }]
        }
    }).state('accountants.membersList', {
        url: '/associados',
        template: '<members-list members="$resolve.members" flex layout="column"/>',
        resolve: {
            members: ["UsersTable", function members(UsersTable) {
                cov_k9zmydl7u.f[9]++;
                cov_k9zmydl7u.s[12]++;
                return UsersTable.$search({
                    ordering: 'member_id'
                }).$then(function (members) {
                    cov_k9zmydl7u.f[10]++;
                    cov_k9zmydl7u.s[13]++;
                    return members;
                }).$promise;
            }]
        }
    }).state('accountants.newMember', {
        url: '/novo-membro?type',
        template: '<new-member-view flex layout="column"/>',
        resolve: {}
    }).state('marketeers.memberDetails', {
        url: '/associado/:id',
        template: '<member-details member="$resolve.member" flex layout="column"/>',
        resolve: {
            member: ["UsersTable", "$stateParams", function member(UsersTable, $stateParams) {
                cov_k9zmydl7u.f[11]++;
                cov_k9zmydl7u.s[14]++;
                return UsersTable.$find($stateParams.id).$then(function (member) {
                    cov_k9zmydl7u.f[12]++;
                    cov_k9zmydl7u.s[15]++;
                    return member;
                }).$promise;
            }]
        }
    }).state('accountants.member', {
        url: '/associado/:id',
        component: 'memberView',
        resolve: {
            member: ["UsersTable", "$stateParams", "$state", function member(UsersTable, $stateParams, $state) {
                cov_k9zmydl7u.f[13]++;
                cov_k9zmydl7u.s[16]++;
                return UsersTable.$find($stateParams.id).$then(function (member) {
                    cov_k9zmydl7u.f[14]++;
                    cov_k9zmydl7u.s[17]++;
                    return member;
                }, function (member) {
                    cov_k9zmydl7u.f[15]++;
                    cov_k9zmydl7u.s[18]++;
                    return $state.go('notfound');
                }).$promise;
            }]
        }
    }).state('accountants.settings', {
        url: '/settings',
        component: 'settingsView',
        resolve: {}
    }).state('accountants.settings.quotas', {
        url: '/quotas-e-joias',
        component: 'quotaSettingsView',
        resolve: {}
    }).state('accountants.member.details', {
        url: '/detalhes',
        template: '<member-details member="$resolve.member" flex layout="column"/>'
    }).state('accountants.member.quotas', {
        url: '/quotas',
        template: '<member-quotas member="$resolve.member" flex layout="column"/>'
    }).state('accountants.member.payments', {
        url: '/pagamentos',
        template: '<member-payments-view member="$resolve.member" flex layout="column"/>'
    }).state('accountants.adminsList', {
        url: '/administradores',
        template: '<admins-list marketeers="$resolve.marketeers" accountants="$resolve.accountants" flex layout="column"/>',
        resolve: {
            marketeers: ["UsersTable", function marketeers(UsersTable) {
                cov_k9zmydl7u.f[16]++;
                cov_k9zmydl7u.s[19]++;
                return UsersTable.$search({
                    type: 'MARKETEER',
                    page_size: 9999
                }).$then(function (marketeers) {
                    cov_k9zmydl7u.f[17]++;
                    cov_k9zmydl7u.s[20]++;
                    return marketeers;
                }).$promise;
            }],
            accountants: ["UsersTable", function accountants(UsersTable) {
                cov_k9zmydl7u.f[18]++;
                cov_k9zmydl7u.s[21]++;
                return UsersTable.$search({
                    type: 'ACCOUNTANT',
                    page_size: 9999
                }).$then(function (accountants) {
                    cov_k9zmydl7u.f[19]++;
                    cov_k9zmydl7u.s[22]++;
                    return accountants;
                }).$promise;
            }]
        }
    }).state('accountants.reportsList', {
        url: '/relatorios',
        template: '<reports-list reports="$resolve.reports" flex layout="column"/>',
        resolve: {
            reports: ["ReportsTable", function reports(ReportsTable) {
                cov_k9zmydl7u.f[20]++;
                cov_k9zmydl7u.s[23]++;
                return ReportsTable.$search({});
            }]
        }
    }).state('marketeers.sendEmail', {
        url: '/enviar-email?members',
        template: '<send-email members="$resolve.members" flex layout="column"/>',
        resolve: {
            members: ["$stateParams", function members($stateParams) {
                cov_k9zmydl7u.f[21]++;
                cov_k9zmydl7u.s[24]++;
                return $stateParams.members;
            }]
        }
    }).state('home', {
        url: '/',
        template: '<home-view categories="$resolve.categories" flex layout="column"/>',
        resolve: {}
    }).state('amigos', {
        url: '/amigo',
        templateUrl: 'app/components/amigos/layout.amigos.html',
        requireAmigo: true
    }).state('amigos.dashboard', {
        url: '/dashboard',
        template: '<dashboard layout="column" flex user="$resolve.user"/>',
        resolve: {
            user: ["$rootScope", function user($rootScope) {
                cov_k9zmydl7u.f[22]++;
                cov_k9zmydl7u.s[25]++;
                return $rootScope.me.$then(function (user) {
                    cov_k9zmydl7u.f[23]++;
                    cov_k9zmydl7u.s[26]++;
                    return user;
                }).$promise;
            }]
        }
    }).state('amigos.pay', {
        url: '/associacao',
        template: '<association-state-view layout="column" flex user="$resolve.user"/>',
        resolve: {
            user: ["$rootScope", function user($rootScope) {
                cov_k9zmydl7u.f[24]++;
                cov_k9zmydl7u.s[27]++;
                return $rootScope.me.$then(function (user) {
                    cov_k9zmydl7u.f[25]++;
                    cov_k9zmydl7u.s[28]++;
                    return user;
                }).$promise;
            }]
        }
    });
}